/* DEPENDANCIES */

// jquery (3.4.1)
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(C,e){"use strict";var t=[],E=C.document,r=Object.getPrototypeOf,s=t.slice,g=t.concat,u=t.push,i=t.indexOf,n={},o=n.toString,v=n.hasOwnProperty,a=v.toString,l=a.call(Object),y={},m=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType},x=function(e){return null!=e&&e===e.window},c={type:!0,src:!0,nonce:!0,noModule:!0};function b(e,t,n){var r,i,o=(n=n||E).createElement("script");if(o.text=e,t)for(r in c)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function w(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[o.call(e)]||"object":typeof e}var f="3.4.1",k=function(e,t){return new k.fn.init(e,t)},p=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;function d(e){var t=!!e&&"length"in e&&e.length,n=w(e);return!m(e)&&!x(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}k.fn=k.prototype={jquery:f,constructor:k,length:0,toArray:function(){return s.call(this)},get:function(e){return null==e?s.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=k.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return k.each(this,e)},map:function(n){return this.pushStack(k.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(s.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:u,sort:t.sort,splice:t.splice},k.extend=k.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||m(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(k.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||k.isPlainObject(n)?n:{},i=!1,a[t]=k.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},k.extend({expando:"jQuery"+(f+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==o.call(e))&&(!(t=r(e))||"function"==typeof(n=v.call(t,"constructor")&&t.constructor)&&a.call(n)===l)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t){b(e,{nonce:t&&t.nonce})},each:function(e,t){var n,r=0;if(d(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},trim:function(e){return null==e?"":(e+"").replace(p,"")},makeArray:function(e,t){var n=t||[];return null!=e&&(d(Object(e))?k.merge(n,"string"==typeof e?[e]:e):u.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:i.call(t,e,n)},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(d(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g.apply([],a)},guid:1,support:y}),"function"==typeof Symbol&&(k.fn[Symbol.iterator]=t[Symbol.iterator]),k.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var h=function(n){var e,d,b,o,i,h,f,g,w,u,l,T,C,a,E,v,s,c,y,k="sizzle"+1*new Date,m=n.document,S=0,r=0,p=ue(),x=ue(),N=ue(),A=ue(),D=function(e,t){return e===t&&(l=!0),0},j={}.hasOwnProperty,t=[],q=t.pop,L=t.push,H=t.push,O=t.slice,P=function(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return-1},R="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",M="[\\x20\\t\\r\\n\\f]",I="(?:\\\\.|[\\w-]|[^\0-\\xa0])+",W="\\["+M+"*("+I+")(?:"+M+"*([*^$|!~]?=)"+M+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+I+"))|)"+M+"*\\]",$=":("+I+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+W+")*)|.*)\\)|)",F=new RegExp(M+"+","g"),B=new RegExp("^"+M+"+|((?:^|[^\\\\])(?:\\\\.)*)"+M+"+$","g"),_=new RegExp("^"+M+"*,"+M+"*"),z=new RegExp("^"+M+"*([>+~]|"+M+")"+M+"*"),U=new RegExp(M+"|>"),X=new RegExp($),V=new RegExp("^"+I+"$"),G={ID:new RegExp("^#("+I+")"),CLASS:new RegExp("^\\.("+I+")"),TAG:new RegExp("^("+I+"|[*])"),ATTR:new RegExp("^"+W),PSEUDO:new RegExp("^"+$),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+M+"*(even|odd|(([+-]|)(\\d*)n|)"+M+"*(?:([+-]|)"+M+"*(\\d+)|))"+M+"*\\)|)","i"),bool:new RegExp("^(?:"+R+")$","i"),needsContext:new RegExp("^"+M+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+M+"*((?:-\\d)?\\d*)"+M+"*\\)|)(?=[^-]|$)","i")},Y=/HTML$/i,Q=/^(?:input|select|textarea|button)$/i,J=/^h\d$/i,K=/^[^{]+\{\s*\[native \w/,Z=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,ee=/[+~]/,te=new RegExp("\\\\([\\da-f]{1,6}"+M+"?|("+M+")|.)","ig"),ne=function(e,t,n){var r="0x"+t-65536;return r!=r||n?t:r<0?String.fromCharCode(r+65536):String.fromCharCode(r>>10|55296,1023&r|56320)},re=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,ie=function(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e},oe=function(){T()},ae=be(function(e){return!0===e.disabled&&"fieldset"===e.nodeName.toLowerCase()},{dir:"parentNode",next:"legend"});try{H.apply(t=O.call(m.childNodes),m.childNodes),t[m.childNodes.length].nodeType}catch(e){H={apply:t.length?function(e,t){L.apply(e,O.call(t))}:function(e,t){var n=e.length,r=0;while(e[n++]=t[r++]);e.length=n-1}}}function se(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&((e?e.ownerDocument||e:m)!==C&&T(e),e=e||C,E)){if(11!==p&&(u=Z.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return n.push(a),n}else if(f&&(a=f.getElementById(i))&&y(e,a)&&a.id===i)return n.push(a),n}else{if(u[2])return H.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&d.getElementsByClassName&&e.getElementsByClassName)return H.apply(n,e.getElementsByClassName(i)),n}if(d.qsa&&!A[t+" "]&&(!v||!v.test(t))&&(1!==p||"object"!==e.nodeName.toLowerCase())){if(c=t,f=e,1===p&&U.test(t)){(s=e.getAttribute("id"))?s=s.replace(re,ie):e.setAttribute("id",s=k),o=(l=h(t)).length;while(o--)l[o]="#"+s+" "+xe(l[o]);c=l.join(","),f=ee.test(t)&&ye(e.parentNode)||e}try{return H.apply(n,f.querySelectorAll(c)),n}catch(e){A(t,!0)}finally{s===k&&e.removeAttribute("id")}}}return g(t.replace(B,"$1"),e,n,r)}function ue(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function le(e){return e[k]=!0,e}function ce(e){var t=C.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function fe(e,t){var n=e.split("|"),r=n.length;while(r--)b.attrHandle[n[r]]=t}function pe(e,t){var n=t&&e,r=n&&1===e.nodeType&&1===t.nodeType&&e.sourceIndex-t.sourceIndex;if(r)return r;if(n)while(n=n.nextSibling)if(n===t)return-1;return e?1:-1}function de(t){return function(e){return"input"===e.nodeName.toLowerCase()&&e.type===t}}function he(n){return function(e){var t=e.nodeName.toLowerCase();return("input"===t||"button"===t)&&e.type===n}}function ge(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&ae(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function ve(a){return le(function(o){return o=+o,le(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function ye(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}for(e in d=se.support={},i=se.isXML=function(e){var t=e.namespaceURI,n=(e.ownerDocument||e).documentElement;return!Y.test(t||n&&n.nodeName||"HTML")},T=se.setDocument=function(e){var t,n,r=e?e.ownerDocument||e:m;return r!==C&&9===r.nodeType&&r.documentElement&&(a=(C=r).documentElement,E=!i(C),m!==C&&(n=C.defaultView)&&n.top!==n&&(n.addEventListener?n.addEventListener("unload",oe,!1):n.attachEvent&&n.attachEvent("onunload",oe)),d.attributes=ce(function(e){return e.className="i",!e.getAttribute("className")}),d.getElementsByTagName=ce(function(e){return e.appendChild(C.createComment("")),!e.getElementsByTagName("*").length}),d.getElementsByClassName=K.test(C.getElementsByClassName),d.getById=ce(function(e){return a.appendChild(e).id=k,!C.getElementsByName||!C.getElementsByName(k).length}),d.getById?(b.filter.ID=function(e){var t=e.replace(te,ne);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&E){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(te,ne);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&E){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=d.getElementsByTagName?function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):d.qsa?t.querySelectorAll(e):void 0}:function(e,t){var n,r=[],i=0,o=t.getElementsByTagName(e);if("*"===e){while(n=o[i++])1===n.nodeType&&r.push(n);return r}return o},b.find.CLASS=d.getElementsByClassName&&function(e,t){if("undefined"!=typeof t.getElementsByClassName&&E)return t.getElementsByClassName(e)},s=[],v=[],(d.qsa=K.test(C.querySelectorAll))&&(ce(function(e){a.appendChild(e).innerHTML="<a id='"+k+"'></a><select id='"+k+"-\r\\' msallowcapture=''><option selected=''></option></select>",e.querySelectorAll("[msallowcapture^='']").length&&v.push("[*^$]="+M+"*(?:''|\"\")"),e.querySelectorAll("[selected]").length||v.push("\\["+M+"*(?:value|"+R+")"),e.querySelectorAll("[id~="+k+"-]").length||v.push("~="),e.querySelectorAll(":checked").length||v.push(":checked"),e.querySelectorAll("a#"+k+"+*").length||v.push(".#.+[+~]")}),ce(function(e){e.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var t=C.createElement("input");t.setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),e.querySelectorAll("[name=d]").length&&v.push("name"+M+"*[*^$|!~]?="),2!==e.querySelectorAll(":enabled").length&&v.push(":enabled",":disabled"),a.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&v.push(":enabled",":disabled"),e.querySelectorAll("*,:x"),v.push(",.*:")})),(d.matchesSelector=K.test(c=a.matches||a.webkitMatchesSelector||a.mozMatchesSelector||a.oMatchesSelector||a.msMatchesSelector))&&ce(function(e){d.disconnectedMatch=c.call(e,"*"),c.call(e,"[s!='']:x"),s.push("!=",$)}),v=v.length&&new RegExp(v.join("|")),s=s.length&&new RegExp(s.join("|")),t=K.test(a.compareDocumentPosition),y=t||K.test(a.contains)?function(e,t){var n=9===e.nodeType?e.documentElement:e,r=t&&t.parentNode;return e===r||!(!r||1!==r.nodeType||!(n.contains?n.contains(r):e.compareDocumentPosition&&16&e.compareDocumentPosition(r)))}:function(e,t){if(t)while(t=t.parentNode)if(t===e)return!0;return!1},D=t?function(e,t){if(e===t)return l=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)===(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!d.sortDetached&&t.compareDocumentPosition(e)===n?e===C||e.ownerDocument===m&&y(m,e)?-1:t===C||t.ownerDocument===m&&y(m,t)?1:u?P(u,e)-P(u,t):0:4&n?-1:1)}:function(e,t){if(e===t)return l=!0,0;var n,r=0,i=e.parentNode,o=t.parentNode,a=[e],s=[t];if(!i||!o)return e===C?-1:t===C?1:i?-1:o?1:u?P(u,e)-P(u,t):0;if(i===o)return pe(e,t);n=e;while(n=n.parentNode)a.unshift(n);n=t;while(n=n.parentNode)s.unshift(n);while(a[r]===s[r])r++;return r?pe(a[r],s[r]):a[r]===m?-1:s[r]===m?1:0}),C},se.matches=function(e,t){return se(e,null,null,t)},se.matchesSelector=function(e,t){if((e.ownerDocument||e)!==C&&T(e),d.matchesSelector&&E&&!A[t+" "]&&(!s||!s.test(t))&&(!v||!v.test(t)))try{var n=c.call(e,t);if(n||d.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){A(t,!0)}return 0<se(t,C,null,[e]).length},se.contains=function(e,t){return(e.ownerDocument||e)!==C&&T(e),y(e,t)},se.attr=function(e,t){(e.ownerDocument||e)!==C&&T(e);var n=b.attrHandle[t.toLowerCase()],r=n&&j.call(b.attrHandle,t.toLowerCase())?n(e,t,!E):void 0;return void 0!==r?r:d.attributes||!E?e.getAttribute(t):(r=e.getAttributeNode(t))&&r.specified?r.value:null},se.escape=function(e){return(e+"").replace(re,ie)},se.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},se.uniqueSort=function(e){var t,n=[],r=0,i=0;if(l=!d.detectDuplicates,u=!d.sortStable&&e.slice(0),e.sort(D),l){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)e.splice(n[r],1)}return u=null,e},o=se.getText=function(e){var t,n="",r=0,i=e.nodeType;if(i){if(1===i||9===i||11===i){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=o(e)}else if(3===i||4===i)return e.nodeValue}else while(t=e[r++])n+=o(t);return n},(b=se.selectors={cacheLength:50,createPseudo:le,match:G,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(te,ne),e[3]=(e[3]||e[4]||e[5]||"").replace(te,ne),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||se.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&se.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return G.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&X.test(n)&&(t=h(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(te,ne).toLowerCase();return"*"===e?function(){return!0}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=p[e+" "];return t||(t=new RegExp("(^|"+M+")"+e+"("+M+"|$)"))&&p(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=se.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace(F," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(h,e,t,g,v){var y="nth"!==h.slice(0,3),m="last"!==h.slice(-4),x="of-type"===e;return 1===g&&0===v?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u,l=y!==m?"nextSibling":"previousSibling",c=e.parentNode,f=x&&e.nodeName.toLowerCase(),p=!n&&!x,d=!1;if(c){if(y){while(l){a=e;while(a=a[l])if(x?a.nodeName.toLowerCase()===f:1===a.nodeType)return!1;u=l="only"===h&&!u&&"nextSibling"}return!0}if(u=[m?c.firstChild:c.lastChild],m&&p){d=(s=(r=(i=(o=(a=c)[k]||(a[k]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]||[])[0]===S&&r[1])&&r[2],a=s&&c.childNodes[s];while(a=++s&&a&&a[l]||(d=s=0)||u.pop())if(1===a.nodeType&&++d&&a===e){i[h]=[S,s,d];break}}else if(p&&(d=s=(r=(i=(o=(a=e)[k]||(a[k]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]||[])[0]===S&&r[1]),!1===d)while(a=++s&&a&&a[l]||(d=s=0)||u.pop())if((x?a.nodeName.toLowerCase()===f:1===a.nodeType)&&++d&&(p&&((i=(o=a[k]||(a[k]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]=[S,d]),a===e))break;return(d-=v)===g||d%g==0&&0<=d/g}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||se.error("unsupported pseudo: "+e);return a[k]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?le(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=P(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:le(function(e){var r=[],i=[],s=f(e.replace(B,"$1"));return s[k]?le(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:le(function(t){return function(e){return 0<se(t,e).length}}),contains:le(function(t){return t=t.replace(te,ne),function(e){return-1<(e.textContent||o(e)).indexOf(t)}}),lang:le(function(n){return V.test(n||"")||se.error("unsupported lang: "+n),n=n.replace(te,ne).toLowerCase(),function(e){var t;do{if(t=E?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=n.location&&n.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===a},focus:function(e){return e===C.activeElement&&(!C.hasFocus||C.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:ge(!1),disabled:ge(!0),checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return J.test(e.nodeName)},input:function(e){return Q.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},text:function(e){var t;return"input"===e.nodeName.toLowerCase()&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:ve(function(){return[0]}),last:ve(function(e,t){return[t-1]}),eq:ve(function(e,t,n){return[n<0?n+t:n]}),even:ve(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:ve(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:ve(function(e,t,n){for(var r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:ve(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=de(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=he(e);function me(){}function xe(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function be(s,e,t){var u=e.dir,l=e.next,c=l||u,f=t&&"parentNode"===c,p=r++;return e.first?function(e,t,n){while(e=e[u])if(1===e.nodeType||f)return s(e,t,n);return!1}:function(e,t,n){var r,i,o,a=[S,p];if(n){while(e=e[u])if((1===e.nodeType||f)&&s(e,t,n))return!0}else while(e=e[u])if(1===e.nodeType||f)if(i=(o=e[k]||(e[k]={}))[e.uniqueID]||(o[e.uniqueID]={}),l&&l===e.nodeName.toLowerCase())e=e[u]||e;else{if((r=i[c])&&r[0]===S&&r[1]===p)return a[2]=r[2];if((i[c]=a)[2]=s(e,t,n))return!0}return!1}}function we(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Te(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function Ce(d,h,g,v,y,e){return v&&!v[k]&&(v=Ce(v)),y&&!y[k]&&(y=Ce(y,e)),le(function(e,t,n,r){var i,o,a,s=[],u=[],l=t.length,c=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)se(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),f=!d||!e&&h?c:Te(c,s,d,n,r),p=g?y||(e?d:l||v)?[]:t:f;if(g&&g(f,p,n,r),v){i=Te(p,u),v(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(p[u[o]]=!(f[u[o]]=a))}if(e){if(y||d){if(y){i=[],o=p.length;while(o--)(a=p[o])&&i.push(f[o]=a);y(null,p=[],i,r)}o=p.length;while(o--)(a=p[o])&&-1<(i=y?P(e,a):s[o])&&(e[i]=!(t[i]=a))}}else p=Te(p===t?p.splice(l,p.length):p),y?y(null,t,p,r):H.apply(t,p)})}function Ee(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=be(function(e){return e===i},a,!0),l=be(function(e){return-1<P(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!==w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[be(we(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[k]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return Ce(1<s&&we(c),1<s&&xe(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace(B,"$1"),t,s<n&&Ee(e.slice(s,n)),n<r&&Ee(e=e.slice(n)),n<r&&xe(e))}c.push(t)}return we(c)}return me.prototype=b.filters=b.pseudos,b.setFilters=new me,h=se.tokenize=function(e,t){var n,r,i,o,a,s,u,l=x[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=_.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=z.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(B," ")}),a=a.slice(n.length)),b.filter)!(r=G[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?se.error(e):x(e,s).slice(0)},f=se.compile=function(e,t){var n,v,y,m,x,r,i=[],o=[],a=N[e+" "];if(!a){t||(t=h(e)),n=t.length;while(n--)(a=Ee(t[n]))[k]?i.push(a):o.push(a);(a=N(e,(v=o,m=0<(y=i).length,x=0<v.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=S+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t===C||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument===C||(T(o),n=!E);while(s=v[a++])if(s(o,t||C,n)){r.push(o);break}i&&(S=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=y[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=q.call(r));f=Te(f)}H.apply(r,f),i&&!e&&0<f.length&&1<u+y.length&&se.uniqueSort(r)}return i&&(S=h,w=p),c},m?le(r):r))).selector=e}return a},g=se.select=function(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&h(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&E&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(te,ne),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=G.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(te,ne),ee.test(o[0].type)&&ye(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&xe(o)))return H.apply(n,r),n;break}}}return(l||f(e,c))(r,t,!E,n,!t||ee.test(e)&&ye(t.parentNode)||t),n},d.sortStable=k.split("").sort(D).join("")===k,d.detectDuplicates=!!l,T(),d.sortDetached=ce(function(e){return 1&e.compareDocumentPosition(C.createElement("fieldset"))}),ce(function(e){return e.innerHTML="<a href='#'></a>","#"===e.firstChild.getAttribute("href")})||fe("type|href|height|width",function(e,t,n){if(!n)return e.getAttribute(t,"type"===t.toLowerCase()?1:2)}),d.attributes&&ce(function(e){return e.innerHTML="<input/>",e.firstChild.setAttribute("value",""),""===e.firstChild.getAttribute("value")})||fe("value",function(e,t,n){if(!n&&"input"===e.nodeName.toLowerCase())return e.defaultValue}),ce(function(e){return null==e.getAttribute("disabled")})||fe(R,function(e,t,n){var r;if(!n)return!0===e[t]?t.toLowerCase():(r=e.getAttributeNode(t))&&r.specified?r.value:null}),se}(C);k.find=h,k.expr=h.selectors,k.expr[":"]=k.expr.pseudos,k.uniqueSort=k.unique=h.uniqueSort,k.text=h.getText,k.isXMLDoc=h.isXML,k.contains=h.contains,k.escapeSelector=h.escape;var T=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&k(e).is(n))break;r.push(e)}return r},S=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},N=k.expr.match.needsContext;function A(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}var D=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function j(e,n,r){return m(n)?k.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?k.grep(e,function(e){return e===n!==r}):"string"!=typeof n?k.grep(e,function(e){return-1<i.call(n,e)!==r}):k.filter(n,e,r)}k.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?k.find.matchesSelector(r,e)?[r]:[]:k.find.matches(e,k.grep(t,function(e){return 1===e.nodeType}))},k.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(k(e).filter(function(){for(t=0;t<r;t++)if(k.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)k.find(e,i[t],n);return 1<r?k.uniqueSort(n):n},filter:function(e){return this.pushStack(j(this,e||[],!1))},not:function(e){return this.pushStack(j(this,e||[],!0))},is:function(e){return!!j(this,"string"==typeof e&&N.test(e)?k(e):e||[],!1).length}});var q,L=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(k.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||q,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:L.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof k?t[0]:t,k.merge(this,k.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:E,!0)),D.test(r[1])&&k.isPlainObject(t))for(r in t)m(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=E.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):m(e)?void 0!==n.ready?n.ready(e):e(k):k.makeArray(e,this)}).prototype=k.fn,q=k(E);var H=/^(?:parents|prev(?:Until|All))/,O={children:!0,contents:!0,next:!0,prev:!0};function P(e,t){while((e=e[t])&&1!==e.nodeType);return e}k.fn.extend({has:function(e){var t=k(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(k.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&k(e);if(!N.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&k.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?k.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?i.call(k(e),this[0]):i.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(k.uniqueSort(k.merge(this.get(),k(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),k.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return T(e,"parentNode")},parentsUntil:function(e,t,n){return T(e,"parentNode",n)},next:function(e){return P(e,"nextSibling")},prev:function(e){return P(e,"previousSibling")},nextAll:function(e){return T(e,"nextSibling")},prevAll:function(e){return T(e,"previousSibling")},nextUntil:function(e,t,n){return T(e,"nextSibling",n)},prevUntil:function(e,t,n){return T(e,"previousSibling",n)},siblings:function(e){return S((e.parentNode||{}).firstChild,e)},children:function(e){return S(e.firstChild)},contents:function(e){return"undefined"!=typeof e.contentDocument?e.contentDocument:(A(e,"template")&&(e=e.content||e),k.merge([],e.childNodes))}},function(r,i){k.fn[r]=function(e,t){var n=k.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=k.filter(t,n)),1<this.length&&(O[r]||k.uniqueSort(n),H.test(r)&&n.reverse()),this.pushStack(n)}});var R=/[^\x20\t\r\n\f]+/g;function M(e){return e}function I(e){throw e}function W(e,t,n,r){var i;try{e&&m(i=e.promise)?i.call(e).done(t).fail(n):e&&m(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}k.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},k.each(e.match(R)||[],function(e,t){n[t]=!0}),n):k.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){k.each(e,function(e,t){m(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==w(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return k.each(arguments,function(e,t){var n;while(-1<(n=k.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<k.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},k.extend({Deferred:function(e){var o=[["notify","progress",k.Callbacks("memory"),k.Callbacks("memory"),2],["resolve","done",k.Callbacks("once memory"),k.Callbacks("once memory"),0,"resolved"],["reject","fail",k.Callbacks("once memory"),k.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return k.Deferred(function(r){k.each(o,function(e,t){var n=m(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&m(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,m(t)?s?t.call(e,l(u,o,M,s),l(u,o,I,s)):(u++,t.call(e,l(u,o,M,s),l(u,o,I,s),l(u,o,M,o.notifyWith))):(a!==M&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){k.Deferred.exceptionHook&&k.Deferred.exceptionHook(e,t.stackTrace),u<=i+1&&(a!==I&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(k.Deferred.getStackHook&&(t.stackTrace=k.Deferred.getStackHook()),C.setTimeout(t))}}return k.Deferred(function(e){o[0][3].add(l(0,e,m(r)?r:M,e.notifyWith)),o[1][3].add(l(0,e,m(t)?t:M)),o[2][3].add(l(0,e,m(n)?n:I))}).promise()},promise:function(e){return null!=e?k.extend(e,a):a}},s={};return k.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=s.call(arguments),o=k.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?s.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(W(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||m(i[t]&&i[t].then)))return o.then();while(t--)W(i[t],a(t),o.reject);return o.promise()}});var $=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;k.Deferred.exceptionHook=function(e,t){C.console&&C.console.warn&&e&&$.test(e.name)&&C.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},k.readyException=function(e){C.setTimeout(function(){throw e})};var F=k.Deferred();function B(){E.removeEventListener("DOMContentLoaded",B),C.removeEventListener("load",B),k.ready()}k.fn.ready=function(e){return F.then(e)["catch"](function(e){k.readyException(e)}),this},k.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--k.readyWait:k.isReady)||(k.isReady=!0)!==e&&0<--k.readyWait||F.resolveWith(E,[k])}}),k.ready.then=F.then,"complete"===E.readyState||"loading"!==E.readyState&&!E.documentElement.doScroll?C.setTimeout(k.ready):(E.addEventListener("DOMContentLoaded",B),C.addEventListener("load",B));var _=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===w(n))for(s in i=!0,n)_(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,m(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(k(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},z=/^-ms-/,U=/-([a-z])/g;function X(e,t){return t.toUpperCase()}function V(e){return e.replace(z,"ms-").replace(U,X)}var G=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function Y(){this.expando=k.expando+Y.uid++}Y.uid=1,Y.prototype={cache:function(e){var t=e[this.expando];return t||(t={},G(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[V(t)]=n;else for(r in t)i[V(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][V(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(V):(t=V(t))in r?[t]:t.match(R)||[]).length;while(n--)delete r[t[n]]}(void 0===t||k.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!k.isEmptyObject(t)}};var Q=new Y,J=new Y,K=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Z=/[A-Z]/g;function ee(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(Z,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:K.test(i)?JSON.parse(i):i)}catch(e){}J.set(e,t,n)}else n=void 0;return n}k.extend({hasData:function(e){return J.hasData(e)||Q.hasData(e)},data:function(e,t,n){return J.access(e,t,n)},removeData:function(e,t){J.remove(e,t)},_data:function(e,t,n){return Q.access(e,t,n)},_removeData:function(e,t){Q.remove(e,t)}}),k.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=J.get(o),1===o.nodeType&&!Q.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=V(r.slice(5)),ee(o,r,i[r]));Q.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){J.set(this,n)}):_(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=J.get(o,n))?t:void 0!==(t=ee(o,n))?t:void 0;this.each(function(){J.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){J.remove(this,e)})}}),k.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=Q.get(e,t),n&&(!r||Array.isArray(n)?r=Q.access(e,t,k.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=k.queue(e,t),r=n.length,i=n.shift(),o=k._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){k.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return Q.get(e,n)||Q.access(e,n,{empty:k.Callbacks("once memory").add(function(){Q.remove(e,[t+"queue",n])})})}}),k.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?k.queue(this[0],t):void 0===n?this:this.each(function(){var e=k.queue(this,t,n);k._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&k.dequeue(this,t)})},dequeue:function(e){return this.each(function(){k.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=k.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=Q.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var te=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,ne=new RegExp("^(?:([+-])=|)("+te+")([a-z%]*)$","i"),re=["Top","Right","Bottom","Left"],ie=E.documentElement,oe=function(e){return k.contains(e.ownerDocument,e)},ae={composed:!0};ie.getRootNode&&(oe=function(e){return k.contains(e.ownerDocument,e)||e.getRootNode(ae)===e.ownerDocument});var se=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&oe(e)&&"none"===k.css(e,"display")},ue=function(e,t,n,r){var i,o,a={};for(o in t)a[o]=e.style[o],e.style[o]=t[o];for(o in i=n.apply(e,r||[]),t)e.style[o]=a[o];return i};function le(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return k.css(e,t,"")},u=s(),l=n&&n[3]||(k.cssNumber[t]?"":"px"),c=e.nodeType&&(k.cssNumber[t]||"px"!==l&&+u)&&ne.exec(k.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)k.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,k.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ce={};function fe(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=Q.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&se(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ce[s])||(o=a.body.appendChild(a.createElement(s)),u=k.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ce[s]=u)))):"none"!==n&&(l[c]="none",Q.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}k.fn.extend({show:function(){return fe(this,!0)},hide:function(){return fe(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){se(this)?k(this).show():k(this).hide()})}});var pe=/^(?:checkbox|radio)$/i,de=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,he=/^$|^module$|\/(?:java|ecma)script/i,ge={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function ve(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&A(e,t)?k.merge([e],n):n}function ye(e,t){for(var n=0,r=e.length;n<r;n++)Q.set(e[n],"globalEval",!t||Q.get(t[n],"globalEval"))}ge.optgroup=ge.option,ge.tbody=ge.tfoot=ge.colgroup=ge.caption=ge.thead,ge.th=ge.td;var me,xe,be=/<|&#?\w+;/;function we(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===w(o))k.merge(p,o.nodeType?[o]:o);else if(be.test(o)){a=a||f.appendChild(t.createElement("div")),s=(de.exec(o)||["",""])[1].toLowerCase(),u=ge[s]||ge._default,a.innerHTML=u[1]+k.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;k.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<k.inArray(o,r))i&&i.push(o);else if(l=oe(o),a=ve(f.appendChild(o),"script"),l&&ye(a),n){c=0;while(o=a[c++])he.test(o.type||"")&&n.push(o)}return f}me=E.createDocumentFragment().appendChild(E.createElement("div")),(xe=E.createElement("input")).setAttribute("type","radio"),xe.setAttribute("checked","checked"),xe.setAttribute("name","t"),me.appendChild(xe),y.checkClone=me.cloneNode(!0).cloneNode(!0).lastChild.checked,me.innerHTML="<textarea>x</textarea>",y.noCloneChecked=!!me.cloneNode(!0).lastChild.defaultValue;var Te=/^key/,Ce=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,Ee=/^([^.]*)(?:\.(.+)|)/;function ke(){return!0}function Se(){return!1}function Ne(e,t){return e===function(){try{return E.activeElement}catch(e){}}()==("focus"===t)}function Ae(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Ae(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=Se;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return k().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=k.guid++)),e.each(function(){k.event.add(this,t,i,r,n)})}function De(e,i,o){o?(Q.set(e,i,!1),k.event.add(e,i,{namespace:!1,handler:function(e){var t,n,r=Q.get(this,i);if(1&e.isTrigger&&this[i]){if(r.length)(k.event.special[i]||{}).delegateType&&e.stopPropagation();else if(r=s.call(arguments),Q.set(this,i,r),t=o(this,i),this[i](),r!==(n=Q.get(this,i))||t?Q.set(this,i,!1):n={},r!==n)return e.stopImmediatePropagation(),e.preventDefault(),n.value}else r.length&&(Q.set(this,i,{value:k.event.trigger(k.extend(r[0],k.Event.prototype),r.slice(1),this)}),e.stopImmediatePropagation())}})):void 0===Q.get(e,i)&&k.event.add(e,i,ke)}k.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=Q.get(t);if(v){n.handler&&(n=(o=n).handler,i=o.selector),i&&k.find.matchesSelector(ie,i),n.guid||(n.guid=k.guid++),(u=v.events)||(u=v.events={}),(a=v.handle)||(a=v.handle=function(e){return"undefined"!=typeof k&&k.event.triggered!==e.type?k.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(R)||[""]).length;while(l--)d=g=(s=Ee.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=k.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=k.event.special[d]||{},c=k.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&k.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),k.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=Q.hasData(e)&&Q.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(R)||[""]).length;while(l--)if(d=g=(s=Ee.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=k.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||k.removeEvent(e,d,v.handle),delete u[d])}else for(d in u)k.event.remove(e,d+t[l],n,r,!0);k.isEmptyObject(u)&&Q.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=k.event.fix(e),u=new Array(arguments.length),l=(Q.get(this,"events")||{})[s.type]||[],c=k.event.special[s.type]||{};for(u[0]=s,t=1;t<arguments.length;t++)u[t]=arguments[t];if(s.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,s)){a=k.event.handlers.call(this,s,l),t=0;while((i=a[t++])&&!s.isPropagationStopped()){s.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!s.isImmediatePropagationStopped())s.rnamespace&&!1!==o.namespace&&!s.rnamespace.test(o.namespace)||(s.handleObj=o,s.data=o.data,void 0!==(r=((k.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,u))&&!1===(s.result=r)&&(s.preventDefault(),s.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,s),s.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<k(i,this).index(l):k.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(k.Event.prototype,t,{enumerable:!0,configurable:!0,get:m(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[k.expando]?e:new k.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return pe.test(t.type)&&t.click&&A(t,"input")&&De(t,"click",ke),!1},trigger:function(e){var t=this||e;return pe.test(t.type)&&t.click&&A(t,"input")&&De(t,"click"),!0},_default:function(e){var t=e.target;return pe.test(t.type)&&t.click&&A(t,"input")&&Q.get(t,"click")||A(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},k.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},k.Event=function(e,t){if(!(this instanceof k.Event))return new k.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?ke:Se,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&k.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[k.expando]=!0},k.Event.prototype={constructor:k.Event,isDefaultPrevented:Se,isPropagationStopped:Se,isImmediatePropagationStopped:Se,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=ke,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=ke,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=ke,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},k.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function(e){var t=e.button;return null==e.which&&Te.test(e.type)?null!=e.charCode?e.charCode:e.keyCode:!e.which&&void 0!==t&&Ce.test(e.type)?1&t?1:2&t?3:4&t?2:0:e.which}},k.event.addProp),k.each({focus:"focusin",blur:"focusout"},function(e,t){k.event.special[e]={setup:function(){return De(this,e,Ne),!1},trigger:function(){return De(this,e),!0},delegateType:t}}),k.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){k.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||k.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),k.fn.extend({on:function(e,t,n,r){return Ae(this,e,t,n,r)},one:function(e,t,n,r){return Ae(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,k(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=Se),this.each(function(){k.event.remove(this,e,n,t)})}});var je=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,qe=/<script|<style|<link/i,Le=/checked\s*(?:[^=]|=\s*.checked.)/i,He=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function Oe(e,t){return A(e,"table")&&A(11!==t.nodeType?t:t.firstChild,"tr")&&k(e).children("tbody")[0]||e}function Pe(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function Re(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Me(e,t){var n,r,i,o,a,s,u,l;if(1===t.nodeType){if(Q.hasData(e)&&(o=Q.access(e),a=Q.set(t,o),l=o.events))for(i in delete a.handle,a.events={},l)for(n=0,r=l[i].length;n<r;n++)k.event.add(t,i,l[i][n]);J.hasData(e)&&(s=J.access(e),u=k.extend({},s),J.set(t,u))}}function Ie(n,r,i,o){r=g.apply([],r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=m(d);if(h||1<f&&"string"==typeof d&&!y.checkClone&&Le.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),Ie(t,r,i,o)});if(f&&(t=(e=we(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=k.map(ve(e,"script"),Pe)).length;c<f;c++)u=e,c!==p&&(u=k.clone(u,!0,!0),s&&k.merge(a,ve(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,k.map(a,Re),c=0;c<s;c++)u=a[c],he.test(u.type||"")&&!Q.access(u,"globalEval")&&k.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?k._evalUrl&&!u.noModule&&k._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")}):b(u.textContent.replace(He,""),u,l))}return n}function We(e,t,n){for(var r,i=t?k.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||k.cleanData(ve(r)),r.parentNode&&(n&&oe(r)&&ye(ve(r,"script")),r.parentNode.removeChild(r));return e}k.extend({htmlPrefilter:function(e){return e.replace(je,"<$1></$2>")},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=oe(e);if(!(y.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||k.isXMLDoc(e)))for(a=ve(c),r=0,i=(o=ve(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&pe.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||ve(e),a=a||ve(c),r=0,i=o.length;r<i;r++)Me(o[r],a[r]);else Me(e,c);return 0<(a=ve(c,"script")).length&&ye(a,!f&&ve(e,"script")),c},cleanData:function(e){for(var t,n,r,i=k.event.special,o=0;void 0!==(n=e[o]);o++)if(G(n)){if(t=n[Q.expando]){if(t.events)for(r in t.events)i[r]?k.event.remove(n,r):k.removeEvent(n,r,t.handle);n[Q.expando]=void 0}n[J.expando]&&(n[J.expando]=void 0)}}}),k.fn.extend({detach:function(e){return We(this,e,!0)},remove:function(e){return We(this,e)},text:function(e){return _(this,function(e){return void 0===e?k.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return Ie(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Oe(this,e).appendChild(e)})},prepend:function(){return Ie(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Oe(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return Ie(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return Ie(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(k.cleanData(ve(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return k.clone(this,e,t)})},html:function(e){return _(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!qe.test(e)&&!ge[(de.exec(e)||["",""])[1].toLowerCase()]){e=k.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(k.cleanData(ve(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return Ie(this,arguments,function(e){var t=this.parentNode;k.inArray(this,n)<0&&(k.cleanData(ve(this)),t&&t.replaceChild(e,this))},n)}}),k.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){k.fn[e]=function(e){for(var t,n=[],r=k(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),k(r[o])[a](t),u.apply(n,t.get());return this.pushStack(n)}});var $e=new RegExp("^("+te+")(?!px)[a-z%]+$","i"),Fe=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=C),t.getComputedStyle(e)},Be=new RegExp(re.join("|"),"i");function _e(e,t,n){var r,i,o,a,s=e.style;return(n=n||Fe(e))&&(""!==(a=n.getPropertyValue(t)||n[t])||oe(e)||(a=k.style(e,t)),!y.pixelBoxStyles()&&$e.test(a)&&Be.test(t)&&(r=s.width,i=s.minWidth,o=s.maxWidth,s.minWidth=s.maxWidth=s.width=a,a=n.width,s.width=r,s.minWidth=i,s.maxWidth=o)),void 0!==a?a+"":a}function ze(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(u){s.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",u.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",ie.appendChild(s).appendChild(u);var e=C.getComputedStyle(u);n="1%"!==e.top,a=12===t(e.marginLeft),u.style.right="60%",o=36===t(e.right),r=36===t(e.width),u.style.position="absolute",i=12===t(u.offsetWidth/3),ie.removeChild(s),u=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s=E.createElement("div"),u=E.createElement("div");u.style&&(u.style.backgroundClip="content-box",u.cloneNode(!0).style.backgroundClip="",y.clearCloneStyle="content-box"===u.style.backgroundClip,k.extend(y,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),a},scrollboxSize:function(){return e(),i}}))}();var Ue=["Webkit","Moz","ms"],Xe=E.createElement("div").style,Ve={};function Ge(e){var t=k.cssProps[e]||Ve[e];return t||(e in Xe?e:Ve[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=Ue.length;while(n--)if((e=Ue[n]+t)in Xe)return e}(e)||e)}var Ye=/^(none|table(?!-c[ea]).+)/,Qe=/^--/,Je={position:"absolute",visibility:"hidden",display:"block"},Ke={letterSpacing:"0",fontWeight:"400"};function Ze(e,t,n){var r=ne.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function et(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(u+=k.css(e,n+re[a],!0,i)),r?("content"===n&&(u-=k.css(e,"padding"+re[a],!0,i)),"margin"!==n&&(u-=k.css(e,"border"+re[a]+"Width",!0,i))):(u+=k.css(e,"padding"+re[a],!0,i),"padding"!==n?u+=k.css(e,"border"+re[a]+"Width",!0,i):s+=k.css(e,"border"+re[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u}function tt(e,t,n){var r=Fe(e),i=(!y.boxSizingReliable()||n)&&"border-box"===k.css(e,"boxSizing",!1,r),o=i,a=_e(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if($e.test(a)){if(!n)return a;a="auto"}return(!y.boxSizingReliable()&&i||"auto"===a||!parseFloat(a)&&"inline"===k.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===k.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+et(e,t,n||(i?"border":"content"),o,r,a)+"px"}function nt(e,t,n,r,i){return new nt.prototype.init(e,t,n,r,i)}k.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=_e(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=V(t),u=Qe.test(t),l=e.style;if(u||(t=Ge(s)),a=k.cssHooks[t]||k.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=ne.exec(n))&&i[1]&&(n=le(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(k.cssNumber[s]?"":"px")),y.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=V(t);return Qe.test(t)||(t=Ge(s)),(a=k.cssHooks[t]||k.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=_e(e,t,r)),"normal"===i&&t in Ke&&(i=Ke[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),k.each(["height","width"],function(e,u){k.cssHooks[u]={get:function(e,t,n){if(t)return!Ye.test(k.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?tt(e,u,n):ue(e,Je,function(){return tt(e,u,n)})},set:function(e,t,n){var r,i=Fe(e),o=!y.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===k.css(e,"boxSizing",!1,i),s=n?et(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-et(e,u,"border",!1,i)-.5)),s&&(r=ne.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=k.css(e,u)),Ze(0,t,s)}}}),k.cssHooks.marginLeft=ze(y.reliableMarginLeft,function(e,t){if(t)return(parseFloat(_e(e,"marginLeft"))||e.getBoundingClientRect().left-ue(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),k.each({margin:"",padding:"",border:"Width"},function(i,o){k.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+re[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(k.cssHooks[i+o].set=Ze)}),k.fn.extend({css:function(e,t){return _(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Fe(e),i=t.length;a<i;a++)o[t[a]]=k.css(e,t[a],!1,r);return o}return void 0!==n?k.style(e,t,n):k.css(e,t)},e,t,1<arguments.length)}}),((k.Tween=nt).prototype={constructor:nt,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||k.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(k.cssNumber[n]?"":"px")},cur:function(){var e=nt.propHooks[this.prop];return e&&e.get?e.get(this):nt.propHooks._default.get(this)},run:function(e){var t,n=nt.propHooks[this.prop];return this.options.duration?this.pos=t=k.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):nt.propHooks._default.set(this),this}}).init.prototype=nt.prototype,(nt.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=k.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){k.fx.step[e.prop]?k.fx.step[e.prop](e):1!==e.elem.nodeType||!k.cssHooks[e.prop]&&null==e.elem.style[Ge(e.prop)]?e.elem[e.prop]=e.now:k.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=nt.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},k.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},k.fx=nt.prototype.init,k.fx.step={};var rt,it,ot,at,st=/^(?:toggle|show|hide)$/,ut=/queueHooks$/;function lt(){it&&(!1===E.hidden&&C.requestAnimationFrame?C.requestAnimationFrame(lt):C.setTimeout(lt,k.fx.interval),k.fx.tick())}function ct(){return C.setTimeout(function(){rt=void 0}),rt=Date.now()}function ft(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=re[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function pt(e,t,n){for(var r,i=(dt.tweeners[t]||[]).concat(dt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function dt(o,e,t){var n,a,r=0,i=dt.prefilters.length,s=k.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=rt||ct(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:k.extend({},e),opts:k.extend(!0,{specialEasing:{},easing:k.easing._default},t),originalProperties:e,originalOptions:t,startTime:rt||ct(),duration:t.duration,tweens:[],createTween:function(e,t){var n=k.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=V(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=k.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=dt.prefilters[r].call(l,o,c,l.opts))return m(n.stop)&&(k._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return k.map(c,pt,l),m(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),k.fx.timer(k.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}k.Animation=k.extend(dt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return le(n.elem,e,ne.exec(t),n),n}]},tweener:function(e,t){m(e)?(t=e,e=["*"]):e=e.match(R);for(var n,r=0,i=e.length;r<i;r++)n=e[r],dt.tweeners[n]=dt.tweeners[n]||[],dt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&se(e),v=Q.get(e,"fxshow");for(r in n.queue||(null==(a=k._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,k.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],st.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!v||void 0===v[r])continue;g=!0}d[r]=v&&v[r]||k.style(e,r)}if((u=!k.isEmptyObject(t))||!k.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=Q.get(e,"display")),"none"===(c=k.css(e,"display"))&&(l?c=l:(fe([e],!0),l=e.style.display||l,c=k.css(e,"display"),fe([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===k.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=Q.access(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&fe([e],!0),p.done(function(){for(r in g||fe([e]),Q.remove(e,"fxshow"),d)k.style(e,r,d[r])})),u=pt(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?dt.prefilters.unshift(e):dt.prefilters.push(e)}}),k.speed=function(e,t,n){var r=e&&"object"==typeof e?k.extend({},e):{complete:n||!n&&t||m(e)&&e,duration:e,easing:n&&t||t&&!m(t)&&t};return k.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in k.fx.speeds?r.duration=k.fx.speeds[r.duration]:r.duration=k.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){m(r.old)&&r.old.call(this),r.queue&&k.dequeue(this,r.queue)},r},k.fn.extend({fadeTo:function(e,t,n,r){return this.filter(se).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=k.isEmptyObject(t),o=k.speed(e,n,r),a=function(){var e=dt(this,k.extend({},t),o);(i||Q.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&!1!==i&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=k.timers,r=Q.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&ut.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||k.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=Q.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=k.timers,o=n?n.length:0;for(t.finish=!0,k.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),k.each(["toggle","show","hide"],function(e,r){var i=k.fn[r];k.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(ft(r,!0),e,t,n)}}),k.each({slideDown:ft("show"),slideUp:ft("hide"),slideToggle:ft("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){k.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),k.timers=[],k.fx.tick=function(){var e,t=0,n=k.timers;for(rt=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||k.fx.stop(),rt=void 0},k.fx.timer=function(e){k.timers.push(e),k.fx.start()},k.fx.interval=13,k.fx.start=function(){it||(it=!0,lt())},k.fx.stop=function(){it=null},k.fx.speeds={slow:600,fast:200,_default:400},k.fn.delay=function(r,e){return r=k.fx&&k.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=C.setTimeout(e,r);t.stop=function(){C.clearTimeout(n)}})},ot=E.createElement("input"),at=E.createElement("select").appendChild(E.createElement("option")),ot.type="checkbox",y.checkOn=""!==ot.value,y.optSelected=at.selected,(ot=E.createElement("input")).value="t",ot.type="radio",y.radioValue="t"===ot.value;var ht,gt=k.expr.attrHandle;k.fn.extend({attr:function(e,t){return _(this,k.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){k.removeAttr(this,e)})}}),k.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?k.prop(e,t,n):(1===o&&k.isXMLDoc(e)||(i=k.attrHooks[t.toLowerCase()]||(k.expr.match.bool.test(t)?ht:void 0)),void 0!==n?null===n?void k.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=k.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!y.radioValue&&"radio"===t&&A(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(R);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),ht={set:function(e,t,n){return!1===t?k.removeAttr(e,n):e.setAttribute(n,n),n}},k.each(k.expr.match.bool.source.match(/\w+/g),function(e,t){var a=gt[t]||k.find.attr;gt[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=gt[o],gt[o]=r,r=null!=a(e,t,n)?o:null,gt[o]=i),r}});var vt=/^(?:input|select|textarea|button)$/i,yt=/^(?:a|area)$/i;function mt(e){return(e.match(R)||[]).join(" ")}function xt(e){return e.getAttribute&&e.getAttribute("class")||""}function bt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(R)||[]}k.fn.extend({prop:function(e,t){return _(this,k.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[k.propFix[e]||e]})}}),k.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&k.isXMLDoc(e)||(t=k.propFix[t]||t,i=k.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=k.find.attr(e,"tabindex");return t?parseInt(t,10):vt.test(e.nodeName)||yt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),y.optSelected||(k.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),k.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){k.propFix[this.toLowerCase()]=this}),k.fn.extend({addClass:function(t){var e,n,r,i,o,a,s,u=0;if(m(t))return this.each(function(e){k(this).addClass(t.call(this,e,xt(this)))});if((e=bt(t)).length)while(n=this[u++])if(i=xt(n),r=1===n.nodeType&&" "+mt(i)+" "){a=0;while(o=e[a++])r.indexOf(" "+o+" ")<0&&(r+=o+" ");i!==(s=mt(r))&&n.setAttribute("class",s)}return this},removeClass:function(t){var e,n,r,i,o,a,s,u=0;if(m(t))return this.each(function(e){k(this).removeClass(t.call(this,e,xt(this)))});if(!arguments.length)return this.attr("class","");if((e=bt(t)).length)while(n=this[u++])if(i=xt(n),r=1===n.nodeType&&" "+mt(i)+" "){a=0;while(o=e[a++])while(-1<r.indexOf(" "+o+" "))r=r.replace(" "+o+" "," ");i!==(s=mt(r))&&n.setAttribute("class",s)}return this},toggleClass:function(i,t){var o=typeof i,a="string"===o||Array.isArray(i);return"boolean"==typeof t&&a?t?this.addClass(i):this.removeClass(i):m(i)?this.each(function(e){k(this).toggleClass(i.call(this,e,xt(this),t),t)}):this.each(function(){var e,t,n,r;if(a){t=0,n=k(this),r=bt(i);while(e=r[t++])n.hasClass(e)?n.removeClass(e):n.addClass(e)}else void 0!==i&&"boolean"!==o||((e=xt(this))&&Q.set(this,"__className__",e),this.setAttribute&&this.setAttribute("class",e||!1===i?"":Q.get(this,"__className__")||""))})},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+mt(xt(n))+" ").indexOf(t))return!0;return!1}});var wt=/\r/g;k.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=m(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,k(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=k.map(t,function(e){return null==e?"":e+""})),(r=k.valHooks[this.type]||k.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=k.valHooks[t.type]||k.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(wt,""):null==e?"":e:void 0}}),k.extend({valHooks:{option:{get:function(e){var t=k.find.attr(e,"value");return null!=t?t:mt(k.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!A(n.parentNode,"optgroup"))){if(t=k(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=k.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<k.inArray(k.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),k.each(["radio","checkbox"],function(){k.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<k.inArray(k(e).val(),t)}},y.checkOn||(k.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})}),y.focusin="onfocusin"in C;var Tt=/^(?:focusinfocus|focusoutblur)$/,Ct=function(e){e.stopPropagation()};k.extend(k.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||E],d=v.call(e,"type")?e.type:e,h=v.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||E,3!==n.nodeType&&8!==n.nodeType&&!Tt.test(d+k.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[k.expando]?e:new k.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:k.makeArray(t,[e]),c=k.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!x(n)){for(s=c.delegateType||d,Tt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||E)&&p.push(a.defaultView||a.parentWindow||C)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(Q.get(o,"events")||{})[e.type]&&Q.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&G(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!G(n)||u&&m(n[d])&&!x(n)&&((a=n[u])&&(n[u]=null),k.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,Ct),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,Ct),k.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=k.extend(new k.Event,n,{type:e,isSimulated:!0});k.event.trigger(r,null,t)}}),k.fn.extend({trigger:function(e,t){return this.each(function(){k.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return k.event.trigger(e,t,n,!0)}}),y.focusin||k.each({focus:"focusin",blur:"focusout"},function(n,r){var i=function(e){k.event.simulate(r,e.target,k.event.fix(e))};k.event.special[r]={setup:function(){var e=this.ownerDocument||this,t=Q.access(e,r);t||e.addEventListener(n,i,!0),Q.access(e,r,(t||0)+1)},teardown:function(){var e=this.ownerDocument||this,t=Q.access(e,r)-1;t?Q.access(e,r,t):(e.removeEventListener(n,i,!0),Q.remove(e,r))}}});var Et=C.location,kt=Date.now(),St=/\?/;k.parseXML=function(e){var t;if(!e||"string"!=typeof e)return null;try{t=(new C.DOMParser).parseFromString(e,"text/xml")}catch(e){t=void 0}return t&&!t.getElementsByTagName("parsererror").length||k.error("Invalid XML: "+e),t};var Nt=/\[\]$/,At=/\r?\n/g,Dt=/^(?:submit|button|image|reset|file)$/i,jt=/^(?:input|select|textarea|keygen)/i;function qt(n,e,r,i){var t;if(Array.isArray(e))k.each(e,function(e,t){r||Nt.test(n)?i(n,t):qt(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==w(e))i(n,e);else for(t in e)qt(n+"["+t+"]",e[t],r,i)}k.param=function(e,t){var n,r=[],i=function(e,t){var n=m(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!k.isPlainObject(e))k.each(e,function(){i(this.name,this.value)});else for(n in e)qt(n,e[n],t,i);return r.join("&")},k.fn.extend({serialize:function(){return k.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=k.prop(this,"elements");return e?k.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!k(this).is(":disabled")&&jt.test(this.nodeName)&&!Dt.test(e)&&(this.checked||!pe.test(e))}).map(function(e,t){var n=k(this).val();return null==n?null:Array.isArray(n)?k.map(n,function(e){return{name:t.name,value:e.replace(At,"\r\n")}}):{name:t.name,value:n.replace(At,"\r\n")}}).get()}});var Lt=/%20/g,Ht=/#.*$/,Ot=/([?&])_=[^&]*/,Pt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Rt=/^(?:GET|HEAD)$/,Mt=/^\/\//,It={},Wt={},$t="*/".concat("*"),Ft=E.createElement("a");function Bt(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(R)||[];if(m(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function _t(t,i,o,a){var s={},u=t===Wt;function l(e){var r;return s[e]=!0,k.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function zt(e,t){var n,r,i=k.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&k.extend(!0,e,r),e}Ft.href=Et.href,k.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Et.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":$t,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":k.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?zt(zt(e,k.ajaxSettings),t):zt(k.ajaxSettings,e)},ajaxPrefilter:Bt(It),ajaxTransport:Bt(Wt),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,v=k.ajaxSetup({},t),y=v.context||v,m=v.context&&(y.nodeType||y.jquery)?k(y):k.event,x=k.Deferred(),b=k.Callbacks("once memory"),w=v.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=Pt.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(v.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),v.url=((e||v.url||Et.href)+"").replace(Mt,Et.protocol+"//"),v.type=t.method||t.type||v.method||v.type,v.dataTypes=(v.dataType||"*").toLowerCase().match(R)||[""],null==v.crossDomain){r=E.createElement("a");try{r.href=v.url,r.href=r.href,v.crossDomain=Ft.protocol+"//"+Ft.host!=r.protocol+"//"+r.host}catch(e){v.crossDomain=!0}}if(v.data&&v.processData&&"string"!=typeof v.data&&(v.data=k.param(v.data,v.traditional)),_t(It,v,t,T),h)return T;for(i in(g=k.event&&v.global)&&0==k.active++&&k.event.trigger("ajaxStart"),v.type=v.type.toUpperCase(),v.hasContent=!Rt.test(v.type),f=v.url.replace(Ht,""),v.hasContent?v.data&&v.processData&&0===(v.contentType||"").indexOf("application/x-www-form-urlencoded")&&(v.data=v.data.replace(Lt,"+")):(o=v.url.slice(f.length),v.data&&(v.processData||"string"==typeof v.data)&&(f+=(St.test(f)?"&":"?")+v.data,delete v.data),!1===v.cache&&(f=f.replace(Ot,"$1"),o=(St.test(f)?"&":"?")+"_="+kt+++o),v.url=f+o),v.ifModified&&(k.lastModified[f]&&T.setRequestHeader("If-Modified-Since",k.lastModified[f]),k.etag[f]&&T.setRequestHeader("If-None-Match",k.etag[f])),(v.data&&v.hasContent&&!1!==v.contentType||t.contentType)&&T.setRequestHeader("Content-Type",v.contentType),T.setRequestHeader("Accept",v.dataTypes[0]&&v.accepts[v.dataTypes[0]]?v.accepts[v.dataTypes[0]]+("*"!==v.dataTypes[0]?", "+$t+"; q=0.01":""):v.accepts["*"]),v.headers)T.setRequestHeader(i,v.headers[i]);if(v.beforeSend&&(!1===v.beforeSend.call(y,T,v)||h))return T.abort();if(u="abort",b.add(v.complete),T.done(v.success),T.fail(v.error),c=_t(Wt,v,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,v]),h)return T;v.async&&0<v.timeout&&(d=C.setTimeout(function(){T.abort("timeout")},v.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&C.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(v,T,n)),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(v,s,T,i),i?(v.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(k.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(k.etag[f]=u)),204===e||"HEAD"===v.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(y,[o,l,T]):x.rejectWith(y,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,v,i?o:a]),b.fireWith(y,[T,l]),g&&(m.trigger("ajaxComplete",[T,v]),--k.active||k.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return k.get(e,t,n,"json")},getScript:function(e,t){return k.get(e,void 0,t,"script")}}),k.each(["get","post"],function(e,i){k[i]=function(e,t,n,r){return m(t)&&(r=r||n,n=t,t=void 0),k.ajax(k.extend({url:e,type:i,dataType:r,data:t,success:n},k.isPlainObject(e)&&e))}}),k._evalUrl=function(e,t){return k.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){k.globalEval(e,t)}})},k.fn.extend({wrapAll:function(e){var t;return this[0]&&(m(e)&&(e=e.call(this[0])),t=k(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return m(n)?this.each(function(e){k(this).wrapInner(n.call(this,e))}):this.each(function(){var e=k(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=m(t);return this.each(function(e){k(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){k(this).replaceWith(this.childNodes)}),this}}),k.expr.pseudos.hidden=function(e){return!k.expr.pseudos.visible(e)},k.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},k.ajaxSettings.xhr=function(){try{return new C.XMLHttpRequest}catch(e){}};var Ut={0:200,1223:204},Xt=k.ajaxSettings.xhr();y.cors=!!Xt&&"withCredentials"in Xt,y.ajax=Xt=!!Xt,k.ajaxTransport(function(i){var o,a;if(y.cors||Xt&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Ut[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&C.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),k.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),k.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return k.globalEval(e),e}}}),k.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),k.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=k("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),E.head.appendChild(r[0])},abort:function(){i&&i()}}});var Vt,Gt=[],Yt=/(=)\?(?=&|$)|\?\?/;k.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Gt.pop()||k.expando+"_"+kt++;return this[e]=!0,e}}),k.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Yt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Yt.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=m(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Yt,"$1"+r):!1!==e.jsonp&&(e.url+=(St.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||k.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=C[r],C[r]=function(){o=arguments},n.always(function(){void 0===i?k(C).removeProp(r):C[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,Gt.push(r)),o&&m(i)&&i(o[0]),o=i=void 0}),"script"}),y.createHTMLDocument=((Vt=E.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===Vt.childNodes.length),k.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(y.createHTMLDocument?((r=(t=E.implementation.createHTMLDocument("")).createElement("base")).href=E.location.href,t.head.appendChild(r)):t=E),o=!n&&[],(i=D.exec(e))?[t.createElement(i[1])]:(i=we([e],t,o),o&&o.length&&k(o).remove(),k.merge([],i.childNodes)));var r,i,o},k.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=mt(e.slice(s)),e=e.slice(0,s)),m(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&k.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?k("<div>").append(k.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},k.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){k.fn[t]=function(e){return this.on(t,e)}}),k.expr.pseudos.animated=function(t){return k.grep(k.timers,function(e){return t===e.elem}).length},k.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=k.css(e,"position"),c=k(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=k.css(e,"top"),u=k.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),m(t)&&(t=t.call(e,n,k.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},k.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){k.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===k.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===k.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=k(e).offset()).top+=k.css(e,"borderTopWidth",!0),i.left+=k.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-k.css(r,"marginTop",!0),left:t.left-i.left-k.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===k.css(e,"position"))e=e.offsetParent;return e||ie})}}),k.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;k.fn[t]=function(e){return _(this,function(e,t,n){var r;if(x(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),k.each(["top","left"],function(e,n){k.cssHooks[n]=ze(y.pixelPosition,function(e,t){if(t)return t=_e(e,n),$e.test(t)?k(e).position()[n]+"px":t})}),k.each({Height:"height",Width:"width"},function(a,s){k.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){k.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return _(this,function(e,t,n){var r;return x(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?k.css(e,t,i):k.style(e,t,n,i)},s,n?e:void 0,n)}})}),k.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){k.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}}),k.fn.extend({hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)}}),k.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)}}),k.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),m(e))return r=s.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(s.call(arguments)))}).guid=e.guid=e.guid||k.guid++,i},k.holdReady=function(e){e?k.readyWait++:k.ready(!0)},k.isArray=Array.isArray,k.parseJSON=JSON.parse,k.nodeName=A,k.isFunction=m,k.isWindow=x,k.camelCase=V,k.type=w,k.now=Date.now,k.isNumeric=function(e){var t=k.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},"function"==typeof define&&define.amd&&define("jquery",[],function(){return k});var Qt=C.jQuery,Jt=C.$;return k.noConflict=function(e){return C.$===k&&(C.$=Jt),e&&C.jQuery===k&&(C.jQuery=Qt),k},e||(C.jQuery=C.$=k),k});

// lazy load images (https://github.com/aFarkas/lazysizes)
!function(e){var t=function(u,D,f){"use strict";var k,H;if(function(){var e;var t={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",fastLoadedClass:"ls-is-cached",iframeLoadMode:0,srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:true,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:true,ricTimeout:0,throttleDelay:125};H=u.lazySizesConfig||u.lazysizesConfig||{};for(e in t){if(!(e in H)){H[e]=t[e]}}}(),!D||!D.getElementsByClassName){return{init:function(){},cfg:H,noSupport:true}}var O=D.documentElement,i=u.HTMLPictureElement,P="addEventListener",$="getAttribute",q=u[P].bind(u),I=u.setTimeout,U=u.requestAnimationFrame||I,o=u.requestIdleCallback,j=/^picture$/i,r=["load","error","lazyincluded","_lazyloaded"],a={},G=Array.prototype.forEach,J=function(e,t){if(!a[t]){a[t]=new RegExp("(\\s|^)"+t+"(\\s|$)")}return a[t].test(e[$]("class")||"")&&a[t]},K=function(e,t){if(!J(e,t)){e.setAttribute("class",(e[$]("class")||"").trim()+" "+t)}},Q=function(e,t){var a;if(a=J(e,t)){e.setAttribute("class",(e[$]("class")||"").replace(a," "))}},V=function(t,a,e){var i=e?P:"removeEventListener";if(e){V(t,a)}r.forEach(function(e){t[i](e,a)})},X=function(e,t,a,i,r){var n=D.createEvent("Event");if(!a){a={}}a.instance=k;n.initEvent(t,!i,!r);n.detail=a;e.dispatchEvent(n);return n},Y=function(e,t){var a;if(!i&&(a=u.picturefill||H.pf)){if(t&&t.src&&!e[$]("srcset")){e.setAttribute("srcset",t.src)}a({reevaluate:true,elements:[e]})}else if(t&&t.src){e.src=t.src}},Z=function(e,t){return(getComputedStyle(e,null)||{})[t]},s=function(e,t,a){a=a||e.offsetWidth;while(a<H.minSize&&t&&!e._lazysizesWidth){a=t.offsetWidth;t=t.parentNode}return a},ee=function(){var a,i;var t=[];var r=[];var n=t;var s=function(){var e=n;n=t.length?r:t;a=true;i=false;while(e.length){e.shift()()}a=false};var e=function(e,t){if(a&&!t){e.apply(this,arguments)}else{n.push(e);if(!i){i=true;(D.hidden?I:U)(s)}}};e._lsFlush=s;return e}(),te=function(a,e){return e?function(){ee(a)}:function(){var e=this;var t=arguments;ee(function(){a.apply(e,t)})}},ae=function(e){var a;var i=0;var r=H.throttleDelay;var n=H.ricTimeout;var t=function(){a=false;i=f.now();e()};var s=o&&n>49?function(){o(t,{timeout:n});if(n!==H.ricTimeout){n=H.ricTimeout}}:te(function(){I(t)},true);return function(e){var t;if(e=e===true){n=33}if(a){return}a=true;t=r-(f.now()-i);if(t<0){t=0}if(e||t<9){s()}else{I(s,t)}}},ie=function(e){var t,a;var i=99;var r=function(){t=null;e()};var n=function(){var e=f.now()-a;if(e<i){I(n,i-e)}else{(o||r)(r)}};return function(){a=f.now();if(!t){t=I(n,i)}}},e=function(){var v,m,c,h,e;var y,z,g,p,C,b,A;var n=/^img$/i;var d=/^iframe$/i;var E="onscroll"in u&&!/(gle|ing)bot/.test(navigator.userAgent);var _=0;var w=0;var M=0;var N=-1;var L=function(e){M--;if(!e||M<0||!e.target){M=0}};var x=function(e){if(A==null){A=Z(D.body,"visibility")=="hidden"}return A||!(Z(e.parentNode,"visibility")=="hidden"&&Z(e,"visibility")=="hidden")};var W=function(e,t){var a;var i=e;var r=x(e);g-=t;b+=t;p-=t;C+=t;while(r&&(i=i.offsetParent)&&i!=D.body&&i!=O){r=(Z(i,"opacity")||1)>0;if(r&&Z(i,"overflow")!="visible"){a=i.getBoundingClientRect();r=C>a.left&&p<a.right&&b>a.top-1&&g<a.bottom+1}}return r};var t=function(){var e,t,a,i,r,n,s,o,l,u,f,c;var d=k.elements;if((h=H.loadMode)&&M<8&&(e=d.length)){t=0;N++;for(;t<e;t++){if(!d[t]||d[t]._lazyRace){continue}if(!E||k.prematureUnveil&&k.prematureUnveil(d[t])){R(d[t]);continue}if(!(o=d[t][$]("data-expand"))||!(n=o*1)){n=w}if(!u){u=!H.expand||H.expand<1?O.clientHeight>500&&O.clientWidth>500?500:370:H.expand;k._defEx=u;f=u*H.expFactor;c=H.hFac;A=null;if(w<f&&M<1&&N>2&&h>2&&!D.hidden){w=f;N=0}else if(h>1&&N>1&&M<6){w=u}else{w=_}}if(l!==n){y=innerWidth+n*c;z=innerHeight+n;s=n*-1;l=n}a=d[t].getBoundingClientRect();if((b=a.bottom)>=s&&(g=a.top)<=z&&(C=a.right)>=s*c&&(p=a.left)<=y&&(b||C||p||g)&&(H.loadHidden||x(d[t]))&&(m&&M<3&&!o&&(h<3||N<4)||W(d[t],n))){R(d[t]);r=true;if(M>9){break}}else if(!r&&m&&!i&&M<4&&N<4&&h>2&&(v[0]||H.preloadAfterLoad)&&(v[0]||!o&&(b||C||p||g||d[t][$](H.sizesAttr)!="auto"))){i=v[0]||d[t]}}if(i&&!r){R(i)}}};var a=ae(t);var S=function(e){var t=e.target;if(t._lazyCache){delete t._lazyCache;return}L(e);K(t,H.loadedClass);Q(t,H.loadingClass);V(t,B);X(t,"lazyloaded")};var i=te(S);var B=function(e){i({target:e.target})};var T=function(e,t){var a=e.getAttribute("data-load-mode")||H.iframeLoadMode;if(a==0){e.contentWindow.location.replace(t)}else if(a==1){e.src=t}};var F=function(e){var t;var a=e[$](H.srcsetAttr);if(t=H.customMedia[e[$]("data-media")||e[$]("media")]){e.setAttribute("media",t)}if(a){e.setAttribute("srcset",a)}};var s=te(function(t,e,a,i,r){var n,s,o,l,u,f;if(!(u=X(t,"lazybeforeunveil",e)).defaultPrevented){if(i){if(a){K(t,H.autosizesClass)}else{t.setAttribute("sizes",i)}}s=t[$](H.srcsetAttr);n=t[$](H.srcAttr);if(r){o=t.parentNode;l=o&&j.test(o.nodeName||"")}f=e.firesLoad||"src"in t&&(s||n||l);u={target:t};K(t,H.loadingClass);if(f){clearTimeout(c);c=I(L,2500);V(t,B,true)}if(l){G.call(o.getElementsByTagName("source"),F)}if(s){t.setAttribute("srcset",s)}else if(n&&!l){if(d.test(t.nodeName)){T(t,n)}else{t.src=n}}if(r&&(s||l)){Y(t,{src:n})}}if(t._lazyRace){delete t._lazyRace}Q(t,H.lazyClass);ee(function(){var e=t.complete&&t.naturalWidth>1;if(!f||e){if(e){K(t,H.fastLoadedClass)}S(u);t._lazyCache=true;I(function(){if("_lazyCache"in t){delete t._lazyCache}},9)}if(t.loading=="lazy"){M--}},true)});var R=function(e){if(e._lazyRace){return}var t;var a=n.test(e.nodeName);var i=a&&(e[$](H.sizesAttr)||e[$]("sizes"));var r=i=="auto";if((r||!m)&&a&&(e[$]("src")||e.srcset)&&!e.complete&&!J(e,H.errorClass)&&J(e,H.lazyClass)){return}t=X(e,"lazyunveilread").detail;if(r){re.updateElem(e,true,e.offsetWidth)}e._lazyRace=true;M++;s(e,t,r,i,a)};var r=ie(function(){H.loadMode=3;a()});var o=function(){if(H.loadMode==3){H.loadMode=2}r()};var l=function(){if(m){return}if(f.now()-e<999){I(l,999);return}m=true;H.loadMode=3;a();q("scroll",o,true)};return{_:function(){e=f.now();k.elements=D.getElementsByClassName(H.lazyClass);v=D.getElementsByClassName(H.lazyClass+" "+H.preloadClass);q("scroll",a,true);q("resize",a,true);q("pageshow",function(e){if(e.persisted){var t=D.querySelectorAll("."+H.loadingClass);if(t.length&&t.forEach){U(function(){t.forEach(function(e){if(e.complete){R(e)}})})}}});if(u.MutationObserver){new MutationObserver(a).observe(O,{childList:true,subtree:true,attributes:true})}else{O[P]("DOMNodeInserted",a,true);O[P]("DOMAttrModified",a,true);setInterval(a,999)}q("hashchange",a,true);["focus","mouseover","click","load","transitionend","animationend"].forEach(function(e){D[P](e,a,true)});if(/d$|^c/.test(D.readyState)){l()}else{q("load",l);D[P]("DOMContentLoaded",a);I(l,2e4)}if(k.elements.length){t();ee._lsFlush()}else{a()}},checkElems:a,unveil:R,_aLSL:o}}(),re=function(){var a;var n=te(function(e,t,a,i){var r,n,s;e._lazysizesWidth=i;i+="px";e.setAttribute("sizes",i);if(j.test(t.nodeName||"")){r=t.getElementsByTagName("source");for(n=0,s=r.length;n<s;n++){r[n].setAttribute("sizes",i)}}if(!a.detail.dataAttr){Y(e,a.detail)}});var i=function(e,t,a){var i;var r=e.parentNode;if(r){a=s(e,r,a);i=X(e,"lazybeforesizes",{width:a,dataAttr:!!t});if(!i.defaultPrevented){a=i.detail.width;if(a&&a!==e._lazysizesWidth){n(e,r,i,a)}}}};var e=function(){var e;var t=a.length;if(t){e=0;for(;e<t;e++){i(a[e])}}};var t=ie(e);return{_:function(){a=D.getElementsByClassName(H.autosizesClass);q("resize",t)},checkElems:t,updateElem:i}}(),t=function(){if(!t.i&&D.getElementsByClassName){t.i=true;re._();e._()}};return I(function(){H.init&&t()}),k={cfg:H,autoSizer:re,loader:e,init:t,uP:Y,aC:K,rC:Q,hC:J,fire:X,gW:s,rAF:ee}}(e,e.document,Date);e.lazySizes=t,"object"==typeof module&&module.exports&&(module.exports=t)}("undefined"!=typeof window?window:{});

// safari viewheight fix (https://github.com/Hiswe/vh-check)
!function(e,n){"object"==typeof exports&&"undefined"!=typeof module?module.exports=n():"function"==typeof define&&define.amd?define(n):e.vhCheck=n()}(this,function(){"use strict";var r=function(){return(r=Object.assign||function(e){for(var n,t=1,o=arguments.length;t<o;t++)for(var r in n=arguments[t])Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r]);return e}).apply(this,arguments)};function n(){var e,n,t=((e=document.createElement("div")).style.cssText="position: fixed; top: 0; height: 100vh; pointer-events: none;",document.documentElement.insertBefore(e,document.documentElement.firstChild),e),o=window.innerHeight,r=t.offsetHeight,i=r-o;return n=t,document.documentElement.removeChild(n),{vh:r,windowHeight:o,offset:i,isNeeded:0!==i,value:0}}function i(){}function e(){var e=n();return e.value=e.offset,e}var c=Object.freeze({noop:i,computeDifference:e,redefineVhUnit:function(){var e=n();return e.value=.01*e.windowHeight,e}});function u(e){return"string"==typeof e&&0<e.length}var a=Object.freeze({cssVarName:"vh-offset",redefineVh:!1,method:e,force:!1,bind:!0,updateOnTouch:!1,onUpdate:i});var t=!1,o=[];try{var f=Object.defineProperty({},"passive",{get:function(){t=!0}});window.addEventListener("test",f,f),window.removeEventListener("test",f,f)}catch(e){t=!1}function d(e,n){o.push({eventName:e,callback:n}),window.addEventListener(e,n,!!t&&{passive:!0})}function s(){o.forEach(function(e){window.removeEventListener(e.eventName,e.callback)}),o=[]}function m(e,n){document.documentElement.style.setProperty("--"+e,n.value+"px")}function h(e,n){return r({},e,{unbind:s,recompute:n.method})}return function(e){var n=Object.freeze(function(e){if(u(e))return r({},a,{cssVarName:e});if("object"!=typeof e)return a;var n,t={force:!0===e.force,bind:!1!==e.bind,updateOnTouch:!0===e.updateOnTouch,onUpdate:(n=e.onUpdate,"function"==typeof n?e.onUpdate:i)},o=!0===e.redefineVh;return t.method=c[o?"redefineVhUnit":"computeDifference"],t.cssVarName=u(e.cssVarName)?e.cssVarName:o?"vh":a.cssVarName,t}(e)),t=h(n.method(),n);if(!t.isNeeded&&!n.force)return t;if(m(n.cssVarName,t),n.onUpdate(t),!n.bind)return t;function o(){window.requestAnimationFrame(function(){var e=n.method();m(n.cssVarName,e),n.onUpdate(h(e,n))})}return t.unbind(),d("orientationchange",o),n.updateOnTouch&&d("touchmove",o),t}});
(function () { var test = vhCheck("browser-address-bar"); }());

// block body scroll in modals (https://github.com/willmcpo/body-scroll-lock)
!function(e,t){if("function"==typeof define&&define.amd)define(["exports"],t);else if("undefined"!=typeof exports)t(exports);else{var o={};t(o),e.bodyScrollLock=o}}(this,function(exports){"use strict";function r(e){if(Array.isArray(e)){for(var t=0,o=Array(e.length);t<e.length;t++)o[t]=e[t];return o}return Array.from(e)}Object.defineProperty(exports,"__esModule",{value:!0});var l=!1;if("undefined"!=typeof window){var e={get passive(){l=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}var d="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&/iP(ad|hone|od)/.test(window.navigator.platform),c=[],u=!1,a=-1,s=void 0,v=void 0,f=function(t){return c.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(t))})},m=function(e){var t=e||window.event;return!!f(t.target)||(1<t.touches.length||(t.preventDefault&&t.preventDefault(),!1))},o=function(){setTimeout(function(){void 0!==v&&(document.body.style.paddingRight=v,v=void 0),void 0!==s&&(document.body.style.overflow=s,s=void 0)})};exports.disableBodyScroll=function(i,e){if(d){if(!i)return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");if(i&&!c.some(function(e){return e.targetElement===i})){var t={targetElement:i,options:e||{}};c=[].concat(r(c),[t]),i.ontouchstart=function(e){1===e.targetTouches.length&&(a=e.targetTouches[0].clientY)},i.ontouchmove=function(e){var t,o,n,r;1===e.targetTouches.length&&(o=i,r=(t=e).targetTouches[0].clientY-a,!f(t.target)&&(o&&0===o.scrollTop&&0<r?m(t):(n=o)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&r<0?m(t):t.stopPropagation()))},u||(document.addEventListener("touchmove",m,l?{passive:!1}:void 0),u=!0)}}else{n=e,setTimeout(function(){if(void 0===v){var e=!!n&&!0===n.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;e&&0<t&&(v=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===s&&(s=document.body.style.overflow,document.body.style.overflow="hidden")});var o={targetElement:i,options:e||{}};c=[].concat(r(c),[o])}var n},exports.clearAllBodyScrollLocks=function(){d?(c.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),u&&(document.removeEventListener("touchmove",m,l?{passive:!1}:void 0),u=!1),c=[],a=-1):(o(),c=[])},exports.enableBodyScroll=function(t){if(d){if(!t)return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");t.ontouchstart=null,t.ontouchmove=null,c=c.filter(function(e){return e.targetElement!==t}),u&&0===c.length&&(document.removeEventListener("touchmove",m,l?{passive:!1}:void 0),u=!1)}else(c=c.filter(function(e){return e.targetElement!==t})).length||o()}});

// infinite scrolling (https://github.com/webcreate/infinite-ajax-scroll/tree/2.x)
!function(t,e){"function"==typeof define&&define.amd?define("jquery-bridget/jquery-bridget",["jquery"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("jquery")):t.jQueryBridget=e(t,t.jQuery)}(window,function(t,e){"use strict";function i(i,r,l){function a(t,e,n){var o,r="$()."+i+'("'+e+'")';return t.each(function(t,a){var h=l.data(a,i);if(!h)return void s(i+" not initialized. Cannot call methods, i.e. "+r);var c=h[e];if(!c||"_"==e.charAt(0))return void s(r+" is not a valid method");var u=c.apply(h,n);o=void 0===o?u:o}),void 0!==o?o:t}function h(t,e){t.each(function(t,n){var o=l.data(n,i);o?(o.option(e),o._init()):(o=new r(n,e),l.data(n,i,o))})}l=l||e||t.jQuery,l&&(r.prototype.option||(r.prototype.option=function(t){l.isPlainObject(t)&&(this.options=l.extend(!0,this.options,t))}),l.fn[i]=function(t){if("string"==typeof t){var e=o.call(arguments,1);return a(this,t,e)}return h(this,t),this},n(l))}function n(t){!t||t&&t.bridget||(t.bridget=i)}var o=Array.prototype.slice,r=t.console,s="undefined"==typeof r?function(){}:function(t){r.error(t)};return n(e||t.jQuery),i}),function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},n=i[t]=i[t]||[];return n.indexOf(e)==-1&&n.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{},n=i[t]=i[t]||{};return n[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=i.indexOf(e);return n!=-1&&i.splice(n,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){i=i.slice(0),e=e||[];for(var n=this._onceEvents&&this._onceEvents[t],o=0;o<i.length;o++){var r=i[o],s=n&&n[r];s&&(this.off(t,r),delete n[r]),r.apply(this,e)}return this}},e.allOff=function(){delete this._events,delete this._onceEvents},t}),function(t,e){"use strict";"function"==typeof define&&define.amd?define("desandro-matches-selector/matches-selector",e):"object"==typeof module&&module.exports?module.exports=e():t.matchesSelector=e()}(window,function(){"use strict";var t=function(){var t=window.Element.prototype;if(t.matches)return"matches";if(t.matchesSelector)return"matchesSelector";for(var e=["webkit","moz","ms","o"],i=0;i<e.length;i++){var n=e[i],o=n+"MatchesSelector";if(t[o])return o}}();return function(e,i){return e[t](i)}}),function(t,e){"function"==typeof define&&define.amd?define("fizzy-ui-utils/utils",["desandro-matches-selector/matches-selector"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("desandro-matches-selector")):t.fizzyUIUtils=e(t,t.matchesSelector)}(window,function(t,e){var i={};i.extend=function(t,e){for(var i in e)t[i]=e[i];return t},i.modulo=function(t,e){return(t%e+e)%e};var n=Array.prototype.slice;i.makeArray=function(t){if(Array.isArray(t))return t;if(null===t||void 0===t)return[];var e="object"==typeof t&&"number"==typeof t.length;return e?n.call(t):[t]},i.removeFrom=function(t,e){var i=t.indexOf(e);i!=-1&&t.splice(i,1)},i.getParent=function(t,i){for(;t.parentNode&&t!=document.body;)if(t=t.parentNode,e(t,i))return t},i.getQueryElement=function(t){return"string"==typeof t?document.querySelector(t):t},i.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},i.filterFindElements=function(t,n){t=i.makeArray(t);var o=[];return t.forEach(function(t){if(t instanceof HTMLElement){if(!n)return void o.push(t);e(t,n)&&o.push(t);for(var i=t.querySelectorAll(n),r=0;r<i.length;r++)o.push(i[r])}}),o},i.debounceMethod=function(t,e,i){i=i||100;var n=t.prototype[e],o=e+"Timeout";t.prototype[e]=function(){var t=this[o];clearTimeout(t);var e=arguments,r=this;this[o]=setTimeout(function(){n.apply(r,e),delete r[o]},i)}},i.docReady=function(t){var e=document.readyState;"complete"==e||"interactive"==e?setTimeout(t):document.addEventListener("DOMContentLoaded",t)},i.toDashed=function(t){return t.replace(/(.)([A-Z])/g,function(t,e,i){return e+"-"+i}).toLowerCase()};var o=t.console;return i.htmlInit=function(e,n){i.docReady(function(){var r=i.toDashed(n),s="data-"+r,l=document.querySelectorAll("["+s+"]"),a=document.querySelectorAll(".js-"+r),h=i.makeArray(l).concat(i.makeArray(a)),c=s+"-options",u=t.jQuery;h.forEach(function(t){var i,r=t.getAttribute(s)||t.getAttribute(c);try{i=r&&JSON.parse(r)}catch(l){return void(o&&o.error("Error parsing "+s+" on "+t.className+": "+l))}var a=new e(t,i);u&&u.data(t,n,a)})})},i}),function(t,e){"function"==typeof define&&define.amd?define("infinite-scroll/js/core",["ev-emitter/ev-emitter","fizzy-ui-utils/utils"],function(i,n){return e(t,i,n)}):"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter"),require("fizzy-ui-utils")):t.InfiniteScroll=e(t,t.EvEmitter,t.fizzyUIUtils)}(window,function(t,e,i){function n(t,e){var s=i.getQueryElement(t);if(!s)return void console.error("Bad element for InfiniteScroll: "+(s||t));if(t=s,t.infiniteScrollGUID){var l=r[t.infiniteScrollGUID];return l.option(e),l}this.element=t,this.options=i.extend({},n.defaults),this.option(e),o&&(this.$element=o(this.element)),this.create()}var o=t.jQuery,r={};n.defaults={},n.create={},n.destroy={};var s=n.prototype;i.extend(s,e.prototype);var l=0;s.create=function(){var t=this.guid=++l;this.element.infiniteScrollGUID=t,r[t]=this,this.pageIndex=1,this.loadCount=0,this.updateGetPath();var e=this.getPath&&this.getPath();if(!e)return void console.error("Disabling InfiniteScroll");this.updateGetAbsolutePath(),this.log("initialized",[this.element.className]),this.callOnInit();for(var i in n.create)n.create[i].call(this)},s.option=function(t){i.extend(this.options,t)},s.callOnInit=function(){var t=this.options.onInit;t&&t.call(this,this)},s.dispatchEvent=function(t,e,i){this.log(t,i);var n=e?[e].concat(i):i;if(this.emitEvent(t,n),o&&this.$element){t+=".infiniteScroll";var r=t;if(e){var s=o.Event(e);s.type=t,r=s}this.$element.trigger(r,i)}};var a={initialized:function(t){return"on "+t},request:function(t){return"URL: "+t},load:function(t,e){return(t.title||"")+". URL: "+e},error:function(t,e){return t+". URL: "+e},append:function(t,e,i){return i.length+" items. URL: "+e},last:function(t,e){return"URL: "+e},history:function(t,e){return"URL: "+e},pageIndex:function(t,e){return"current page determined to be: "+t+" from "+e}};s.log=function(t,e){if(this.options.debug){var i="[InfiniteScroll] "+t,n=a[t];n&&(i+=". "+n.apply(this,e)),console.log(i)}},s.updateMeasurements=function(){this.windowHeight=t.innerHeight;var e=this.element.getBoundingClientRect();this.top=e.top+t.pageYOffset},s.updateScroller=function(){var e=this.options.elementScroll;if(!e)return void(this.scroller=t);if(this.scroller=e===!0?this.element:i.getQueryElement(e),!this.scroller)throw"Unable to find elementScroll: "+e},s.updateGetPath=function(){var t=this.options.path;if(!t)return void console.error("InfiniteScroll path option required. Set as: "+t);var e=typeof t;if("function"==e)return void(this.getPath=t);var i="string"==e&&t.match("\{\{#}}");return i?void this.updateGetPathTemplate(t):void this.updateGetPathSelector(t)},s.updateGetPathTemplate=function(t){this.getPath=function(){var e=this.pageIndex+1;return t.replace("\{\{#}}",e)}.bind(this);var e=t.replace(/(\\\?|\?)/,"\\?").replace("\{\{#}}","(\\d\\d?\\d?)"),i=new RegExp(e),n=location.href.match(i);n&&(this.pageIndex=parseInt(n[1],10),this.log("pageIndex",[this.pageIndex,"template string"]))};var h=[/^(.*?\/?page\/?)(\d\d?\d?)(.*?$)/,/^(.*?\/?\?page=)(\d\d?\d?)(.*?$)/,/(.*?)(\d\d?\d?)(?!.*\d)(.*?$)/];return s.updateGetPathSelector=function(t){var e=document.querySelector(t);if(!e)return void console.error("Bad InfiniteScroll path option. Next link not found: "+t);for(var i,n,o=e.getAttribute("href"),r=0;o&&r<h.length;r++){n=h[r];var s=o.match(n);if(s){i=s.slice(1);break}}return i?(this.isPathSelector=!0,this.getPath=function(){var t=this.pageIndex+1;return i[0]+t+i[2]}.bind(this),this.pageIndex=parseInt(i[1],10)-1,void this.log("pageIndex",[this.pageIndex,"next link"])):void console.error("InfiniteScroll unable to parse next link href: "+o)},s.updateGetAbsolutePath=function(){var t=this.getPath(),e=t.match(/^http/)||t.match(/^\//);if(e)return void(this.getAbsolutePath=this.getPath);var i=location.pathname,n=t.match(/^\?/);if(n)return void(this.getAbsolutePath=function(){return i+this.getPath()});var o=i.substring(0,i.lastIndexOf("/"));this.getAbsolutePath=function(){return o+"/"+this.getPath()}},n.create.hideNav=function(){var t=i.getQueryElement(this.options.hideNav);t&&(t.style.display="none",this.nav=t)},n.destroy.hideNav=function(){this.nav&&(this.nav.style.display="")},s.destroy=function(){this.allOff();for(var t in n.destroy)n.destroy[t].call(this);delete this.element.infiniteScrollGUID,delete r[this.guid],o&&this.$element&&o.removeData(this.element,"infiniteScroll")},n.throttle=function(t,e){e=e||200;var i,n;return function(){var o=+new Date,r=arguments,s=function(){i=o,t.apply(this,r)}.bind(this);i&&o<i+e?(clearTimeout(n),n=setTimeout(s,e)):s()}},n.data=function(t){t=i.getQueryElement(t);var e=t&&t.infiniteScrollGUID;return e&&r[e]},n.setJQuery=function(t){o=t},i.htmlInit(n,"infinite-scroll"),s._init=function(){},o&&o.bridget&&o.bridget("infiniteScroll",n),n}),function(t,e){"function"==typeof define&&define.amd?define("infinite-scroll/js/page-load",["./core"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("./core")):e(t,t.InfiniteScroll)}(window,function(t,e){function i(t){for(var e=document.createDocumentFragment(),i=0;t&&i<t.length;i++)e.appendChild(t[i]);return e}function n(t){for(var e=t.querySelectorAll("script"),i=0;i<e.length;i++){var n=e[i],r=document.createElement("script");o(n,r),r.innerHTML=n.innerHTML,n.parentNode.replaceChild(r,n)}}function o(t,e){for(var i=t.attributes,n=0;n<i.length;n++){var o=i[n];e.setAttribute(o.name,o.value)}}function r(t,e,i,n,o){var r=new XMLHttpRequest;r.open("GET",t,!0),r.responseType=e||"",r.setRequestHeader("X-Requested-With","XMLHttpRequest"),r.onload=function(){if(200==r.status)i(r.response);else if(204==r.status)o(r.response);else{var t=new Error(r.statusText);n(t)}},r.onerror=function(){var e=new Error("Network error requesting "+t);n(e)},r.send()}var s=e.prototype;return e.defaults.loadOnScroll=!0,e.defaults.checkLastPage=!0,e.defaults.responseType="document",e.create.pageLoad=function(){this.canLoad=!0,this.on("scrollThreshold",this.onScrollThresholdLoad),this.on("load",this.checkLastPage),this.options.outlayer&&this.on("append",this.onAppendOutlayer)},s.onScrollThresholdLoad=function(){this.options.loadOnScroll&&this.loadNextPage()},s.loadNextPage=function(){if(!this.isLoading&&this.canLoad){var t=this.getAbsolutePath();this.isLoading=!0;var e=function(e){this.onPageLoad(e,t)}.bind(this),i=function(e){this.onPageError(e,t)}.bind(this),n=function(e){this.lastPageReached(e,t)}.bind(this);r(t,this.options.responseType,e,i,n),this.dispatchEvent("request",null,[t])}},s.onPageLoad=function(t,e){return this.options.append||(this.isLoading=!1),this.pageIndex++,this.loadCount++,this.dispatchEvent("load",null,[t,e]),this.appendNextPage(t,e),t},s.appendNextPage=function(t,e){var n=this.options.append,o="document"==this.options.responseType;if(o&&n){var r=t.querySelectorAll(n),s=i(r),l=function(){this.appendItems(r,s),this.isLoading=!1,this.dispatchEvent("append",null,[t,e,r])}.bind(this);this.options.outlayer?this.appendOutlayerItems(s,l):l()}},s.appendItems=function(t,e){t&&t.length&&(e=e||i(t),n(e),this.element.appendChild(e))},s.appendOutlayerItems=function(i,n){var o=e.imagesLoaded||t.imagesLoaded;return o?void o(i,n):(console.error("[InfiniteScroll] imagesLoaded required for outlayer option"),void(this.isLoading=!1))},s.onAppendOutlayer=function(t,e,i){this.options.outlayer.appended(i)},s.checkLastPage=function(t,e){var i=this.options.checkLastPage;if(i){var n=this.options.path;if("function"==typeof n){var o=this.getPath();if(!o)return void this.lastPageReached(t,e)}var r;if("string"==typeof i?r=i:this.isPathSelector&&(r=n),r&&t.querySelector){var s=t.querySelector(r);s||this.lastPageReached(t,e)}}},s.lastPageReached=function(t,e){this.canLoad=!1,this.dispatchEvent("last",null,[t,e])},s.onPageError=function(t,e){return this.isLoading=!1,this.canLoad=!1,this.dispatchEvent("error",null,[t,e]),t},e.create.prefill=function(){if(this.options.prefill){var t=this.options.append;if(!t)return void console.error("append option required for prefill. Set as :"+t);this.updateMeasurements(),this.updateScroller(),this.isPrefilling=!0,this.on("append",this.prefill),this.once("error",this.stopPrefill),this.once("last",this.stopPrefill),this.prefill()}},s.prefill=function(){var t=this.getPrefillDistance();this.isPrefilling=t>=0,this.isPrefilling?(this.log("prefill"),this.loadNextPage()):this.stopPrefill()},s.getPrefillDistance=function(){return this.options.elementScroll?this.scroller.clientHeight-this.scroller.scrollHeight:this.windowHeight-this.element.clientHeight},s.stopPrefill=function(){this.log("stopPrefill"),this.off("append",this.prefill)},e}),function(t,e){"function"==typeof define&&define.amd?define("infinite-scroll/js/scroll-watch",["./core","fizzy-ui-utils/utils"],function(i,n){return e(t,i,n)}):"object"==typeof module&&module.exports?module.exports=e(t,require("./core"),require("fizzy-ui-utils")):e(t,t.InfiniteScroll,t.fizzyUIUtils)}(window,function(t,e,i){var n=e.prototype;return e.defaults.scrollThreshold=400,e.create.scrollWatch=function(){this.pageScrollHandler=this.onPageScroll.bind(this),this.resizeHandler=this.onResize.bind(this);var t=this.options.scrollThreshold,e=t||0===t;e&&this.enableScrollWatch()},e.destroy.scrollWatch=function(){this.disableScrollWatch()},n.enableScrollWatch=function(){this.isScrollWatching||(this.isScrollWatching=!0,this.updateMeasurements(),this.updateScroller(),this.on("last",this.disableScrollWatch),this.bindScrollWatchEvents(!0))},n.disableScrollWatch=function(){this.isScrollWatching&&(this.bindScrollWatchEvents(!1),delete this.isScrollWatching)},n.bindScrollWatchEvents=function(e){var i=e?"addEventListener":"removeEventListener";this.scroller[i]("scroll",this.pageScrollHandler),t[i]("resize",this.resizeHandler)},n.onPageScroll=e.throttle(function(){var t=this.getBottomDistance();t<=this.options.scrollThreshold&&this.dispatchEvent("scrollThreshold")}),n.getBottomDistance=function(){return this.options.elementScroll?this.getElementBottomDistance():this.getWindowBottomDistance()},n.getWindowBottomDistance=function(){var e=this.top+this.element.clientHeight,i=t.pageYOffset+this.windowHeight;return e-i},n.getElementBottomDistance=function(){var t=this.scroller.scrollHeight,e=this.scroller.scrollTop+this.scroller.clientHeight;return t-e},n.onResize=function(){this.updateMeasurements()},i.debounceMethod(e,"onResize",150),e}),function(t,e){"function"==typeof define&&define.amd?define("infinite-scroll/js/history",["./core","fizzy-ui-utils/utils"],function(i,n){return e(t,i,n)}):"object"==typeof module&&module.exports?module.exports=e(t,require("./core"),require("fizzy-ui-utils")):e(t,t.InfiniteScroll,t.fizzyUIUtils)}(window,function(t,e,i){var n=e.prototype;e.defaults.history="replace";var o=document.createElement("a");return e.create.history=function(){if(this.options.history){o.href=this.getAbsolutePath();var t=o.origin||o.protocol+"//"+o.host,e=t==location.origin;return e?void(this.options.append?this.createHistoryAppend():this.createHistoryPageLoad()):void console.error("[InfiniteScroll] cannot set history with different origin: "+o.origin+" on "+location.origin+" . History behavior disabled.")}},n.createHistoryAppend=function(){this.updateMeasurements(),this.updateScroller(),this.scrollPages=[{top:0,path:location.href,title:document.title}],this.scrollPageIndex=0,this.scrollHistoryHandler=this.onScrollHistory.bind(this),this.unloadHandler=this.onUnload.bind(this),this.scroller.addEventListener("scroll",this.scrollHistoryHandler),this.on("append",this.onAppendHistory),this.bindHistoryAppendEvents(!0)},n.bindHistoryAppendEvents=function(e){var i=e?"addEventListener":"removeEventListener";this.scroller[i]("scroll",this.scrollHistoryHandler),t[i]("unload",this.unloadHandler)},n.createHistoryPageLoad=function(){this.on("load",this.onPageLoadHistory)},e.destroy.history=n.destroyHistory=function(){var t=this.options.history&&this.options.append;t&&this.bindHistoryAppendEvents(!1)},n.onAppendHistory=function(t,e,i){if(i&&i.length){var n=i[0],r=this.getElementScrollY(n);o.href=e,this.scrollPages.push({top:r,path:o.href,title:t.title})}},n.getElementScrollY=function(t){return this.options.elementScroll?this.getElementElementScrollY(t):this.getElementWindowScrollY(t)},n.getElementWindowScrollY=function(e){var i=e.getBoundingClientRect();return i.top+t.pageYOffset},n.getElementElementScrollY=function(t){return t.offsetTop-this.top},n.onScrollHistory=function(){for(var t,e,i=this.getScrollViewY(),n=0;n<this.scrollPages.length;n++){var o=this.scrollPages[n];if(o.top>=i)break;t=n,e=o}t!=this.scrollPageIndex&&(this.scrollPageIndex=t,this.setHistory(e.title,e.path))},i.debounceMethod(e,"onScrollHistory",150),n.getScrollViewY=function(){return this.options.elementScroll?this.scroller.scrollTop+this.scroller.clientHeight/2:t.pageYOffset+this.windowHeight/2},n.setHistory=function(t,e){var i=this.options.history,n=i&&history[i+"State"];n&&(history[i+"State"](null,t,e),this.options.historyTitle&&(document.title=t),this.dispatchEvent("history",null,[t,e]))},n.onUnload=function(){var e=this.scrollPageIndex;if(0!==e){var i=this.scrollPages[e],n=t.pageYOffset-i.top+this.top;this.destroyHistory(),scrollTo(0,n)}},n.onPageLoadHistory=function(t,e){this.setHistory(t.title,e)},e}),function(t,e){"function"==typeof define&&define.amd?define("infinite-scroll/js/button",["./core","fizzy-ui-utils/utils"],function(i,n){return e(t,i,n)}):"object"==typeof module&&module.exports?module.exports=e(t,require("./core"),require("fizzy-ui-utils")):e(t,t.InfiniteScroll,t.fizzyUIUtils)}(window,function(t,e,i){function n(t,e){this.element=t,this.infScroll=e,this.clickHandler=this.onClick.bind(this),this.element.addEventListener("click",this.clickHandler),e.on("request",this.disable.bind(this)),e.on("load",this.enable.bind(this)),e.on("error",this.hide.bind(this)),e.on("last",this.hide.bind(this))}return e.create.button=function(){var t=i.getQueryElement(this.options.button);if(t)return void(this.button=new n(t,this))},e.destroy.button=function(){this.button&&this.button.destroy()},n.prototype.onClick=function(t){t.preventDefault(),this.infScroll.loadNextPage()},n.prototype.enable=function(){this.element.removeAttribute("disabled")},n.prototype.disable=function(){this.element.disabled="disabled"},n.prototype.hide=function(){this.element.style.display="none"},n.prototype.destroy=function(){this.element.removeEventListener("click",this.clickHandler)},e.Button=n,e}),function(t,e){"function"==typeof define&&define.amd?define("infinite-scroll/js/status",["./core","fizzy-ui-utils/utils"],function(i,n){return e(t,i,n)}):"object"==typeof module&&module.exports?module.exports=e(t,require("./core"),require("fizzy-ui-utils")):e(t,t.InfiniteScroll,t.fizzyUIUtils)}(window,function(t,e,i){function n(t){r(t,"none")}function o(t){r(t,"block")}function r(t,e){t&&(t.style.display=e)}var s=e.prototype;return e.create.status=function(){var t=i.getQueryElement(this.options.status);t&&(this.statusElement=t,this.statusEventElements={request:t.querySelector(".infinite-scroll-request"),error:t.querySelector(".infinite-scroll-error"),last:t.querySelector(".infinite-scroll-last")},this.on("request",this.showRequestStatus),this.on("error",this.showErrorStatus),this.on("last",this.showLastStatus),this.bindHideStatus("on"))},s.bindHideStatus=function(t){var e=this.options.append?"append":"load";this[t](e,this.hideAllStatus)},s.showRequestStatus=function(){this.showStatus("request")},s.showErrorStatus=function(){this.showStatus("error")},s.showLastStatus=function(){this.showStatus("last"),this.bindHideStatus("off")},s.showStatus=function(t){o(this.statusElement),this.hideStatusEventElements();var e=this.statusEventElements[t];o(e)},s.hideAllStatus=function(){n(this.statusElement),this.hideStatusEventElements()},s.hideStatusEventElements=function(){for(var t in this.statusEventElements){var e=this.statusEventElements[t];n(e)}},e}),function(t,e){"function"==typeof define&&define.amd?define(["infinite-scroll/js/core","infinite-scroll/js/page-load","infinite-scroll/js/scroll-watch","infinite-scroll/js/history","infinite-scroll/js/button","infinite-scroll/js/status"],e):"object"==typeof module&&module.exports&&(module.exports=e(require("./core"),require("./page-load"),require("./scroll-watch"),require("./history"),require("./button"),require("./status")))}(window,function(t){return t}),function(t,e){"use strict";"function"==typeof define&&define.amd?define("imagesloaded/imagesloaded",["ev-emitter/ev-emitter"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter")):t.imagesLoaded=e(t,t.EvEmitter)}("undefined"!=typeof window?window:this,function(t,e){function i(t,e){for(var i in e)t[i]=e[i];return t}function n(t){if(Array.isArray(t))return t;var e="object"==typeof t&&"number"==typeof t.length;return e?h.call(t):[t]}function o(t,e,r){if(!(this instanceof o))return new o(t,e,r);var s=t;return"string"==typeof t&&(s=document.querySelectorAll(t)),s?(this.elements=n(s),this.options=i({},this.options),"function"==typeof e?r=e:i(this.options,e),r&&this.on("always",r),this.getImages(),l&&(this.jqDeferred=new l.Deferred),void setTimeout(this.check.bind(this))):void a.error("Bad element for imagesLoaded "+(s||t))}function r(t){this.img=t}function s(t,e){this.url=t,this.element=e,this.img=new Image}var l=t.jQuery,a=t.console,h=Array.prototype.slice;o.prototype=Object.create(e.prototype),o.prototype.options={},o.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},o.prototype.addElementImages=function(t){"IMG"==t.nodeName&&this.addImage(t),this.options.background===!0&&this.addElementBackgroundImages(t);var e=t.nodeType;if(e&&c[e]){for(var i=t.querySelectorAll("img"),n=0;n<i.length;n++){var o=i[n];this.addImage(o)}if("string"==typeof this.options.background){var r=t.querySelectorAll(this.options.background);for(n=0;n<r.length;n++){var s=r[n];this.addElementBackgroundImages(s)}}}};var c={1:!0,9:!0,11:!0};return o.prototype.addElementBackgroundImages=function(t){var e=getComputedStyle(t);if(e)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(e.backgroundImage);null!==n;){var o=n&&n[2];o&&this.addBackground(o,t),n=i.exec(e.backgroundImage)}},o.prototype.addImage=function(t){var e=new r(t);this.images.push(e)},o.prototype.addBackground=function(t,e){var i=new s(t,e);this.images.push(i)},o.prototype.check=function(){function t(t,i,n){setTimeout(function(){e.progress(t,i,n)})}var e=this;return this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?void this.images.forEach(function(e){e.once("progress",t),e.check()}):void this.complete()},o.prototype.progress=function(t,e,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!t.isLoaded,this.emitEvent("progress",[this,t,e]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,t),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&a&&a.log("progress: "+i,t,e)},o.prototype.complete=function(){var t=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(t,[this]),this.emitEvent("always",[this]),this.jqDeferred){var e=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[e](this)}},r.prototype=Object.create(e.prototype),r.prototype.check=function(){var t=this.getIsImageComplete();return t?void this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),void(this.proxyImage.src=this.img.src))},r.prototype.getIsImageComplete=function(){return this.img.complete&&this.img.naturalWidth},r.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.img,e])},r.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},r.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},r.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},r.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype=Object.create(r.prototype),s.prototype.check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url;var t=this.getIsImageComplete();t&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},s.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.element,e])},o.makeJQueryPlugin=function(e){e=e||t.jQuery,e&&(l=e,l.fn.imagesLoaded=function(t,e){var i=new o(this,t,e);return i.jqDeferred.promise(l(this))})},o.makeJQueryPlugin(),o});

// sticky elements (https://github.com/ppowalowski/stickUp2)
!function(t,e,o){function s(s,i){function r(){return"auto"===O.topMargin?parseInt(U.css("marginTop")):isNaN(O.topMargin)&&0<O.topMargin.search("px")?parseInt(O.topMargin.replace("px","")):isNaN(parseInt(O.topMargin))?(console.log("incorrect argument, ignored."),0):parseInt(O.topMargin)}function n(){var t={cancel:!1};U.trigger("stickUp:beforeUnstick",[t]),t.cancel||(N.remove(),U.removeClass(O.fixedClass).css({maxWidth:"",marginTop:"",marginLeft:"",marginRight:"",position:"",top:"",left:"",right:"",bottom:"",width:""}),b=I=h=!1,O.syncPosition&&j(),U.trigger("stickUp:unstick"))}function a(t){U.before(N.css("height",W));var e=N.offsetParent();if(t){U.css({position:"absolute"});var o=P.offset().top+P.outerHeight()-e.offset().top-w-parseInt(P.css("paddingBottom"))}U.css({position:"absolute",marginTop:T,bottom:"",left:N.position().left,top:t?o:U.offset().top-e.offset().top-T})}function p(){var t={cancel:!1};if(U.trigger("stickUp:beforeStick",[t]),!t.cancel){h=!0,U.before(N.css("height",W)),U.addClass(O.fixedClass);var e=-S;U.css({marginTop:T,position:"fixed",top:e+"px",left:"",right:"",bottom:""}),U.trigger("stickUp:stick")}}function c(s){if(O.disableOn()){if(k=k&&!1,!O.keepInWrapper||P.is(":visible")){if(m=t(s.target).scrollTop(),u=l<=m?"down":"up",d=Math.abs(l-m),y=t(e).outerHeight(),z=m+y,l=m,C=U.offset().top,H=parseInt(U.outerHeight()+T)+parseInt(U.css("marginBottom")),h||b||I||(W=parseInt(U.outerHeight(!0)),B.top=I||b?parseInt(N.offset().top):parseInt(U.offset().top),g=parseInt(U.offset().left)+5),w=parseInt(U.outerHeight())+parseInt(U.css("margin-bottom"))+T,O.keepInWrapper?B.bottom=P.offset().top+P.outerHeight()-parseInt(P.css("paddingBottom")):B.bottom=t(o).outerHeight(),M=U.offset().top+w,y<H)v=!0,x&&(S=0,b&&a(),x=!1),b&&"up"===u&&m<=C-T&&(p(),b=I=!(h=!0)),!h&&!I&&(!O.keepInWrapper||O.keepInWrapper&&z<=B.bottom)&&M-T<=z&&(function(){U.before(N.css("height",W)),U.addClass(O.fixedClass);var t=-S;U.css({marginTop:T,position:"fixed",top:"",left:"",right:"",bottom:t})}(),b=!(h=I=!0)),(!b&&h&&I&&"up"===u||!b&&h&&!I&&"down"===u&&z<=M)&&(a(),b=!(I=h=!1)),z>=B.bottom&&O.keepInWrapper&&(!I&&!b||parseInt(M-T)!==parseInt(B.bottom))&&(a(!0),b=I=!(h=!1));else if(x=!0,v&&(b&&a(),v=!1),S=O.scrollHide?H+O.lazyHeight:O.lazyHeight,(!h&&!I&&m>=B.top-T+S||I&&b&&m<=C-T+S)&&(p(),b=I=!(h=!0)),O.keepInWrapper&&parseInt(M-T)!==parseInt(B.bottom)&&m>=B.bottom-w+S&&(a(!0),b=I=!(h=!1)),h){var i=parseInt(U.css("top"));if("up"===u&&0!==i){var r=-i<d?0:i+d;U.css("top",r+"px")}else"down"===u&&-S<i&&(r=S+i<d?-S:i-d,U.css("top",r+"px"))}(h||b||I)&&m<=B.top-T&&n(),(h||b||I)&&N.width()!==U.outerWidth()&&U.outerWidth(N.outerWidth()),(O.syncPosition&&h||b)&&(g=N.offset().left,U.offset().left,U.offset({left:g})),U.trigger("stickUp:scroll")}}else k||(n(),k=!0)}function f(t){U.trigger("stickUp:resize",O),T=null!==O.topMargin?r():0,b&&(a(),I=!1),c(t)}var g,l=0,m=0,u="",d=0,h=!1,I=!1,b=!1,k=!1,x=!1,v=!1,H=0,W=0,w=0,y=0,z=0,C=0,M=0,U=t(),T=0,S=0,N=t('<div style="margin-top:0;margin-bottom:0; padding:0"></div>'),P=t(),B={top:0,bottom:0,custom:[]},O={scrollHide:!1,lazyHeight:0,topMargin:"auto",keepInWrapper:!1,wrapperSelector:"",zIndex:99,syncPosition:!1,namespaceClass:"stuckElement",fixedClass:"isStuck",disableOn:function(){return!0}},j=function(){N.css({"margin-left":U.css("margin-left"),"margin-right":U.css("margin-left")}),U.css({"margin-left":N.css("margin-left"),"margin-right":N.css("margin-right")})};(function(s,i){(U=t(s)).addClass(O.namespaceClass),i&&t.extend(!0,O,i),T=null!==O.topMargin?r():0,O.lazyHeight&&(T+=O.lazyHeight),O.keepInWrapper?(""!==O.wrapperSelector&&(P=U.closest(O.wrapperSelector)),P.length||(P=U.parent())):P=t("body"),O.zIndex&&U.css("z-index",O.zIndex),j(),t(e).on("scroll.stickUp",c),t(e).on("resize.stickUp",f),c({target:o})}).call(this,s,i)}t.fn.stickUp=function(t){return this.each(function(){new s(this,t)})}}(jQuery,window,document);

// smooth automatic scrolling (https://github.com/iamdustan/smoothscroll)
function isMicrosoftBrowser(o){var t=["MSIE ","Trident/","Edge/"];return new RegExp(t.join("|")).test(o)}function polyfill(){function o(o,t){this.scrollLeft=o,this.scrollTop=t}function t(o){return.5*(1-Math.cos(Math.PI*o))}function l(o){if(null===o||"object"!=typeof o||void 0===o.behavior||"auto"===o.behavior||"instant"===o.behavior)return!0;if("object"==typeof o&&"smooth"===o.behavior)return!1;throw new TypeError("behavior member of ScrollOptions "+o.behavior+" is not a valid value for enumeration ScrollBehavior.")}function e(o,t){return"Y"===t?o.clientHeight+a<o.scrollHeight:"X"===t?o.clientWidth+a<o.scrollWidth:void 0}function r(o,t){var l=w.getComputedStyle(o,null)["overflow"+t];return"auto"===l||"scroll"===l}function i(o){var t=e(o,"Y")&&r(o,"Y"),l=e(o,"X")&&r(o,"X");return t||l}function s(o){var t;do{o=o.parentNode,t=o===d.body}while(!1===t&&!1===i(o));return t=null,o}function c(o){var l,e,r,i=h(),s=(i-o.startTime)/p;s=s>1?1:s,l=t(s),e=o.startX+(o.x-o.startX)*l,r=o.startY+(o.y-o.startY)*l,o.method.call(o.scrollable,e,r),e===o.x&&r===o.y||w.requestAnimationFrame(c.bind(w,o))}function n(t,l,e){var r,i,s,n,f=h();t===d.body?(r=w,i=w.scrollX||w.pageXOffset,s=w.scrollY||w.pageYOffset,n=v.scroll):(r=t,i=t.scrollLeft,s=t.scrollTop,n=o),c({scrollable:r,method:n,startTime:f,startX:i,startY:s,x:l,y:e})}if(!("scrollBehavior"in d.documentElement.style&&!0!==w.__forceSmoothScrollPolyfill__)){var f=w.HTMLElement||w.Element,p=468,a=isMicrosoftBrowser(w.navigator.userAgent)?1:0,v={scroll:w.scroll||w.scrollTo,scrollBy:w.scrollBy,elementScroll:f.prototype.scroll||o,scrollIntoView:f.prototype.scrollIntoView},h=w.performance&&w.performance.now?w.performance.now.bind(w.performance):Date.now;w.scroll=w.scrollTo=function(){void 0!==arguments[0]&&(!0!==l(arguments[0])?n.call(w,d.body,void 0!==arguments[0].left?~~arguments[0].left:w.scrollX||w.pageXOffset,void 0!==arguments[0].top?~~arguments[0].top:w.scrollY||w.pageYOffset):v.scroll.call(w,void 0!==arguments[0].left?arguments[0].left:"object"!=typeof arguments[0]?arguments[0]:w.scrollX||w.pageXOffset,void 0!==arguments[0].top?arguments[0].top:void 0!==arguments[1]?arguments[1]:w.scrollY||w.pageYOffset))},w.scrollBy=function(){void 0!==arguments[0]&&(l(arguments[0])?v.scrollBy.call(w,void 0!==arguments[0].left?arguments[0].left:"object"!=typeof arguments[0]?arguments[0]:0,void 0!==arguments[0].top?arguments[0].top:void 0!==arguments[1]?arguments[1]:0):n.call(w,d.body,~~arguments[0].left+(w.scrollX||w.pageXOffset),~~arguments[0].top+(w.scrollY||w.pageYOffset)))},f.prototype.scroll=f.prototype.scrollTo=function(){if(void 0!==arguments[0])if(!0!==l(arguments[0])){var o=arguments[0].left,t=arguments[0].top;n.call(this,this,void 0===o?this.scrollLeft:~~o,void 0===t?this.scrollTop:~~t)}else{if("number"==typeof arguments[0]&&void 0===arguments[1])throw new SyntaxError("Value couldn't be converted");v.elementScroll.call(this,void 0!==arguments[0].left?~~arguments[0].left:"object"!=typeof arguments[0]?~~arguments[0]:this.scrollLeft,void 0!==arguments[0].top?~~arguments[0].top:void 0!==arguments[1]?~~arguments[1]:this.scrollTop)}},f.prototype.scrollBy=function(){void 0!==arguments[0]&&(!0!==l(arguments[0])?this.scroll({left:~~arguments[0].left+this.scrollLeft,top:~~arguments[0].top+this.scrollTop,behavior:arguments[0].behavior}):v.elementScroll.call(this,void 0!==arguments[0].left?~~arguments[0].left+this.scrollLeft:~~arguments[0]+this.scrollLeft,void 0!==arguments[0].top?~~arguments[0].top+this.scrollTop:~~arguments[1]+this.scrollTop))},f.prototype.scrollIntoView=function(){if(!0!==l(arguments[0])){var o=s(this),t=o.getBoundingClientRect(),e=this.getBoundingClientRect();o!==d.body?(n.call(this,o,o.scrollLeft+e.left-t.left,o.scrollTop+e.top-t.top),"fixed"!==w.getComputedStyle(o).position&&w.scrollBy({left:t.left,top:t.top,behavior:"smooth"})):w.scrollBy({left:e.left,top:e.top,behavior:"smooth"})}else v.scrollIntoView.call(this,void 0===arguments[0]||arguments[0])}}}var w=window,d=document;"object"==typeof exports?module.exports={polyfill:polyfill}:polyfill();



/* POLYFILLS */

// ..


/* GENERIC FUNCTIONS */

// helpers
function objectValues(object) {
	return Object.keys(object).map(function(key) {
			return object[key];
	});
}

class ClassWatcher {

		constructor(targetNode, classToWatch, classAddedCallback, classRemovedCallback) {
				this.targetNode = targetNode;
				this.classToWatch = classToWatch;
				this.classAddedCallback = classAddedCallback;
				this.classRemovedCallback = classRemovedCallback;
				this.observer = null;
				this.lastClassState = targetNode.classList.contains(this.classToWatch);

				this.mutationCallback = (mutationsList) => {
					for(let mutation of mutationsList) {
						if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
							let currentClassState = mutation.target.classList.contains(this.classToWatch);
							if(this.lastClassState !== currentClassState) {
								this.lastClassState = currentClassState;
								if(currentClassState) {
									this.classAddedCallback();
								}
								else {
									this.classRemovedCallback();
								}
							}
						}
					}
				}

				this.init();
		}

		init() {
				this.observer = new MutationObserver(this.mutationCallback);
				this.observe();
		}

		observe() {
				this.observer.observe(this.targetNode, { attributes: true });
		}

		disconnect() {
				this.observer.disconnect();
		}
}

// selecting text
function selectText(container) {
	if (document.selection) {
		var range = document.body.createTextRange();
		range.moveToElementText(container);
		range.select();
	} else if (window.getSelection) {
		var range = document.createRange();
		range.selectNode(container);
		window.getSelection().removeAllRanges();
		window.getSelection().addRange(range);
	}
}

// url parameters
function getParametersAsObject(search) {
	var pairs = search.split('&');

	var result = {};
	pairs.forEach(function(pair) {
		pair = pair.split('=');
		result[decodeURIComponent(pair[0].replace(/\+/g, '%20') || '')] = decodeURIComponent(pair[1].replace(/\+/g, '%20') || '');
	});

	return JSON.parse(JSON.stringify(result));
}
function getURLParameter(name, url) {
	if (!url) url = window.location.href;
	name = name.replace(/[\[\]]/g, '\\$&');
	var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
	results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
function removeURLParameter(name, url) {
	if (!url) url = window.location.href;
	var rtn = url.split("?")[0],
			param,
			params_arr = [],
			queryString = (url.indexOf("?") !== -1) ? url.split("?")[1] : "";
	if (queryString !== "") {
		params_arr = queryString.split("&");
		for (var i = params_arr.length - 1; i >= 0; i -= 1) {
			param = params_arr[i].split("=")[0];
			if (param === name) {
				params_arr.splice(i, 1);
			}
		}
		if (params_arr.length > 0) {
			rtn = rtn + "?" + params_arr.join("&");
		}
	}
	return rtn;
}

// text formatting
function convertToSlug(text) {
		return text.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'');
}
function timeDifference(seconds) {
	var intervalType;

	var interval = Math.floor(seconds / 31536000);
	if (interval >= 1) {
		intervalType = 'year';
	} else {
		interval = Math.floor(seconds / 2592000);
		if (interval >= 1) {
			intervalType = 'month';
		} else {
			interval = Math.floor(seconds / 86400);
			if (interval >= 1) {
				intervalType = 'day';
			} else {
				interval = Math.floor(seconds / 3600);
				if (interval >= 1) {
					intervalType = "hour";
				} else {
					interval = Math.floor(seconds / 60);
					if (interval >= 1) {
						intervalType = "minute";
					} else {
						interval = seconds;
						intervalType = "second";
					}
				}
			}
		}
	}

	if (interval > 1 || interval === 0) {
		intervalType += 's';
	}

	return interval + ' ' + intervalType;
};
function displayCurrency(amount, decimals, floor) {
	if (typeof decimals === 'undefined') decimals = 2;
	if (decimals == 0) {
		if (floor) {
			amount = Math.floor(amount / 100);
		} else {
			amount = Math.ceil(amount / 100);
		}
	} else {
		amount = (amount / 100).toFixed(decimals);
	}
	return "$" + amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}
function humanTimestamp(date, showYear) {
	if (typeof showYear === 'undefined') showYear = true;

	function ordinal_suffix_of(i) {
		var j = i % 10,
				k = i % 100;
		if (j == 1 && k != 11) {
			return i + "st";
		}
		if (j == 2 && k != 12) {
			return i + "nd";
		}
		if (j == 3 && k != 13) {
			return i + "rd";
		}
		return i + "th";
	}

		function formatAMPM(date) {
			var hours = date.getHours();
			var minutes = date.getMinutes();
			var ampm = hours >= 12 ? 'pm' : 'am';
			hours = hours % 12;
			hours = hours ? hours : 12;
			minutes = minutes < 10 ? '0'+minutes : minutes;
			var strTime = hours + ':' + minutes + '' + ampm;
			return strTime;
		}

	var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

	var dateString = days[date.getDay()] + ", " + ordinal_suffix_of(date.getDate()) + " of " + months[date.getMonth()] + (showYear ? ", " + date.getFullYear() : "");

		var timeString = formatAMPM(date);
		timeString = timeString.replace(":00", "");

	return (dateString + " at " + timeString);
}

// checks
function isInt(value) {
	return !isNaN(value) && parseInt(Number(value)) == value && !isNaN(parseInt(value, 10));
}
function isElementVisible(el) {
		var rect		 = el.getBoundingClientRect(),
				vWidth	 = window.innerWidth || doc.documentElement.clientWidth,
				vHeight	= window.innerHeight || doc.documentElement.clientHeight,
				efp			= function (x, y) { return document.elementFromPoint(x, y) };

		// Return false if it's not in the viewport
		if (rect.right < 0 || rect.bottom < 0
						|| rect.left > vWidth || rect.top > vHeight)
				return false;

		// Return true if any of its four corners are visible
		return (
					el.contains(efp(rect.left,	rect.top))
			||	el.contains(efp(rect.right, rect.top))
			||	el.contains(efp(rect.right, rect.bottom))
			||	el.contains(efp(rect.left,	rect.bottom))
		);
}
function isElementHovered(el) {
	return $(el).is(":hover");
}
function isValidDate(d) {
	return d instanceof Date && !isNaN(d);
}

// performance
function throttle(fn, wait) {
	var time = Date.now();
	return function() {
		if ((time + wait - Date.now()) < 0) {
			fn();
			time = Date.now();
		}
	}
}

// element helpers
function getPosition(el) {
	var xPos = 0;
	var yPos = 0;

	while (el) {
		if (el.tagName == "BODY") {
			// deal with browser quirks with body/window/document and page scroll
			var xScroll = el.scrollLeft || document.documentElement.scrollLeft;
			var yScroll = el.scrollTop || document.documentElement.scrollTop;

			xPos += (el.offsetLeft - xScroll + el.clientLeft);
			yPos += (el.offsetTop - yScroll + el.clientTop);
		} else {
			// for all other non-BODY elements
			xPos += (el.offsetLeft - el.scrollLeft + el.clientLeft);
			yPos += (el.offsetTop - el.scrollTop + el.clientTop);
		}

		el = el.offsetParent;
	}
	return {
		x: xPos,
		y: yPos
	};
}

/*
// filters (tags)
function addTagToURL() {}
function removeTagFromURL() {}
function toggleTagFilter(tag) {}
*/


/* FUNCTIONS */

function validateFormSubmit(form) {
	var inputs = form.querySelectorAll("input, textarea, select");
	var submitButton = form.querySelector("input[type=submit]");

	var valid = true;
	for (var i = 0; i < inputs.length; i++) {
		var input = inputs[i];

		// skip the submit button
		if (input == submitButton) {
			continue;
		}

		// invalid
		if (!input.checkValidity()) {
			valid = false;
		}
	}

	// valid
	if (valid) {
		submitButton.classList.remove("disabled");

	// invalid
	} else {
		submitButton.classList.add("disabled");
	}

}

// search bar
function searchBar(activate) {
	var bar = document.querySelector("header > form.search");
	var input = bar.querySelector(".query");

	if (activate) {
		bar.classList.add("active");
		input.focus();
	} else {
		bar.classList.remove("active");
		input.blur();
	}
}
function verifySearch(form) {
	var query = form.querySelector("[name='q']");
	query = query.value.toLowerCase().trim();

	// what's on
	if (query.includes("clinic") || query.includes("lesson")) {
		window.location.href = "/products/whats-on";
		return false;
	}
	if (query.includes("skatepark")) {
		window.location.href = "/products/whats-on";
		return false;
	}
	if (query.includes("birthday") || query.includes("party") || query.includes("parties")) {
		window.location.href = "/products/whats-on";
		return false;
	}

	switch(query) {

		/* BRANDS */
		// adidas
		case "adidas":
			window.location.href = "/collections/adidas";
			return false;

		// anti-hero
		case "anti-hero":
		case "anti hero":
		case "antihero":
			window.location.href = "/collections/antihero";
			return false;

		// baker
		case "baker":
			window.location.href = "/collections/baker";
			return false;

		// beyond
		case "beyond":
		case "beyondskate":
		case "beyond skate":
			window.location.href = "/collections/beyond";
			return false;

		// bronze
		case "bronze":
		case "bronze56k":
		case "bronze56":
		case "bronze 56k":
		case "bronze 56":
		case "56k":
			window.location.href = "/collections/bronze-56k";
			return false;

		// butter
		case "butter":
		case "buttergoods":
		case "butter goods":
			window.location.href = "/collections/butter-goods";
			return false;

		// carhartt
		case "carhartt":
		case "car hartt":
		case "carhart":
		case "car hart":
		case "carheart":
		case "car heart":
			window.location.href = "/collections/carhartt";
			return false;

		// cash only
		case "cashonly":
		case "cash only":
		case "cash-only":
			window.location.href = "/collections/cash-only";
			return false;

		// champion
		case "champion":
			window.location.href = "/collections/champion";
			return false;

		// converse
		case "converse":
			window.location.href = "/collections/converse";
			return false;

		// dickies
		case "dickies":
			window.location.href = "/collections/dickies";
			return false;

		// dime
		case "dime":
			window.location.href = "/collections/dime";
			return false;

		// element
		case "element":
			window.location.href = "/collections/element";
			return false;

		// fucking awesome
		case "fa":
		case "fucking awesome":
			window.location.href = "/collections/fucking-awesome";
			return false;

		// nike
		case "nike":
		case "nikesb":
		case "nike sb":
			window.location.href = "/collections/nike-sb";
			return false;

		// palace
		case "palace":
			window.location.href = "/collections/palace";
			return false;

		// passport
		case "pass port":
		case "passport":
		case "pass~port":
		case "pass-port":
			window.location.href = "/collections/passport";
			return false;

		// patagonia
		case "patagonia":
			window.location.href = "/collections/patagonia";
			return false;

		// polar
		case "polar":
			window.location.href = "/collections/polar";
			return false;

		// reebok
		case "reebok":
			window.location.href = "/collections/reebok";
			return false;

		// santa cruz
		case "santa cruz":
		case "santacruz":
			window.location.href = "/collections/santa-cruz";
			return false;

		// spitfire
		case "spitfire":
			window.location.href = "/collections/spitfire";
			return false;

		// stussy
		case "stussy":
			window.location.href = "/collections/stussy";
			return false;

		// thrasher
		case "thrasher":
			window.location.href = "/collections/thrasher";
			return false;

		// triple 6 clubhouse
		case "666 clubhouse":
		case "666 club":
		case "666":
		case "triple 6 clubhouse":
		case "triple 6 club":
		case "triple 6":
		case "triple six clubhouse":
		case "triple six club":
		case "triple six":
			window.location.href = "/collections/triple-6-clubhouse";
			return false;

		// vans
		case "vans":
			window.location.href = "/collections/vans";
			return false;


		/* CLOTHING */
		// beanies
		case "beanies":
		case "beanie":
		case "beenies":
		case "beenie":
		case "beany":
			window.location.href = "/collections/beanies";
			return false;

	// hats
		case "hat":
		case "hats":
			window.location.href = "/collections/hats";
			return false;

		// hoodies
		case "hood":
		case "hoodie":
		case "hoodies":
		case "hoody":
		case "pullover":
			window.location.href = "/collections/hoodies";
			return false;

	// jackets
		case "jacket":
		case "jackets":
			window.location.href = "/collections/jackets";
			return false;

	// jumpers
		case "jumper":
		case "jumpers":
			window.location.href = "/collections/hoodies-sweatshirts";
			return false;

	// jeans
		case "jean":
		case "jeans":
			window.location.href = "/collections/jeans";
			return false;

	// pants
		case "pant":
		case "pants":
			window.location.href = "/collections/jeans-pants";
			return false;

	// shirts
		case "shirt":
		case "shirts":
			window.location.href = "/collections/shirts";
			return false;

	// shoes
		case "footwear":
		case "shoe":
		case "shoes":
			window.location.href = "/collections/footwear";
			return false;

	// shorts
		case "shorts":
			window.location.href = "/collections/shorts";
			return false;

	// socks
		case "sock":
		case "socks":
			window.location.href = "/collections/socks";
			return false;

	// tees
		case "tee":
		case "tees":
		case "t-shirt":
		case "t-shirts":
		case "t shirt":
		case "t shirts":
		case "tshirt":
		case "tshirts":
		case "teeshirt":
		case "teeshirts":
		case "tee shirt":
		case "tee shirts":
			window.location.href = "/collections/t-shirts";
			return false;


		/* HARDWARE */
		// mob griptape
		case "mob":
		case "mob grip":
		case "mob griptape":
		case "mob grip tape":
		case "black grip":
		case "black griptape":
		case "black grip tape":
			window.location.href = "/products/griptape";
			return false;

		// griptape
		case "grip":
		case "griptape":
		case "grip tape":
			window.location.href = "/collections/griptape";
			return false;

		// decks
		case "deck":
		case "decks":
		case "board":
		case "boards":
			window.location.href = "/collections/decks";
			return false;

		// completes
		case "complete":
		case "completes":
		case "complete deck":
		case "complete decks":
		case "complete board":
		case "complete boards":
		case "complete skateboard":
		case "complete skateboards":
			window.location.href = "/collections/completes";
			return false;

		// skateboards: completes & decks
		case "skateboard":
		case "skateboards":
		case "skate board":
		case "skate boards":
			window.location.href = "/collections/completes-decks";
			return false;

		// longboards
		case "longboard":
		case "longboards":
		case "long board":
		case "long boards":
			window.location.href = "/collections/longboards";
			return false;

		// cruisers
		case "cruiser":
		case "cruisers":
			window.location.href = "/collections/cruisers";
			return false;

		// wheels
		case "wheel":
		case "wheels":
			window.location.href = "/collections/wheels";
			return false;

		// trucks
		case "truck":
		case "trucks":
			window.location.href = "/collections/trucks";
			return false;

		// bearings
		case "bearing":
		case "bearings":
			window.location.href = "/collections/bearings";
			return false;

		// helmets
		case "helmet":
		case "helmets":
			window.location.href = "/collections/helmets";
			return false;


		/* ACCESSORIES */
	// bags
		case "bag":
		case "bags":
			window.location.href = "/collections/bags";
			return false;

	// glasses
		case "glasses":
		case "sun glasses":
		case "sunglasses":
			window.location.href = "/collections/sunglasses";
			return false;

	// stickers
		case "sticker":
		case "stickers":
			window.location.href = "/collections/stickers";
			return false;


		/* OTHER */
		// gift card
		case "gift card":
		case "giftcard":
		case "gift voucher":
		case "giftvoucher":
		case "voucher":
			window.location.href = "/products/online-gift-voucher";
			return false;

	// sale
		case "on sale":
		case "sale":
		case "cheap":
		case "bargain":
		case "discounted":
		case "discount":
			window.location.href = "/collections/sale";
			return false;

		default:
			return true;
	}
}

// modals
function modal(name) {

	// close any currently open modals
	var modals = document.querySelectorAll(".modal.active");
	for (var i = 0; i < modals.length; i++) {
		var modal = modals[i];
		modal.classList.remove("active");
	}

	// show the modal
	if (name) {
		var modal = document.querySelector(".modal#" + name.replace(/\./g, '\\.'));
		modal.classList.add("active");

		var backdrop = document.querySelector(".modal.backdrop");
		backdrop.classList.add("active");

		// disable body scrolling
				var container = modal.querySelector(".container");

				var scroll = container.querySelector(".scroll");
				if (scroll) container = scroll;

				document.body.classList.add("locked");

				/*
				bodyScrollLock.disableBodyScroll(container);

				var scrollableElements = container.querySelectorAll('[data-scrollable="true"]');
				scrollableElements.forEach(function(scrollableElement) {
					bodyScrollLock.disableBodyScroll(scrollableElement);
				})
				*/

				container.scrollTop = 0;

	} else {

		// enable body scrolling
		// bodyScrollLock.clearAllBodyScrollLocks();
				document.body.classList.remove("locked");

	}
}

// products
function gridProductColour(product, id, name) {
	var images = product.querySelectorAll(".images .image");
	var colours = product.querySelectorAll(".colours .colour");

	// update images
	for (var i = 0; i < colours.length; i++) {
		var image = images[i];
		var colour = colours[i];

		if (+image.getAttribute("data-id") == +id) {
			image.classList.add("active");
			colour.classList.add("selected");
		} else {
			image.classList.remove("active");
			colour.classList.remove("selected");
		}
	}

	// update name
	var selected = product.querySelector(".overview > .selected");
	selected.innerHTML = name;

	// update url
	var url = new URL(product.href);
	url.searchParams.set('variant', id);
	product.href = url;
}

// sorting
function sortBy(value) {
	var url = window.location;

	var parameters = new URLSearchParams(url.search);
	parameters.set('sort_by', value);
	url.search = parameters.toString();
}

// scroller
function scrollScroller(container, direction) {

	// variables
	var scroll = {
		minimum: 0,
		maximum: container.scrollWidth - container.offsetWidth
	};

	// calculate margins
	var childMarginLeft = null;
	var containerStyle = container.currentStyle || window.getComputedStyle(container);
	var containerMarginLeft = Number(containerStyle.marginLeft.replace(/[^\d\-\.]/g, ""));

	// snapping points
	var points = [];
	for (i = 0; i < container.children.length; i++) {
		var child = container.children[i];

		// calculate the margins
		if (childMarginLeft == null) {
			var childStyle = child.currentStyle || window.getComputedStyle(child);
			childMarginLeft = Number(childStyle.marginLeft.replace(/[^\d\-\.]/g, ""));
		}

		// add to array of snapping points
		if (!points.includes(child.offsetLeft) && (i == 0 || -(points[points.length - 1] - child.offsetLeft) >= 15)) {
			points.push(child.offsetLeft + containerMarginLeft);
		}
	}

	function closestNumber(array, num) {
		var i = 0;
		var minDiff = 1000;
		var ans;
		for (i in array) {
			var m = Math.abs(num - array[i]);
			if (m < minDiff) {
				minDiff = m;
				ans = array[i];
			}
		}
		return ans;
	}

	// min and max scroll points
	var sp = {
		current: points.indexOf(closestNumber(points, container.scrollLeft)),
		next: {
			distance: Math.floor(1.15 * (container.offsetWidth / (container.children[0].offsetWidth + (Number(window.getComputedStyle(container.children[0]).marginRight.replace(/[^\d\-\.]/g, "")) * 2))) - 1)
		}
	};

	// minimum distance of 1
	if (sp.next.distance < 1) {
		sp.next.distance = 1;
	}

	// figure out where we're scrolling
	switch (direction) {
		case "left":
			sp.next.position = points[(sp.current - sp.next.distance < 0) ? 0 : sp.current - sp.next.distance];
			if (sp.next.position < scroll.minimum) {
				sp.next.position = scroll.minimum;
			}
			break;
		case "right":
			sp.next.position = points[(sp.current + sp.next.distance > points.length - 1) ? points.length - 1 : sp.current + sp.next.distance];
			if (sp.next.position > scroll.maximum) {
				sp.next.position = scroll.maximum;
			}
			break;
	}

	// perform the scroll
	container.scroll({
		top: 0,
		left: sp.next.position,
		behavior: 'smooth'
	});

}
function checkScrollerButtons(container, leftButton, rightButton) {

	// variables
	var scroll = {
		minimum: 0,
		maximum: container.scrollWidth - container.offsetWidth
	};

	// check whether buttons need to be shown or hidden
	var tolerance = 20;
	if (container.scrollWidth < container.offsetWidth + tolerance) {
		leftButton.classList.add("disabled");
		rightButton.classList.add("disabled");
	} else if (container.scrollLeft < scroll.minimum + tolerance) {
		leftButton.classList.add("disabled");
		rightButton.classList.remove("disabled");
	} else if (container.scrollLeft > scroll.maximum - tolerance) {
		leftButton.classList.remove("disabled");
		rightButton.classList.add("disabled");
	} else if (container.scrollLeft > scroll.minimum + tolerance) {
		leftButton.classList.remove("disabled");
		rightButton.classList.remove("disabled");
	}
}
function overflowScrollFade(container) {

	// is scrollable
	if (container.scrollHeight > container.clientHeight) {
		container.parentNode.classList.add("fade_top", "fade_bottom");

		var top = container.scrollTop;
		var bottom = container.scrollHeight - container.clientHeight - container.scrollTop;

		// is at the top
		if (top <= 2) {
			container.parentNode.classList.remove("fade_top");
		}

		// is at the bottom
		if (bottom <= 2) {
			container.parentNode.classList.remove("fade_bottom");
		}

		// is not scrollable
		} else {
			container.parentNode.classList.remove("fade_top", "fade_bottom");
		}
}



/* CLASSES */

class Bag {

	// initialise
	constructor(info) {

		// variables
		this.storePickupID = 32354546384976;
		this.freeGripID = 32084076462160;
		this.keys = {
			settings: [
				"method",
				"pickup_store",
				"stock",
				"stock_timestamp",
				"shippable_item_quantities",
				"stores"
			],
			shopify: [
				"token",
				"item_count",
				"items",
				"items_subtotal_price",
				"note",
				"total_discount",
				"attributes",
				"cart_level_discount_applications",
				"currency",
				"original_total_price",
				"requires_shipping",
				"total_price",
				"total_weight"
			]
		};

		// bag from shopify
		this.shopify = info;

		// remember the current bag
		var bagSync = localStorage.getItem('bagSync');
		this.cache = bagSync ? JSON.parse(bagSync) : {};
		if (this.cache && !(this.cache.item_count > 0 && this.shopify.item_count == 0) && "shippable_item_quantities" in this.cache) {
			this.settings = this.clean(this.cache, this.keys.settings);

		// new bag
		} else {
			this.settings = {
				method: "delivery",
				pickup_store: "north_perth",
				stock: {},
				stock_timestamp: null,
				shippable_item_quantities: {},
				stores: {
					"north_perth": {
						id: 1,
						name: "North Perth",
						item_quantities: {}
					},
					"whitford_city": {
						id: 3,
						name: "Whitford City",
						item_quantities: {}
					},
					"cannington": {
						id: 2,
						name: "Cannington",
						item_quantities: {}
					},
					"joondalup": {
						id: 5,
						name: "Joondalup",
						item_quantities: {}
					}
				}
			};
		}

		// find the required elements
		this.element = document.querySelector(".modal#bag .container");
		this.elements = {
			count: document.querySelector("header > * > .bag"),

			freeShipping: this.element.querySelector(".free.shipping.counter"),
			freeShippingBar: this.element.querySelector(".free.shipping.counter > .bar"),
			freeShippingText: this.element.querySelector(".free.shipping.counter > .text"),

			items: this.element.querySelector(".products"),
			templateItem: this.element.querySelector(".products > .template.product"),
			emptyMessage: this.element.querySelector(".products > .empty.message"),

			discount: this.element.querySelector(".footer > .subtotal > .key > .discount"),
			subtotal: this.element.querySelector(".footer > .subtotal > .value"),

			noteLabel: this.element.querySelector(".footer > label.note"),
			noteInput: this.element.querySelector(".footer > textarea.note"),

			form: this.element.querySelector("form.footer"),
			checkout: this.element.querySelector(".footer > .checkout"),

			delivery: this.element.querySelector(".methods > .delivery"),
			pickup: this.element.querySelector(".methods > .pickup")
		};

		// clone all of the shopify product details in to this class
		this.import(this.shopify, this.keys.shopify);
		this.import(this.settings, this.keys.settings);

		// listen for any syncs from other tabs
		window.addEventListener('storage', (event) => {
			if (event.key == 'bagSync'){
				var data = localStorage.getItem('bagSync');
				if (data) {
					this.import(JSON.parse(data), this.keys, false);
				}
			}
		});

		// if the page is cached (e.g from clicking back button) reload the items
		window.onpageshow = function(event) {
			if (event.persisted || window.performance && window.performance.navigation.type == 2) {
				var data = localStorage.getItem('bagSync');
				if (data) {
					this.import(JSON.parse(data), this.keys, false);
				}
			}
		}.bind(this);
	}

	// resetting the class (mainly for testing)
	clear () {
		$.ajax({
			type: "POST",
			url: "/cart/clear.js",
			dataType: "json",
			success: function(response) {
				this.import(response, this.keys);
			}.bind(this),
		});
	}
	reset() {
		this.clear();
		this.stock = {};
		this.stock_timestamp = 0;
		this.pickup_store = 'north_perth';
		this.method = 'delivery';

		this.sync();
	}

	/*
	test() {
		modal('bag');
		this.reset();

		// one second pause
		setTimeout(function() {

			// change to pickup
			this.method = 'pickup';

			// set whitford city store
			this.pickup_store = 'whitford_city';

			// add a few items..
			setTimeout(function() {

				this.addItem("id=32330679681104");

			}.bind(this), 1 * 1000);


		}.bind(this), 1 * 1000);
	}
	*/

	// importing data
	clone(data) {
		return JSON.parse(JSON.stringify(data));
	}
	clean(data, keys) {
		data = this.clone(data);

		// remove underscores
		for (var attribute in data) {
			if (attribute.startsWith("_")) {
				data[attribute.replace(/^_/, "")] = data[attribute];
				delete data[attribute];
			}
		}

		// check if the keys is multiple arrays
		if (typeof keys === 'object' && keys !== null) {
			var newKeys = [];
			for (var id in keys) {
								var keyGroup = keys[id];
				if (Array.isArray(keyGroup)) {
					newKeys = newKeys.concat(keyGroup);
				}
			}
						keys = newKeys;
		}

		// remove keys that aren't needed
		if (Array.isArray(keys) && keys.length > 0) {
			for (var attribute in data) {
				if (!keys.includes(attribute.toString())) {
					delete data[attribute];
				}
			}
		}

		return data;
	}
	import(data, keys, sync) {
		if (sync === undefined) sync = true;

		var oldData = this.clean(this, keys);
		var newData = this.clean(data, keys);

		// if the data to import is different
		for (var attribute in newData) {
			if (!(attribute in oldData) || JSON.stringify(oldData[attribute]) != JSON.stringify(newData[attribute])) {
				this[attribute] = newData[attribute];
			}
		}

		// sync to other tabs
		if (sync) this.sync();
	}
	sync() {
		window.localStorage.setItem('bagSync', JSON.stringify(this.clean(this, this.keys)));
	}

	// synced data (js and html)
	get note() {
		return this._note;
	}
	set note(note) {
				if (!note) note = "";
		this._note = note;

		// update the html
		this.elements.noteInput.value = note;
		if (note) {
			this.elements.noteLabel.classList.add('disabled');
			this.elements.noteInput.classList.remove('disabled');
		} else {
			this.elements.noteLabel.classList.remove('disabled');
			this.elements.noteInput.classList.add('disabled');
		}
	}

	get items() {
		return this._items;
	}
	set items(items) {
		if (JSON.stringify(this._items) == JSON.stringify(items)) return true;
		var oldItems = this._items ? this._items : [];
		var newItems = items ? items : [];

		this._items = newItems;

		// compare the old and new items
		var items = {};

		// old items
		for (var i = oldItems.length -1; i >= 0; i--) {
			var oldItem = oldItems[i];

			// temporary items object
			items[oldItem.key] = {
				id: oldItem.id,
				key: oldItem.key,
				old: oldItem,
				element: this.element.querySelector(".products > .product[data-key='" + oldItem.key + "']")
			};
		}

		// new items
		for (var i = newItems.length -1; i >= 0; i--) {
			var newItem = newItems[i];

			if (newItem.key in items) {
				items[newItem.key].new = newItem;
			} else {
				items[newItem.key] = {
					id: newItem.id,
					key: newItem.key,
					new: newItem
				};
			}
		}

		// each item
		var count = 0;
		var subtotal = 0;
		var total = 0;
		var discount = 0;
		for (var key in items) {
			let item = items[key];

			// create or update
			if ("new" in item && item.new.quantity > 0) {
				if (("old" in item && item.new.quantity != item.old.quantity) || !("element" in item)) {

					// update item
					if ("old" in item && item.new.quantity != item.old.quantity) {
						item.element.querySelector(".details .quantity > .amount").innerHTML = item.new.quantity;

					// new item
					} else if (!("element" in item)) {
						item.element = this.newItemElement(item.new);
						this.elements.items.insertBefore(
							item.element,
							this.elements.items.firstChild
						);
					}

					// update bag quantities
					setTimeout(function() {
						if (typeof product !== 'undefined') {
							product.bagQuantity(item.id, item.new.quantity);

							// check if the plus button needs to be blocked
							if (item.new.quantity == product.getInventory(item.id)) {
								item.element.querySelector(".quantity .plus").classList.add("disabled");
							}
						}
					}, 10);
				}

				// count quantity
				count += item.new.quantity;

				// calculate subtotal
				subtotal += item.new.final_line_price;

				// calculate total
				total += item.new.original_line_price;

				// calculate discount
				discount += item.new.total_discount;

			// delete item
			} else {
				let element = item.element;
				element.classList.add("hide");

				setTimeout(function() {
					element.parentNode.removeChild(element);
				}, 0.5 * 1000);

				// update bag quantities
				setTimeout(function() {
					if (typeof product !== 'undefined') product.bagQuantity(item.id, 0);
				}, 10);
			}
		}

		// update the count
		this.item_count = count;

		// update the subtotal
		this.items_subtotal_price = subtotal;

		// update the total
		this.original_total_price = total;

		// update the discounted amount
		this.total_discount = discount;

		// get the shippable items, and total quantity of items (merging same IDs)
		this.shippable_item_quantities = {};
		for (var i = 0; i < this.items.length; i++) {
			var item = this.items[i];
			if (item.requires_shipping && item.id != this.storePickupID) {
				if (item.id in this.shippable_item_quantities) {
					this.shippable_item_quantities[item.id] += item.quantity;
				} else {
					this.shippable_item_quantities[item.id] = item.quantity;
				}
			}
		}

		// check pickup stock
		this.updatePickup();
	}

	get item_count() {
		return this._item_count;
	}
	set item_count(count) {
		this._item_count = count;

		// make sure all required parameters have been set
		if (typeof this.items === 'undefined') this.items = this.shopify.items;

		if (this.items.some(item => item.id === this.storePickupID) && count > 0) count--;

		// update the html
		this.elements.count.innerHTML = count;
		if (count) {
			this.elements.count.classList.remove("empty");
			this.elements.checkout.classList.remove("disabled");

			this.elements.emptyMessage.classList.remove("visible");
		} else {
			this.elements.count.classList.add("empty");
			this.elements.checkout.classList.add("disabled");

			this.elements.emptyMessage.classList.add("visible");

			// remove any pickup status icons
			var statusIcons = this.elements.pickup.querySelectorAll(".stores > .store .status.unavailable, .stores > .store .status.error, .stores > .store .status.available");
			for (var i = 0; i < statusIcons.length; i++) {
				statusIcons[i].classList.remove("unavailable", "error", "available");
			}
		}
	}

	get items_subtotal_price() {
		return this._items_subtotal_price;
	}
	set items_subtotal_price(subtotal) {
		if (this._items_subtotal_price == subtotal) return true;
		this._items_subtotal_price = subtotal;

		// update the html
		this.elements.subtotal.innerHTML = displayCurrency(subtotal);

		// free shipping counter
		if (this.elements.freeShipping) {
			var threshold = this.elements.freeShipping.getAttribute("data-threshold") * 100;

			// check if any of the items require shipping
			var requiresShipping = true;
			if (this.items.length > 0) {
				requiresShipping = false;

				for (var i = 0; i < this.items.length; i++) {
					var item = this.items[i];

					if (item.requires_shipping) {
						requiresShipping = true;
						break;
					}
				}
			}

			if (!requiresShipping) {
				this.elements.freeShippingBar.style.width = (subtotal / threshold) * 100 + "%";
				this.elements.freeShippingText.innerHTML = "Your order does not require delivery.";

			} else if (subtotal >= threshold - (1 * 100)) {
				this.elements.freeShippingBar.style.width = "100%";
				this.elements.freeShippingText.innerHTML = "Your order qualifies for free delivery*";

			} else {
				this.elements.freeShippingBar.style.width = (subtotal / threshold) * 100 + "%";
				this.elements.freeShippingText.innerHTML = "You are " + displayCurrency(threshold - subtotal, false, true) + " away from free delivery*";
			}
		}

	}

	get total_discount() {
		return this._total_discount;
	}
	set total_discount(discount) {
		this._total_discount = discount;

		// update the html
		var discountPercentage = Math.round((discount / this.original_total_price) * 100);
		if (this.total_discount > 0 && discountPercentage > 0) {
			this.elements.discount.innerHTML = Math.round((discount / this.original_total_price) * 100);
		} else {
			this.elements.discount.innerHTML = "";
		}
	}

	validate() {

		// make sure all required parameters have been set
		if (typeof this.stores === 'undefined') this.stores = this.settings.stores;
		if (typeof this.pickup_store === 'undefined') this.pickup_store = this.settings.pickup_store;

		// check if is valid
		var valid = true;

		// no items
		if (this.items.some(item => item.id === this.storePickupID)) {
			if (this.item_count <= 1) valid = false;
		} else {
			if (this.item_count == 0) valid = false;
		}

		// invalid pickup
		if (this.method == "pickup" && this.getStorePickupStatus() != "available") valid = false;

		// loading
		if (this.loading) valid = false;

		this.valid = valid;
	}
	get valid() {
		this.validate();
		return this._valid;
	}
	set valid(valid) {
		// if (this._valid == valid) return;
		this._valid = valid;

		if (valid) {
			this.elements.checkout.classList.remove("disabled");

						// hide any item unavailabilities
			var errorProducts = this.elements.items.querySelectorAll(".product.error, .product.unavailable, .product.checking");
			for (var i = 0; i < errorProducts.length; i++) {
				errorProducts[i].classList.remove("error", "unavailable", "checking");
			}
		} else {
			this.elements.checkout.classList.add("disabled");
		}
	}

	get loading() {
		return this._loading;
	}
	set loading(loading) {
		// if (this._loading == loading) return;
		this._loading = loading;

				// clear any existing timers
				clearTimeout(this.loadingTransitionTimer);

		if (loading) {
			this.elements.checkout.classList.add('loading', 'icon');
			this.valid = false;
		} else {
			this.loadingTransitionTimer = setTimeout(function() {
				this.elements.checkout.classList.remove('loading', 'icon');
				this.validate();

								delete this.loadingTransitionTimer;
			}.bind(this), 0.1 * 1000);
		}
	}

	get method() {
		return this._method;
	}
	set method(method) {
		var previousMethod = this._method;
		if (previousMethod == method) return true;
		this._method = method;

		// update the html
		if (method == "pickup") {
			this.elements.pickup.classList.add('active');
			this.elements.delivery.classList.remove('active');

			// add pickup messages
			var products = this.elements.items.querySelectorAll(".product.error, .product.unavailable, .product.checking");
			for (var i = 0; i < products.length; i++) {
				var product = products[i];
				var message = product.querySelector(".message");
				message.innerHTML = "Checking...";
				product.classList.add("checking");
			}

			// add the hidden inputs
			var inputMethod = this.elements.form.querySelector("input[name='attributes[cnc-fulfilment-method]']");
			inputMethod.value = "store";

			var inputStoreName = this.elements.form.querySelector("input[name='attributes[cnc-store-name]']");
			inputStoreName.value = (typeof this.stores !== 'undefined' && typeof this.pickup_store !== 'undefined') ? this.stores[this.pickup_store].name : "";

			var inputOutlet = this.elements.form.querySelector("input[name='attributes[cnc-outlet]']");
			inputOutlet.value = (typeof this.stores !== 'undefined' && typeof this.pickup_store !== 'undefined') ? this.stores[this.pickup_store].id : "";

			// update pickup
			this.updatePickup();

		} else {
			this.elements.delivery.classList.add('active');
			this.elements.pickup.classList.remove('active');

			// hide any pickup messages
			var inputMethod = this.elements.form.querySelector("input[name='attributes[cnc-fulfilment-method]']");
			inputMethod.value = "";

			var inputStoreName = this.elements.form.querySelector("input[name='attributes[cnc-store-name]']");
			inputStoreName.value = "";

			var inputOutlet = this.elements.form.querySelector("input[name='attributes[cnc-outlet]']");
			inputOutlet.value = "";

			// update checkout button
			this.validate();
		}

		// if we need to animate this change too
		if (typeof previousMethod === 'string' && typeof method === 'string' && previousMethod != method) {
			var container = this.elements.delivery.parentNode;

			container.style.height = this.elements[previousMethod].offsetHeight + "px";

			setTimeout(function() {
				container.style.height = this.elements[method].offsetHeight + "px";
			}.bind(this), 0.01 * 1000);

						clearTimeout(this.methodTransitionTimer);
						this.methodTransitionTimer = setTimeout(function() {
				container.style.height = "";
			}.bind(this), 0.4 * 1000);
		}
	}

	get pickup_store() {
		return this._pickup_store;
	}
	set pickup_store(store) {
		var previousStore = this._pickup_store;
		if (previousStore == store) return true;
		this._pickup_store = store;

		// show selected
		var stores = this.elements.pickup.querySelectorAll(".stores > .store");
		for (var i = 0; i < stores.length; i++) {
			var storeElement = stores[i];
			if (storeElement.dataset.id == store) {
				storeElement.classList.add("selected");
			} else {
				storeElement.classList.remove("selected");
			}
		}

		// update hidden inputs
		if (this.method == "pickup") {
			var inputStoreName = this.elements.form.querySelector("input[name='attributes[cnc-store-name]']");
			inputStoreName.value = this.stores[this.pickup_store].name;

			var inputOutlet = this.elements.form.querySelector("input[name='attributes[cnc-outlet]']");
			inputOutlet.value = this.stores[this.pickup_store].id;

			this.updatePickup();
		}
	}

	getStorePickupStatus(pickupStore) {

		// make sure all required parameters have been set
		if (typeof this.stores === 'undefined') this.stores = this.settings.stores;
		if (typeof this.shippable_item_quantities === 'undefined') this.shippable_item_quantities = this.settings.shippable_item_quantities;

		if (pickupStore == null) pickupStore = this.pickup_store;

		var bagItemsQuantity = 0;
		var storeItemsQuantity = 0;

		// bag items quantity
		for (var id in this.shippable_item_quantities) {
			var bagQuantity = this.shippable_item_quantities[id];

			var storeQuantity = 0;
			if (id in this.stores[pickupStore].item_quantities) {
				storeQuantity = this.stores[pickupStore].item_quantities[id];
			}

			// update total quantities
			bagItemsQuantity += bagQuantity;
			if (storeQuantity > bagQuantity) {
				storeItemsQuantity += bagQuantity;
			} else if (storeQuantity > 0) {
				storeItemsQuantity += storeQuantity;
			}
		}

		// return result
		if (bagItemsQuantity > 0) {
			if (storeItemsQuantity <= 0) {
				return "unavailable";
			} else if (storeItemsQuantity < bagItemsQuantity) {
				return "error";
			} else {
				return "available";
			}
		} else {
			return "";
		}
	}

	get stock() {
		return this._stock;
	}
	set stock(stock) {
		this._stock = stock;

		// make sure all required parameters have been set
		if (typeof this.stores === 'undefined') this.stores = this.settings.stores;

		// count quantities available for each of the stores
		for (var storeKey in this.stores) {
			this.stores[storeKey].item_quantities = {};

			for (var itemId in this.stock) {
				this.stores[storeKey].item_quantities[itemId] = this.stock[itemId][storeKey];
			}
		}
	}

	// js
	getItem(key) {
		for (var i = 0; i < this._items.length; i++) {
			var item = this._items[i];
			if (item.key == key) {
				return item;
			}
		}
		return undefined;
	}
	getLinkedItems(id, sku) {
		var items = [];
		for (var i = 0; i < this._items.length; i++) {
			var item = this._items[i];

			if (item.properties && "Linked To" in item.properties) {
				if (item.properties["Linked To"] == id || item.properties["Linked To"] == sku) {
					items.push(item);
				}
			}
		}

		// return null if there aren't any linked items
		if (items.length > 0) {
			return items;
		} else {
			return null;
		}
	}

	// html
	newItemElement(item) {

		// duplicate the template product
		let element = this.elements.templateItem.cloneNode(true);
		element.classList.remove("template");

		// hide the store pickup item
		if (item.id == this.storePickupID) element.style.display = "none";

		// transition in
		element.classList.add("hide");
		setTimeout(function() {
			element.classList.remove("hide");
		}, 10);

		// id
		element.setAttribute("data-id", item.id);
		element.setAttribute("data-key", item.key);

		// resize the image
		var image = null;
		if ("featured_image" in item && "url" in item.featured_image && item.featured_image.url) {
			image = new URL(`https:${item.featured_image.url}`);
			var extension = image.pathname.split('.').pop();
			var match = new RegExp("\." + extension + "$", "gi");
			image.pathname = image.pathname.replace(match, "") + "_400x." + extension;
		}

		// assign all the variables
		element.querySelector(".image > img").src = image ? image.href : "";
		element.querySelector(".details .vendor").innerHTML = item.vendor;
		element.querySelector(".details > .title").innerHTML = item.product_title;
		element.querySelector(".details > .title").href = item.url;

		// selected options
		if (item.variant_title) {
			var title = [];
			for (var i = item.options_with_values.length - 1; i >= 0; i--) {
				var option = item.options_with_values[i];
				var ignoreValues = ["default", "default title", "o/s", "o / s", "osfa", "os", "o/c", "o / c", "oc", "one size"];

				if (!ignoreValues.includes(option.value.toLowerCase())) {
					title.push(option.value.trim());
				}
			}
			title = title.join(", ").replace(/\//g, " / ").replace(/\s\s+/g, " ");

			// if we've got a title
			if (title) {
				var variantTitle = document.createElement("div");
				variantTitle.classList.add("option");
				variantTitle.innerHTML = title;
				element.querySelector(".details > .options").appendChild(variantTitle);
			}
		}

		// selected properties
		if (item.properties) {
			for (var i in item.properties) {
				var property = document.createElement("div");
				property.classList.add("option");

				// if it's an experience
				if (i.toLowerCase() == "when") {

					// disable the plus quantity button
					var plus = element.querySelector(".quantity .plus");
					plus.classList.add("alwaysDisabled");

					// reformat date
					var date = item.properties[i];
					var pattern = /(\w{3} \d{1,2}, \d{4})\s+at\s+(\d{1,2}:\d{1,2})(am|pm)\s+(\w{1,4}T).*to.*(\w{3} \d{1,2}, \d{4})\s+at\s+(\d{1,2}:\d{1,2})(am|pm)\s+(\w{1,4}T)/i;
					if (pattern.test(date)) {
						var matches = date.match(pattern);
						var startDate = new Date(matches[1] + " " + matches[2] + " " + matches[3] + " (" + matches[4] + ")");
						var endDate = new Date(matches[5] + " " + matches[6] + " " + matches[7] + " (" + matches[8] + ")");

						// remove if it has already ended
						var nowDate = new Date(new Date().toLocaleString("en-US", { timeZone: "Australia/Perth" }));
						if (nowDate > endDate) {
							setTimeout(function() {
								this.removeItem(item.key);
							}.bind(this), 0.1 * 1000);
						}

												var AWST = new Date(new Date().toLocaleString("en-US", { timeZone: "Australia/Perth" })).getTime() / 1000;
												var localTimestamp = new Date().getTime() / 1000;
												var isAWST = Math.abs(AWST - localTimestamp) <= 5 * 60; // within 5 minutes

						property.innerHTML = i + ": " + humanTimestamp(startDate, false) + (isAWST ? "" : " AWST");

						property.style.textTransform = "none";
					} else {
						property.innerHTML = i + ": " + item.properties[i];
					}

				} else if (i.toLowerCase() == "linked to" || i.toLowerCase() == "_timeslot") {
					continue;
				} else {
					property.innerHTML = i + ": " + item.properties[i];
				}

				element.querySelector(".details > .options").appendChild(property);
			}
		}

		element.querySelector(".details .quantity > .amount").innerHTML = item.quantity;
		element.querySelector(".details .price").innerHTML = item.price > 0 ? displayCurrency(item.price) : "Free";

		// block them from increasing the quantity of free items
		if (item.price <= 0) {
			var plus = element.querySelector(".quantity .plus");
			plus.classList.add("alwaysDisabled");
		}

		return element;
	}
	updateItemElement(item) {

		// just get a new one, but don't let it transition in
		var element = this.newItemElement(item);
		element.classList.remove("hide");

		return element;
	}

	// requests
	addItem(data, success, error) {

		// convert data to data object
		var dataObject = {};
		if (Array.isArray(data)) {
			dataObject.items = data;
		} else {
			dataObject.items = [data];
		}

		// make sure the format matches shopify's ajax api
		for (var i = 0; i < dataObject.items.length; i++) {
			var item = dataObject.items[i];
			if (typeof item === 'string' || item instanceof String) {
				dataObject.items[i] = getParametersAsObject(item);
			}
		}

		// make the request
		this.loading = true;
		$.ajax({
			type: "POST",
			url: "/cart/add.js",
			data: dataObject,
			dataType: "json",

			success: function(response) {
				this.loading = false;

				var items = this.clone(this._items);

				// go through all the new items
				for (var i = 0; i < response.items.length; i++) {
					var newItem = response.items[i];

					// if the item already exists
					if (this.getItem(newItem.key)) {
						for (var j = 0; j < items.length; j++) {
							var item = items[j];
							if (item.key == newItem.key) {
								items[j] = newItem;
							}
						}

						// scroll to that item
						setTimeout(function() {
							var scrollContainer = this.element.querySelector(".scroll");
							var scrollHeight = scrollContainer.scrollHeight;
							var containerHeight = scrollContainer.offsetHeight;

							var updatedItem = this.elements.items.querySelector(".product[data-key='" + newItem.key + "']");
							var updatedItemHeight = updatedItem.offsetHeight;

							var scrollPosition = getPosition(updatedItem).y + updatedItemHeight - containerHeight + 35;
							if (scrollPosition > 0 && scrollPosition < scrollHeight) {
								scrollContainer.scroll({
									top: scrollPosition,
									left: 0,
									behavior: 'smooth'
								});
							}

						}.bind(this), 0.1 * 1000);

					// new item
					} else {
						items.unshift(newItem);
					}
				}

				// show these changes
				this.items = items;

				// show the bag (as long as it wasn't the store pickup item)
				if (data != ("id=" + this.storePickupID)) modal('bag');

				// sync to other tabs
				this.sync();

				if (success !== undefined) success(response);
			}.bind(this),

			error: function(response) {
				this.loading = false;
				if (error !== undefined) error(response);
			}.bind(this)
		});

	}
	removeItem(key, success, error) {
		this.changeItemQuantity(key, 0, success, error);
	}

	changeItemQuantity(key, quantity, success, error) {
		var item = this.getItem(key);
		if (!item) {
			if (error !== undefined) error("Item doesn't exist!");
			return false;
		}

		// make an array of items that are getting their quantities changed
		var updates = {
			[key]: quantity
		};

		// check if any products are linked to it, to update them too
		var linkedItems = this.getLinkedItems(item.id, item.sku);
		if (linkedItems) {
			for (var i = 0; i < linkedItems.length; i++) {
				var linkedItem = linkedItems[i];
				if (linkedItem.quantity > quantity) {
					updates[linkedItem.key] = quantity;
				}
			}
		}

		// disable the plus and minus buttons while it's loading
		for (var key in updates) {
			var plus = this.element.querySelector(".product[data-key='" + key + "'] .quantity .plus");
			var minus = this.element.querySelector(".product[data-key='" + key + "'] .quantity .minus");
			if (plus) plus.classList.add("disabled");
			if (minus) minus.classList.add("disabled");
		}

		// predict the expected changes
		let oldData = this.clean(this, this.keys);
		let expectedData = this.clean(this, this.keys);
		expectedData.item_count = 0;
		expectedData.items_subtotal_price = 0;
		expectedData.total_discount = 0;
		for (var i = expectedData.items.length - 1; i >= 0; i--) {
			var item = expectedData.items[i];
			if (item.key in updates) {
				var quantity = updates[item.key];

				// update
				if (quantity > 0) {
					expectedData.items[i].quantity = quantity;
					expectedData.items[i].original_line_price = expectedData.items[i].original_price * quantity;
					expectedData.items[i].final_line_price = expectedData.items[i].final_price * quantity;
					expectedData.items[i].line_price = expectedData.items[i].final_line_price;
					expectedData.items[i].total_discount = (expectedData.items[i].price - expectedData.items[i].final_price) * quantity;

				// delete
				} else {
					expectedData.items.splice(i, 1);
					continue;
				}
			}

			// recalculate count
			expectedData.item_count += item.quantity;

			// recalculate subtotal
			expectedData.items_subtotal_price += item.final_line_price;

			// recalculate total
			expectedData.original_total_price += item.original_line_price;

			// recalculate discount
			expectedData.total_discount += item.total_discount;
		}
		this.import(expectedData, this.keys.shopify, false);

		this.loading = true;
		$.ajax({
			type: "POST",
			url: Object.keys(updates).length > 1 ? "/cart/update.js" : "/cart/change.js",
			data: Object.keys(updates).length > 1 ? { updates: updates } : { quantity: objectValues(updates)[0], id: Object.keys(updates)[0] },
			dataType: "json",

			success: function(response) {
				this.loading = false;

				for (var key in updates) {
					var plus = this.element.querySelector(".product[data-key='" + key + "'] .quantity .plus");
					var minus = this.element.querySelector(".product[data-key='" + key + "'] .quantity .minus");
					if (plus) plus.classList.remove("disabled");
					if (minus) minus.classList.remove("disabled");
				}

				// check if any quantities changed
				var changed = false;
				for (var i = 0; i < oldData.items.length; i++) {
					var newItem = response.items[i];
					var oldItem = oldData.items[i];

					if (!newItem || !oldItem || newItem.key != oldItem.key || newItem.quantity != oldItem.quantity) {
						changed = true;
						break;
					}
				}

				// if something changed
				if (changed) {
					this.import(response, this.keys.shopify);
					if (success !== undefined) success(response);

				// nothing changed
				} else {
					this.import(oldData, this.keys.shopify, false);
					if (error !== undefined) error("No change!");
				}

			}.bind(this),

			error: function(response) {
				this.loading = false;

				for (var key in updates) {
					var plus = this.element.querySelector(".product[data-key='" + key + "'] .quantity .plus");
					var minus = this.element.querySelector(".product[data-key='" + key + "'] .quantity .minus");
					if (plus) plus.classList.remove("disabled");
					if (minus) minus.classList.remove("disabled");
				}

				// revert the expected changes
				this.import(oldData, this.keys.shopify, false);

				if (error !== undefined) error(response);
			}.bind(this)
		});

	}
	plusItemQuantity(key, amount, success, error) {
		if (amount === undefined) amount = 1;

		// details
		let item = this.getItem(key);
		if (!item) {
			if (error !== undefined) error("Item doesn't exist!");
			return false;
		}

		// elements
		let plus = this.element.querySelector(".product[data-key='" + key + "'] .quantity .plus");

		// trucks need to change in quantities of 2
		if ((item.product_type.toLowerCase() == "trucks" || item.product_type.toLowerCase() == "truck") && item.vendor.toLowerCase() != "carver") {
			amount = 2;
		}

		// variables
		let quantity = item.quantity + amount;

		// callbacks
		var thisSuccess = function(response) {
			if (typeof product !== 'undefined' && quantity == product.getInventory(item.id)) plus.classList.add("disabled");
			if (success !== undefined) success(response);
		}
		var thisError = function(response) {
			if (plus) plus.classList.add("disabled");
			if (error !== undefined) error(response);
		}

		// process
		this.changeItemQuantity(key, quantity, thisSuccess, thisError);
	}
	minusItemQuantity(key, amount, success, error) {
		if (amount === undefined) amount = 1;

		// details
		let item = this.getItem(key);
		if (!item) {
			if (error !== undefined) error("Item doesn't exist!");
			return false;
		}

		// trucks need to change in quantities of 2
		if ((item.product_type.toLowerCase() == "trucks" || item.product_type.toLowerCase() == "truck") && item.vendor.toLowerCase() != "carver") {
			amount = 2;
		}

		// variables
		let quantity = item.quantity - amount;

		// process
		this.changeItemQuantity(key, quantity, success, error);

	}

	// click and collect (pickup)
	updatePickup(callback) {
		if (this.method != "pickup") return false;
		if (!Array.isArray(this.items) || !this.items.length) {
			this.updatePickupHTML();
			return false;
		}

		// helpers
		function arrayContainsArray(superset, subset) {
			if (0 === subset.length) return false;
			return subset.every(function (value) {
				return (superset.indexOf(value) >= 0);
			});
		}

		// get the ids of all the cached stock
		var ids = this.items.map(a => a.id.toString());
		var cachedIds = this.stock && Object.keys(this.stock).length ? Object.keys(this.stock) : [];

		// can use existing data (less than 5 minutes old)
		var now = new Date().getTime() / 1000;
		if (this.stock_timestamp && (now - this.stock_timestamp) <= (5 * 60) && arrayContainsArray(cachedIds, ids)) {
			if (callback !== undefined && typeof callback === "function") callback(true);
					this.updatePickupHTML();

		// needs an update
		} else {

					// show loading
			this.loading = true;

						// update while loading
					this.updatePickupHTML();

			// get the store stock quantities
			$.ajax({
				type: "GET",
				url: "https://shopify.retailexpress.com.au/api/shopify_stores/beyond-skate-city/outlets?variant_ids=" + ids.join(),
				dataType: "json",

				success: function(response) {
					this.loading = false;

					// update the stock timestamp
					this.stock_timestamp = new Date().getTime() / 1000;

					// assign the values to the this.stock variable
					var stock = {};
					for (var i = 0; i < response.outlets.length; i++) {
						var outlet = response.outlets[i];
						var outletId = outlet.name.toLowerCase().replace(/\s+/g, '_');
						outletId = outletId == "whitfords" ? "whitford_city" : outletId;

						// each of the ids
						for (var id in outlet.stock) {
							if (!(id in stock)) stock[id] = {};
							stock[id][outletId] = outlet.stock[id];
						}
					}
					this.stock = stock;

					// sync it over
					this.sync();

										if (callback !== undefined && typeof callback === "function") callback(true);
					this.updatePickupHTML();

				}.bind(this),

				error: function(response) {
					this.loading = false;
					console.log(response);

					// reset stock
										this.stock = {};
										this.stock_timestamp = null;

					if (callback !== undefined && typeof callback === "function") callback(false);
										this.updatePickupHTML();
				}.bind(this)
			});

		}
	}
	updatePickupHTML() {

		// make sure all required parameters have been set
		if (typeof this.stock === 'undefined') this.stock = this.settings.stock;
		if (typeof this.pickup_store === 'undefined') this.pickup_store = this.settings.pickup_store;

		// update the status of each store's button
		var storeButtons = this.elements.pickup.querySelectorAll(".stores > .store");
		for (var i = 0; i < storeButtons.length; i++) {
			var status = storeButtons[i].querySelector(".status");
			var storeKey = storeButtons[i].dataset.id;

			status.classList.remove("unavailable", "error", "available");
			var storePickupStatus = this.getStorePickupStatus(storeKey);
			if (storePickupStatus) status.classList.add(storePickupStatus);
		}

		// show unavailability errors on the actual items
		var products = this.elements.items.querySelectorAll(".product");
		for (var i = 0; i < products.length; i++) {
			var product = products[i];
			var message = product.querySelector(".message");

			var item = this.getItem(product.dataset.key);
			if (!item) continue;

			// remove error messages
			product.classList.remove("error", "unavailable", "checking");

			// if it's online only
			if (!item.requires_shipping || item.id == this.storePickupID) continue;

			// error messages
			if (!(item.id in this.stock)) {
				product.classList.add("checking");
				message.innerHTML = "Checking...";

			} else if (this.stock[item.id][this.pickup_store] <= 0) {
				product.classList.add("unavailable");
								message.innerHTML = "Unavailable!";

			} else if (this.shippable_item_quantities[item.id] > this.stock[item.id][this.pickup_store]) {
				product.classList.add("error");
								message.innerHTML = "Only " + this.stock[item.id][this.pickup_store] + " available!";
			}
		}

		// checkout button
		this.validate();
	}

		// finalise
		checkout() {
		if (!this.valid) return false;

		// show loading
		this.loading = true;
		var startTimestamp = Date.now() / 1000;

		// delivery
		if (this.method != "pickup") {
			setTimeout(function() {
							this.loading = false;
				this.submit();
			}.bind(this), 0.4 * 1000);

		// pickup
		} else {

					// force a pickup stock check
					this.stock_timestamp = 0;
			this.updatePickup(function(success) {
				if (success) {
									this.loading = true;

					// add some time for the transition
					var endTimestamp = Date.now() / 1000;
					var timespan = endTimestamp - startTimestamp;
					if (timespan < 0.4) {
						setTimeout(function() {
													this.loading = false;
							this.submit();
						}.bind(this), (0.4 - timespan) * 1000);

					// the process took long enough
					} else {
											this.loading = false;
											this.submit();
					}
				}
			}.bind(this));
		}
	}
		submit() {
		if (!this.valid) return false;

		// fix wrong pickup item
		if (this.method == "delivery" && this.items.some(item => item.id === this.storePickupID)) {
			var pickupItem = this.elements.items.querySelector(".product[data-id='" + this.storePickupID + "']");
			if (pickupItem) this.removeItem(pickupItem.getAttribute('data-key'), function() {
				this.elements.form.submit();
			}.bind(this));

		} else if (this.method == "pickup" && !this.items.some(item => item.id === this.storePickupID)) {
			this.addItem("id=" + this.storePickupID, function() {
				this.elements.form.submit();
			}.bind(this));

		} else {
			this.elements.form.submit();
		}
		}

}
class Product {

	// initialise
	constructor(info) {

		// clone all of the shopify product details in to this class
		for (var attr in info) {
			if (info.hasOwnProperty(attr)) this[attr] = info[attr];
		}
		this.restricted = this.tags.includes("unavailable") || this.tags.includes("restricted");

		// variables
		this.element = document.querySelector(".container#product");
		this.notifyTimer = null;

				this.storeAvailabilities = {};

		// get all the variant selectors
		this.selectors = {};
		var selectors = this.element.querySelectorAll("form .sizes > input[id]");
		for (var i = 0; i < selectors.length; i++) {
			var selector = selectors[i];
			this.selectors[selector.id] = selector;
		}

				// superscript kid and toddler size suffixes
				var isYouthSize = new RegExp(/^\d+(\.\d+)?(t|k)$/i);
				var sizeLabels = this.element.querySelectorAll(".sizes > label.size");
				for (var i = 0; i < sizeLabels.length; i++) {
						var sizeLabel = sizeLabels[i];
						if (isYouthSize.test(sizeLabel.innerHTML)) {
								sizeLabel.innerHTML = sizeLabel.innerHTML.replace(/k/i, "<sub>K</sub>").replace(/t/i, "<sub>T</sub>");
						}
				}
	}

	// getters
	getInventory(id) {
		if (id in this.selectors) {
			var selector = this.selectors[id];
			return parseInt(selector.getAttribute("data-inventory"));
		} else {
			return null;
		}
	}

	// change the colour
	reset() {
		clearTimeout(this.notifyTimer);

		// uncheck size selection
			var sizes = document.querySelectorAll("form.selected .sizes > input:checked");
		if (sizes.length > 1) {
			for (var i = 0; i < sizes.length; i++) {
				var size = sizes[i];
				size.checked = false;
			}
		}

				// close the accordians
		var accordians = document.querySelectorAll("form.selected .accordians input:checked");
				for (var i = 0; i < accordians.length; i++) {
					var accordian = accordians[i];
					accordian.checked = false;
				}

		// restore price
		var price = document.querySelector("form.selected .current.price");
		var minPrice = price.getAttribute("data-min-price");
		var maxPrice = price.getAttribute("data-max-price");

		if (parseInt(maxPrice) > parseInt(minPrice)) {
			price.innerHTML = displayCurrency(minPrice, 0) + " - " + displayCurrency(maxPrice, 0);
		} else {
			price.innerHTML = displayCurrency(maxPrice);
		}

		var comparePrice = document.querySelector("form.selected .old.price");
		if (comparePrice) {
			comparePrice.innerHTML = displayCurrency(comparePrice.getAttribute("data-compare-price"), 0);
		}

	}
	colour(id) {
		if (document.querySelector(".selected.colourGroup[data-id='" + id + "']")) return false;
		clearTimeout(this.notifyTimer);

		// reset selections
		this.mobileFooter(false);
		this.reset();

		// select the id
		var previousName = null;
		var name = null;
		var colourElements = document.querySelectorAll(".colourGroup[data-id]");
		for (var i = 0; i < colourElements.length; i++) {
			var colourElement = colourElements[i];
			if (colourElement.getAttribute("data-id") == id) {
				if (colourElement.getAttribute("data-id-name")) name = colourElement.getAttribute("data-id-name");
				colourElement.classList.add("selected");
			} else if (colourElement.classList.contains("selected")) {
				if (colourElement.getAttribute("data-id-name")) previousName = colourElement.getAttribute("data-id-name");
				colourElement.classList.remove("selected");
			}
		}

		// set the colour name in the title
		if (previousName && name && document.title.indexOf(" | ") > -1) {

			// remove the shop name suffix
			var titleParts = document.title.split(" | ");
			var shopname = titleParts.pop();
			var rawTitle = titleParts.join(" | ");

			// replace colour name with new colour
			var newRawTitle = rawTitle.replace(new RegExp(previousName + '$'), name);

			// add the shop name back
			document.title = [newRawTitle, shopname].join(" | ");
		}

		// set the variant id in the url
		var url = new URL(window.location.href);
		url.searchParams.set('variant', id);
		window.history.replaceState({}, document.title, url);

		// update the selection
		this.update();

				// make sure the fixed sidebar is in the right place
				window.scrollBy(0, 1);
				window.scrollBy(0, -1);

	}

	// update html
	update() {
		clearTimeout(this.notifyTimer);

		// variables
				var valid = document.querySelector("form.selected").checkValidity();
		var madeSelection = false;
		var soldOut = true;
		var inventoryLimit = false;

		var experience = document.querySelector("meta[name='experience']") ? true : false;
				var event = this.element.dataset.template.includes("event");

		// sizes
		var sizes = document.querySelectorAll("form.selected .sizes > input");
		var selectedSize = null;
		if (sizes.length > 0) {
			for (var i = 0; i < sizes.length; i++) {
				var size = sizes[i];

				// compare bag with inventory numbers
				var inventoryQuantity = parseInt(size.getAttribute("data-inventory"));
				var bagQuantity = parseInt(size.getAttribute("data-bag"));
				if (bagQuantity >= inventoryQuantity) {
					size.classList.add("limit");
				} else {
					size.classList.remove("limit");
				}

				// a size has been selected
				if (size.checked) {
					madeSelection = true;
					selectedSize = size;

					// that size has an inventory limit
					if (size.classList.contains("limit")) {
						inventoryLimit = true;
					}
				}

				// not sold out
				if (size.classList.contains("available")) {
					soldOut = false;
				}
			}
		}

		// pricing
		if (madeSelection) {
		var price = document.querySelector("form.selected .current.price");
			var sizePrice = selectedSize.getAttribute("data-price");
				price.innerHTML = sizePrice > 0 ? displayCurrency(sizePrice) : "Free";

			var comparePrice = document.querySelector("form.selected .old.price");
			var sizeComparePrice = selectedSize.getAttribute("data-compare-price");
			if (comparePrice) {
				if (parseInt(sizeComparePrice) > parseInt(sizePrice)) {
					comparePrice.innerHTML = displayCurrency(sizeComparePrice, 0);
				} else {
					comparePrice.innerHTML = "";
				}
			}
		}

		// add buttons
		var addButtons = document.querySelectorAll("form.selected .add.button");
		for (var i = 0; i < addButtons.length; i++) {
			var addButton = addButtons[i];

			// disabled
			if (!valid || soldOut || inventoryLimit || !madeSelection || this.restricted) {
				addButton.classList.add("disabled");
			} else {
				addButton.classList.remove("disabled");
			}

			// text
			if (this.restricted) {
				addButton.innerHTML = "Unavailable";
			} else if (soldOut) {
				addButton.innerHTML = "Sold Out";
			} else if (inventoryLimit) {
				addButton.innerHTML = "Inventory Limit Reached";
			} else if (event || experience) {
				addButton.innerHTML = "View Calendar";
						} else if (!madeSelection && sizes.length > 1) {
								addButton.innerHTML = "Select a Size";
						} else {
				addButton.innerHTML = "Add to Bag";
			}

		}

				// update the click and collect
				this.clickAndCollect();

	}

	// show status
	loading(enabled) {
		var addButtons = document.querySelectorAll("form.selected .add.button");
		for (var i = 0; i < addButtons.length; i++) {
			var addButton = addButtons[i];

			if (enabled) {
				addButton.classList.add("loading");
				addButton.classList.add("icon");
				addButton.classList.add("disabled");
			} else {
				addButton.classList.remove("loading");
				addButton.classList.remove("icon");
				addButton.classList.remove("disabled");
			}
		}
	}
	notify(message, disabled) {
		var addButtons = document.querySelectorAll("form.selected .add.button");
		for (var i = 0; i < addButtons.length; i++) {
			var addButton = addButtons[i];
			addButton.innerHTML = message;

			if (disabled) {
				addButton.classList.add("disabled");
			}
		}

		clearTimeout(this.notifyTimer);
		this.notifyTimer = setTimeout(function() {
			this.update();
		}.bind(this), 2.5 * 1000);
	}

	// adding to the bag
	addToBag() {
		if (this.restricted) return false;
		clearTimeout(this.notifyTimer);
		this.loading(true);

		var variant = document.querySelector("form.selected .sizes > input:checked");

		var data = $(document.querySelector("form.selected")).serialize();
		var success = function(response) {
			this.loading(false);
			// this.notify("Added to Bag!", true);

			// hide the mobile footer (in the background)
			setTimeout(function() {
				this.mobileFooter(false);
			}.bind(this), 0.5 * 1000);

		}.bind(this);
		var error = function(response) {
			this.loading(false);

			// check for valid response
			if (response.hasOwnProperty("responseJSON") && response.responseJSON.hasOwnProperty("description")) {

				// sold out
				if (response.responseJSON.description.endsWith("sold out.")) {
					variant.classList.remove("available");
					variant.checked = false;
					this.update();

				// trying to add too much inventory
				} else if (response.responseJSON.description.startsWith("You can only add")) {
					this.notify("Not Enough Inventory!");

				// all inventory in cart already
				} else if (response.responseJSON.description.startsWith("All")) {
					this.notify("All in Bag Already!");

				// unknown error
				} else {
					this.notify(response.responseJSON.description);
				}

			} else {
				this.notify("Something Went Wrong!");
			}

		}.bind(this);

		bag.addItem(data, success, error);

	}
	bagQuantity(id, quantity) {
		if (id in this.selectors) {
			var selector = this.selectors[id];
			selector.setAttribute("data-bag", quantity);
			this.update();
		}
	}

	// show or hide the fixed footer options
	mobileFooter(visible) {
		var form = document.querySelector("form.selected");
		var button = form.querySelector(".show.button");

		if (button) {

			// show
			if (visible) {
				button.setAttribute("onclick", "product.mobileFooter(false); return false;");
				button.setAttribute("data-value", button.innerHTML);
				button.innerHTML = "Hide";
				button.classList.add("active");
				form.classList.add("active");

			// hide
			} else {
				button.setAttribute("onclick", "product.mobileFooter(true); return false;");
				if (button.getAttribute("data-value")) {
					button.innerHTML = button.getAttribute("data-value");
				}
				button.classList.remove("active");
				form.classList.remove("active");
			}

		}
	}

		// click and collect
		clickAndCollect(initialise) {

				// elements
				var accordian = this.element.querySelector("form.selected .accordian [id^='storeStock'] ~ .content .stores");
				if (accordian) {

					// figure out and show which variant is selected
					var selected = {
						id: null,
						name: null,
						available: null
					};
					var sizes = this.element.querySelectorAll("form.selected .sizes > input");
					for (var i = 0; i < sizes.length; i++) {
						var size = sizes[i];

						// set something as the selected
						if (!selected.id) {
							selected.id = size.value;
							selected.name = size.dataset.name;
							selected.available = size.classList.contains("available");
						}

						// if it's available, "select" it
						if (!selected.available && size.classList.contains("available")) {
							selected.id = size.value;
							selected.name = size.dataset.name;
							selected.available = true;
						}

						// if it's selected, "select" it
						if (size.checked) {
							selected.id = size.value;
							selected.name = size.dataset.name;
							selected.available = true;
							break;
						}
					}
					var sizeTag = accordian.querySelector(".tag.size");
					if (sizeTag) sizeTag.innerHTML = selected.name;

					// initialise
					if (initialise && Object.keys(this.storeAvailabilities).length === 0 && !accordian.classList.contains("loading")) {

						// make sure we don't process it twice at the same time..
						accordian.classList.add("loading");

						// get all the ids
						var ids = [];
						var idElements = this.element.querySelectorAll(".sizes > input[name='id']");
						for (var i = 0; i < idElements.length; i++) {
							var idElement = idElements[i];
							var id = idElement.value;
							if (!ids.includes(id)) ids.push(id);
						}

						// get the store stock quantities
						$.ajax({
							type: "GET",
							url: "https://shopify.retailexpress.com.au/api/shopify_stores/beyond-skate-city/outlets?variant_ids=" + ids.join(),
							dataType: "json",

							success: function(response) {
								accordian.classList.remove("loading");

								// assign the values to the storeAvailabilities variable
								for (var i = 0; i < response.outlets.length; i++) {
									var outlet = response.outlets[i];
									var outletId = outlet.name.toLowerCase().replace(/\s+/g, '_');
									outletId = outletId == "whitfords" ? "whitford_city" : outletId;

									// each of the ids
									for (var id in outlet.stock) {
										var stock = outlet.stock[id];

										// create the id
										if (!(id in this.storeAvailabilities)) this.storeAvailabilities[id] = {};

										// create the outlet / store
										this.storeAvailabilities[id][outletId] = stock;
									}
								}

								// try loading the click and collect again
								this.clickAndCollect(false);

							}.bind(this),

							error: function(response) {
								accordian.classList.remove("loading");

								console.error(response);
							}.bind(this)
						});
					}

					// check if it has been initialised
					if (Object.keys(this.storeAvailabilities).length === 0) return false;

					// show the quantities
					if (selected.id in this.storeAvailabilities) {
						var storeAvailability = this.storeAvailabilities[selected.id];

						for (var storeId in storeAvailability) {
							var quantity = storeAvailability[storeId];

							var stockElement = accordian.querySelector(".store[data-store='" + storeId + "'] .quantity");
							stockElement.classList.remove("low", "none");

							if (quantity > 1) {
								stockElement.innerHTML = "In Stock";
							} else if (quantity == 1) {
								stockElement.innerHTML = "1 Left";
								stockElement.classList.add("low");
							} else {
								stockElement.innerHTML = "Out of Stock";
								stockElement.classList.add("none");
							}
						}
					}

				}

		}

}

class Griptape {

	// initialise
	constructor() {

		// variables
		this.element = document.querySelector(".modal#griptape");
		this.elements = {
			gripsElement: this.element.querySelector(".products"),
			grips: this.element.querySelectorAll(".products > .griptape"),

			idInput: this.element.querySelector("input[name=id]"),
			quantityInput: this.element.querySelector("input[name=quantity]"),

			linkedToInput: this.element.querySelector("input#linkedTo"),

			selectors: this.element.querySelector(".selectors"),

			applied: this.element.querySelector(".selector[data-id=applied]"),
			appliedInputs: this.element.querySelectorAll(".selector[data-id=applied] input"),

			stance: this.element.querySelector(".selector[data-id=stance]"),
			stanceInputs: this.element.querySelectorAll(".selector[data-id=stance] input"),

			addButton: this.element.querySelector(".add.button")
		};
		this.selected = {
			id: null,
			applied: null,
			stance: null
		}
		this.notifyTimer = null;

	}

	// reset the selection (and update html)
	reset() {

		// deselect grip
		this.elements.idInput.value = null;

		// deselect applied
		for (var i = 0; i < this.elements.appliedInputs.length; i++) {
			var appliedInput = this.elements.appliedInputs[i];
			appliedInput.checked = false;
		}

		// deselect stance
		for (var i = 0; i < this.elements.stanceInputs.length; i++) {
			var stanceInput = this.elements.stanceInputs[i];
			stanceInput.checked = false;
		}

		// update html
		this.update();

	}

	// update html
	update() {
		clearTimeout(this.notifyTimer);

		// variables
		this.selected.id = this.elements.idInput.value;

		this.selected.applied = null;
		for (var i = 0; i < this.elements.appliedInputs.length; i++) {
			var appliedInput = this.elements.appliedInputs[i];
			if (appliedInput.checked) {
				if (appliedInput.value == "Yes") {
					this.selected.applied = true;
				} else {
					this.selected.applied = false;
				}
			}
		}

		this.selected.stance = null;
		for (var i = 0; i < this.elements.stanceInputs.length; i++) {
			var stanceInput = this.elements.stanceInputs[i];
			if (stanceInput.checked) {
				this.selected.stance = stanceInput.value;
			}
		}

		// deselect all grips
		var selectedGrips = this.element.querySelectorAll(".products > .griptape.selected");
		for (var i = 0; i < selectedGrips.length; i++) {
			var selectedGrip = selectedGrips[i];
			selectedGrip.classList.remove("selected");
		}

		// no selection
		if (!this.selected.id) {
			this.elements.gripsElement.classList.remove("selected");
			this.elements.addButton.classList.remove("disabled");
			this.elements.addButton.innerHTML = "Skip";

			// hide the selectors
			this.elements.applied.classList.add("hidden");
			this.elements.stance.classList.add("hidden");
			this.elements.selectors.classList.remove("selected");

		// grip selected
		} else {
			this.elements.gripsElement.classList.add("selected");
			this.elements.selectors.classList.add("selected");
			this.elements.addButton.innerHTML = "Add to Bag";

			// show which grip has been selected
			var selectedGrip = this.element.querySelector(".products > .griptape[data-id='" + this.selected.id + "']");
			selectedGrip.classList.add("selected");
			var requiresStance = selectedGrip.dataset.stanceSelector == "true";

			// show the applied selector
			this.elements.applied.classList.remove("hidden");

			// show the stance selector
			if (this.selected.applied && requiresStance) {
				this.elements.stance.classList.remove("hidden");

			} else {
				this.elements.stance.classList.add("hidden");

				// hide stance from cart
				this.selected.stance = null;
				for (var i = 0; i < this.elements.stanceInputs.length; i++) {
					var stanceInput = this.elements.stanceInputs[i];
					stanceInput.checked = false;
				}
			}

			// valid selection
			if (this.selected.applied === false || (this.selected.applied === true && (!requiresStance || (this.selected.stance !== null)))) {
				this.elements.addButton.classList.remove("disabled");

			// invalid selection
			} else {
				this.elements.addButton.classList.add("disabled");
			}
		}

	}

	// show status
	loading(enabled) {
		if (enabled) {
			this.elements.addButton.classList.add("loading");
			this.elements.addButton.classList.add("icon");
			this.elements.addButton.classList.add("disabled");
		} else {
			this.elements.addButton.classList.remove("loading");
			this.elements.addButton.classList.remove("icon");
			this.elements.addButton.classList.remove("disabled");
		}
	}
	notify(message, disabled) {
		this.elements.addButton.innerHTML = message;

		if (disabled) {
			this.elements.addButton.classList.add("disabled");
		}

		clearTimeout(this.notifyTimer);
		this.notifyTimer = setTimeout(function() {
			this.update();
		}.bind(this), 2.5 * 1000);
	}

	// selecting a grip
	select(id) {
		this.elements.idInput.value = id;
		this.update();
	}
	toggle(id) {
		if (this.elements.idInput.value == id) {
			this.reset();
		} else {
			this.select(id);
		}
	}

	// adding to the bag
	addToBag() {
		clearTimeout(this.notifyTimer);

		// set the "linked to" to the deck id or sku
		var deckVariantID = getParametersAsObject($(document.querySelector("form.selected")).serialize()).id;
		var deckVariantSKU = document.querySelector("form.selected .sizes > input[value='" + deckVariantID + "']").dataset.sku;
		this.elements.linkedToInput.value = deckVariantSKU ? deckVariantSKU : deckVariantID;

		// skipping
		if (!this.selected.id) {

			modal(false);
			product.addToBag();

		// adding griptape
		} else {
			this.loading(true);

			var data = [
				$(document.querySelector("form.selected")).serialize(), // deck
				$(this.element.querySelector("form")).serialize() // griptape
			];
			var success = function(response) {
				this.loading(false);
				this.reset();

			}.bind(this);
			var error = function(response) {
				this.loading(false);

				// check for valid response
				if (response.hasOwnProperty("responseJSON") && response.responseJSON.hasOwnProperty("description")) {

					// sold out
					if (response.responseJSON.description.endsWith("sold out.")) {
						this.notify("Sold Out!");

					// trying to add too much inventory
					} else if (response.responseJSON.description.startsWith("You can only add")) {
						this.notify("Not Enough Inventory!");

					// all inventory in cart already
					} else if (response.responseJSON.description.startsWith("All")) {
						this.notify("All in Bag Already!");

					// unknown error
					} else {
						this.notify(response.responseJSON.description);
					}

				} else {
					this.notify("Something Went Wrong!");
				}

			}.bind(this);

			bag.addItem(data, success, error);

		}

	}

}

class CollectionFilter {

	constructor(url) {
		this.url = url;

		this.element = document.querySelector(".modal#collection\\.filters");
		this.elements = {
			form: this.element.querySelector("form"),
			apply: this.element.querySelector(".buttons > .apply"),
			clear: this.element.querySelector(".buttons > .clear"),

			filterButtons: document.querySelector(".header > .filters")
		};

		// set defaults
		this.initialFormData = this.getFormData();
		this.checkCustomised();

		// check that the collection supports filters
		if (!this.url) {
			this.disabled = true;
		} else {
			this.disabled = false;
		}

		// count how many filters are currently active
		var appliedFiltersCount = 0;
		var formData = this.getFormData();
		for (var i = 0; i < formData.length; i++) {
			if (formData[i].name != "sort_by") appliedFiltersCount++;
		}
		this.appliedCount = appliedFiltersCount;


	}

	serialize(obj, prefix) {
		var str = [], p;
		for (p in obj) {
			if (obj.hasOwnProperty(p)) {
				var k = prefix ? prefix + "[" + p + "]" : p, v = obj[p];
				str.push((v !== null && typeof v === "object") ? serialize(v, k) : encodeURIComponent(k) + "=" + encodeURIComponent(v));
			}
		}
		return str.join("&");
	}
	endsWith(str, suffix) {
		return str.indexOf(suffix, str.length - suffix.length) !== -1;
	}
	startsWith(str, prefix) {
		return str.substring(0, prefix.length) === prefix;
	}

	getFormData() {
		return $(this.elements.form).serializeArray();
	}

	isDefault(formData) {
		var isDefault = true;

		for (var i = 0; i < formData.length; i++) {
			var data = formData[i];

			if (data.name != "sort_by") {
				isDefault = false;
				break;
			}
		}

		return isDefault;
	}

	checkCustomised() {
		this.customised = !(JSON.stringify(this.initialFormData) === JSON.stringify(this.getFormData()));
	}
	get customised() {
		return this._customised;
	}
	set customised(customised) {
		this._customised = customised;
		var isDefault = this.isDefault(this.getFormData());

		if (isDefault) {
			this.elements.clear.classList.add("hidden");
		} else {
			this.elements.clear.classList.remove("hidden");
		}

		if (customised) {
			this.elements.apply.classList.remove("disabled");
		} else {
			this.elements.apply.classList.add("disabled");
		}
	}

	get disabled() {
		return this._disabled;
	}
	set disabled(disabled) {
		this._disabled = disabled;

		if (disabled) {
			this.elements.filterButtons.classList.add("disabled");
		} else {
			this.elements.filterButtons.classList.remove("disabled");
		}
	}

	get loading() {
		return this._loading;
	}
	set loading(loading) {
		this._loading = loading;

		var filterButton = this.elements.filterButtons.querySelector(".filter.options.icon");

		if (loading) {
			this.elements.apply.classList.add('disabled', 'loading', 'icon');
			filterButton.classList.add('disabled');
		} else {
			setTimeout(function() {
				this.elements.apply.classList.remove('disabled', 'loading', 'icon');
				filterButton.classList.remove('disabled');
			}.bind(this), 0.1 * 1000);
		}
	}

	get appliedCount() {
		return this._appliedCount;
	}
	set appliedCount(appliedCount) {
		this._appliedCount = appliedCount;

		var filterButton = this.elements.filterButtons.querySelector(".filter.options.icon");
		if (appliedCount > 0) {
			filterButton.classList.add("applied");
		} else {
			filterButton.classList.remove("applied");
		}

		var filterButtonSpan = filterButton.querySelector("span");
		filterButtonSpan.innerHTML = appliedCount + " Filter" + (appliedCount != 1 ? "s" : "") + " Applied";
	}

	apply() {
		var query = {};
		var tags = [];

		var formData = this.getFormData();
		for (var i = 0; i < formData.length; i++) {
			var data = formData[i];

			if (data.name == "tag[]") {
				tags.push(data.value);
			} else {
				query[data.name] = data.value;
			}
		}

		var url = this.url;
		if (tags) url = url + (this.endsWith(url, "/") ? "" : "/") + tags.join("+");
		if (query) url = url + "?" + this.serialize(query);

		// show loading
		this.loading = true;

		// redirect with the filters
		setTimeout(function() {
			window.location.href = url;
		}.bind(this), 0.4 * 1000);
	}

	clear() {
		this.elements.form.reset();

		var inputs = this.elements.form.querySelectorAll("input, select, textarea");
		for (var i = 0; i < inputs.length; i++) {
			var input = inputs[i];

			if (input.name != "sort_by") {
				if (input.type == "radio" || input.type == "checkbox") {
					input.checked = false;
				}
			}
		}

		this.checkCustomised();
	}
}

// events
class Events {

	// initialise
	constructor(info) {

		// find the required elements
		this.element = document.querySelector(".modal#events .container");
		this.elements = {
			viewDates: document.querySelector(".container#product .colourGroup.selected .footer button.add.button"),
			calendar: this.element.querySelector(".calendar"),
			footer: this.element.querySelector(".footer"),
			selected: {
				date: this.element.querySelector(".footer .date"),
				availability: this.element.querySelector(".footer .description .availability"),
								schedule: this.element.querySelector(".footer .description .schedule"),
								expand: this.element.querySelector(".expand.button"),
			},
			options: this.element.querySelector(".footer .options > .scroll"),
			count: this.element.querySelector(".footer .count"),
			cost: this.element.querySelector(".footer .cost"),
			addToBag: this.element.querySelector(".footer .add.button")
		};

				this.defaultOpenHours = [
					{ // sunday
						open: "11:00",
						close: "17:00"
					},
					{ // monday
						open: "9:00",
						close: "17:30"
					},
					{ // tuesday
						open: "9:00",
						close: "17:30"
					},
					{ // wednesday
						open: "9:00",
						close: "17:30"
					},
					{ // thursday
						open: "9:00",
						close: "21:00"
					},
					{ // friday
						open: "9:00",
						close: "17:30"
					},
					{ // saturday
						open: "9:00",
						close: "17:00"
					}
				];

		// stores
				this.stores = {
					north_perth: {
						name: "North Perth",
						addressSearchKey: "north perth",
						hours: this.defaultOpenHours
					},
					whitford_city: {
						name: "Whitford City",
						addressSearchKey: "whitford",
						hours: this.defaultOpenHours
					},
					cannington: {
						name: "Cannington",
						addressSearchKey: "cannington",
						hours: this.defaultOpenHours
					},
					joondalup: {
						name: "Joondalup",
						addressSearchKey: "joondalup",
						hours: this.defaultOpenHours
					}
				};

				// event types (not currently used)
				this.type = {
					birthday: {
						name: "Birthday Party",
						titleSearchKey: "birthday"
					},
					clinic: {
						name: "Skate Clinic",
						titleSearchKey: ""
					},
					private: {
						name: "Private Lesson",
						titleSearchKey: "private"
					},
					skatepark: {
						name: "Skatepark Hire",
						titleSearchKey: "skatepark"
					},
					sweetfire: {
						name: "Sweetfire",
						titleSearchKey: "sweetfire"
					}
				};

				this.defaultTimeslotColour = "#ff4040"; // red
				this.timeslotColours = [
					{
						keys: ["birthday"],
						colour: "rgb(62, 146, 246)" // blue
					},
					{
						keys: ["private"],
						colour: "rgb(255, 174, 41)" // orange
					},
					{
						keys: ["girls"],
						colour: "rgb(255, 102, 183)" // pink
					},
					{
						keys: ["adult"],
						colour: "rgb(122, 122, 122)" // grey
					},
					{
						keys: ["skatepark"],
						colour: "rgb(54, 194, 19)" // green
					},
					{
						keys: ["school"],
						colour: "rgb(54, 194, 19)" // green
					},
					{
						keys: ["sweetfire"],
						colour: "rgb(144, 42, 255)" // purple
					}
				];

		// events
		this.allTimeslots = [];
		this.timeslots = [];

		// day and month names
		this.days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		this.abbreviatedDays = ['Su', 'M', 'Tu', 'W', 'Th', 'F', 'Sa'];
		this.months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
		this.abbreviatedMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

		// filters
		this.clearFilters();

		// callbacks
		this.ready = false;
		this.callbacks = {
			ready: {}
		};

		// current time and date (in AWST)
		this.now = new Date(new Date().toLocaleString("en-US", { timeZone: "Australia/Perth" }));

		// set the future date 13 weeks away (3 months)
		this.future = new Date(this.now.getTime());
		this.future.setDate(this.future.getDate() + (13 * 7));
		this.future = this.dateCeiling(this.future);

		// set the calendar start date to be the 1st of the "now" date's month
		this.start = new Date(this.now.getTime());
		this.start.setDate(1);
		this.start = this.dateFloor(this.start);

		// set the calendar end date to be the last day of the "future" date's month
		this.end = new Date(this.future.getTime());
		this.end.setMonth(this.end.getMonth() + 1);
		this.end.setDate(0);

		// create the html for the calendar
		this.renderCalendar(this.start, this.end);

		// selected
		this.reset();

		// get all the experiences to fill the calendar with
		this.getEvents(this.now, this.future);

				// make sure when the modal is closed, the expanded view is collapsed
				this.toggleModalWatcher = new ClassWatcher(this.element.parentNode, 'active', this.collapseTimeslots.bind(this), this.collapseTimeslots.bind(this));
	}

	// helpers
	range(start, end) {
		return Array(end - start + 1).fill().map((_, idx) => start + idx)
	}
	ordinalSuffixOf(i) {
		var j = i % 10, k = i % 100;
		if (j == 1 && k != 11) {
			return i + "st";
		}
		if (j == 2 && k != 12) {
			return i + "nd";
		}
		if (j == 3 && k != 13) {
			return i + "rd";
		}
		return i + "th";
	}
	pad(n, width, z) {
		z = z || '0';
		n = n + '';
		return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	}
	experiencesDateFormat(a) {
		a = this.removeLocalTimezoneOffset(a);

		var year = a.getFullYear();
		var month = a.getMonth() + 1;
		var date = a.getDate();

		var hour = a.getHours();
		var min = a.getMinutes();
		var sec = a.getSeconds();

		var time = year + "-" + this.pad(month, 2) + "-" + this.pad(date, 2) + "T" + this.pad(hour, 2) + ":" + this.pad(min, 2) + ":" + this.pad(sec, 2) + "Z";

		return time;
	}
	experiencesHumanDateFormat(a) {
				a = new Date(a.toLocaleString("en-US", { timeZone: "Australia/Perth" }));

		var year = a.getFullYear();
		var month = a.getMonth();
		var date = a.getDate();

		var hours = a.getHours();
		var minutes = a.getMinutes();

		var meridiem = "am";
		if (hours >= 12) {
			meridiem = "pm";
		}

		if (hours == 0) {
			hours = 12;
		} else if (hours > 12) {
			hours -= 12;
		}

		return this.abbreviatedMonths[a.getMonth()] + " " + date + ", " + year + " at " + hours + ":" + this.pad(minutes, 2) + meridiem + " AWST(+0800)";
	}
	isToday(date) {
		return date.getDate() == this.now.getDate() &&
		date.getMonth() == this.now.getMonth() &&
		date.getFullYear() == this.now.getFullYear();
	}
		minutesBetween(date1, date2) {
			var diff = date2 - date1;
			var minutes = Math.floor((diff/1000)/60);
			return minutes;
		}

	removeLocalTimezoneOffset(date) {
		var offset = date.getTimezoneOffset() * 60;
		var timestamp = this.dateToTimestamp(date);
		return this.timestampToDate(timestamp + offset);
	}
	addLocalTimezoneOffset(date) {
		var offset = date.getTimezoneOffset() * 60;
		var timestamp = this.dateToTimestamp(date);
		return this.timestampToDate(timestamp - offset);
	}

	dateFloor(date) {
		var d = new Date(date.getTime());
		d.setHours(0);
		d.setMinutes(0);
		d.setSeconds(0);
		d.setMilliseconds(0);
		return d;
	}
	dateCeiling(date) {
		var d = new Date(date.getTime());
		d.setHours(23);
		d.setMinutes(59);
		d.setSeconds(59);
		d.setMilliseconds(999);
		return d;
	}

	dateToTimestamp(date) {
		return date.getTime() / 1000;
	}
	timestampToDate(timestamp) {
		return new Date(timestamp * 1000);
	}

	humanDate(date) {
		// return this.days[date.getDay()] + ", " + this.ordinalSuffixOf(date.getDate()) + " of " + this.months[date.getMonth()] + " " + date.getFullYear();
		return this.days[date.getDay()] + ", " + date.getDate() + " " + this.months[date.getMonth()] + " " + date.getFullYear();
		}
	humanTime(date) {
		var hours = date.getHours();
		var minutes = date.getMinutes();

		var meridiem = "am";
		if (hours >= 12) {
			meridiem = "pm";
		}

		if (hours == 0) {
			hours = 12;
		} else if (hours > 12) {
			hours -= 12;
		}

		if (!minutes) {
			return hours + meridiem;
		} else {
			return hours + ":" + this.pad(minutes, 2) + meridiem;
		}
	}

	// methods
	reset() {
		this.selectedDate = this.now;
		this.selectedTimeslots = {};
				this.collapseTimeslots();
	}

	getStoreName(location) {
		return this.stores[this.getStoreKey(location)].name || null;
	}
	getStoreKey(location) {
		for (var storeKey in this.stores) {
			var store = this.stores[storeKey];

			if (new RegExp(store.addressSearchKey, "i").test(location)) {
				return storeKey;
			}
		}
		return null;
	}

		get store() {
			return this._store;
	}
	set store(store) {
			this._store = store;

			// this.elements.selected.location.innerHTML = this.stores[store].name;

			this.registerFilter("store", function(timeslot) {

				// timeslot.id
				// timeslot.productId
				// timeslot.name
				// timeslot.variants (shopifyVariantId, name & price)
				// timeslot.startDate
				// timeslot.endDate
				// timeslot.location
				// timeslot.totalUnits
				// timeslot.unitsLeft
				// timeslot.minLimit
				// timeslot.maxLimit
				// timeslot.tags

				if (!(new RegExp(this.stores[store].addressSearchKey, "i").test(timeslot.location))) {
					return false;
				}

			}.bind(this));
	}

	get ready() {
		return this._ready;
	}
	set ready(ready) {
		this._ready = ready;

		// call all the "ready callbacks"
		if (ready && this.callbacks.ready) {
			setTimeout(function(){
				if (this.callbacks.ready) {
					for (var name in this.callbacks.ready) {
						this.callbacks.ready[name](this.timeslots);
						delete this.callbacks.ready[name];
					}
				}
			}.bind(this), 0.01 * 1000);
		}
	}

	get loading() {
		return this._loading;
	}
	set loading(loading) {
		this._loading = loading;

		if (loading) {
			this.elements.addToBag.classList.add("loading", "icon");
		} else {
			this.elements.addToBag.classList.remove("loading", "icon");
			this.selectedTimeslots = this.selectedTimeslots;
		}
	}

	get selectedDate() {
		return this._selectedDate;
	}
	set selectedDate(date) {
		if (!(date instanceof Date)) date = this.timestampToDate(date);

		// round the date down to the nearest day
		date = this.dateFloor(date);
		this._selectedDate = date;

		// dates
		var timestamp = this.dateToTimestamp(date);
				var startDate = new Date(date.getTime());
				var endDate = this.dateCeiling(new Date(date.getTime()));

				// make sure the expanded height isn't incorrect
				var wasExpanded = this.expandTimeslots;
				if (wasExpanded) this.toggleTimeslotsView();

		// render the html
		var dayElement = this.elements.calendar.querySelector(".day[data-timestamp='" + timestamp + "']");
		if (!dayElement) return false;

		// deselect the last day
		var lastDayElement = this.elements.calendar.querySelector(".day.selected");
		if (lastDayElement) lastDayElement.classList.remove("selected");

		// select the new day
		dayElement.classList.add("selected");

		// set the selected overview in the footer
		this.elements.selected.date.innerHTML = this.humanDate(date);
		if (this.isToday(date)) {
			this.elements.selected.date.classList.add("today");
		} else {
			this.elements.selected.date.classList.remove("today");
		}

		if (dayElement.classList.contains("available")) {
			this.elements.selected.availability.innerHTML = "Time slots:";
		} else {
			this.elements.selected.availability.innerHTML = "No available time slots.";
		}

		// create a new options scroller (and animate between)
		var container = this.elements.options.parentNode;

		var oldScroller = this.elements.options;
		var newScroller = oldScroller.cloneNode();
		newScroller.classList.add("invisible");
		container.appendChild(newScroller);
		this.elements.options = newScroller;

		container.style.height = oldScroller.offsetHeight + "px";
				container.dataset.collapsedHeight = oldScroller.offsetHeight + "px";

		oldScroller.classList.add("invisible");
		setTimeout(function() {
			newScroller.classList.remove("invisible");
			container.style.height = newScroller.offsetHeight + "px";
						container.dataset.collapsedHeight = newScroller.offsetHeight + "px";
		}.bind(this), 0.01 * 1000);

		setTimeout(function() {
			if (oldScroller) container.removeChild(oldScroller);
			if (newScroller) overflowScrollFade(newScroller);
		}.bind(this), 0.3 * 1000);

		// render the options
		this.renderTimeslots(startDate, endDate);

				// make sure the expanded height isn't incorrect
				if (wasExpanded) {
					setTimeout(function() {
						this.toggleTimeslotsView();
					}.bind(this), 10);
				}
	}

	get timeslots() {
		return this._timeslots;
	}
	set timeslots(timeslots) {
		this._timeslots = timeslots;

		// make sure all required parameters have been set
		if (typeof this.selectedDate === 'undefined') return;

		// reset whatever they've selected
		this.selectedTimeslots = {};

		// remove all the available classes from the days (and colours)
		var availableDays = this.elements.calendar.querySelectorAll(".day.available, .day.sold-out");
		for (var i = 0; i < availableDays.length; i++) {
			var availableDay = availableDays[i];
			availableDay.classList.remove("available");
						availableDay.classList.remove("sold-out");

						var coloursElement = availableDay.querySelector(".colours");
						coloursElement.innerHTML = "";
					}

				var minPrice = null;
				var maxPrice = null;

		// each of the time slots
		for (var i = 0; i < this.timeslots.length; i++) {
			var timeslot = this.timeslots[i];

						// figure out the min and max price for this item
						for (var j = 0; j < timeslot.variants.length; j++) {
							var variant = timeslot.variants[j];

							if (!maxPrice || variant.price > maxPrice) {
								maxPrice = variant.price;
							}
							if (!minPrice || variant.price < minPrice) {
								minPrice = variant.price;
							}
						}

			// get the day element
			var dayElement = this.elements.calendar.querySelector(".day[data-timestamp='" + this.dateToTimestamp(this.dateFloor(timeslot.startDate)) + "']");

			// mark the day on the calendar as "available" or "sold out"
						if (timeslot.unitsLeft > 0) {
							dayElement.classList.add("available");
						} else {
							dayElement.classList.add("sold-out");
						}

						// add the timeslot colour to the day
						var timeslotColour = this.getTimeslotColour(timeslot);
						var coloursElement = dayElement.querySelector(".colours");

						// create the colour if it doesn't exist yet
						var existingColourElement = coloursElement.querySelectorAll(".colour[data-colour='" + timeslotColour + "']");
						if (!existingColourElement.length) {
								var colourElement = document.createElement("span");
								coloursElement.appendChild(colourElement);
								colourElement.classList.add("colour");
								colourElement.style.backgroundColor = timeslotColour;
								colourElement.dataset.colour = timeslotColour;
						}

		}

				// set the price for the events within
				setTimeout(function() {
					if (minPrice != null && maxPrice != null) {
						var priceElement = document.querySelector(".details .footer .current.price");

						// single price
						if (minPrice == maxPrice) {
							priceElement.innerHTML = `$${minPrice.toFixed(2)}`;

						// range
						} else {
							priceElement.innerHTML = `$${minPrice} - $${maxPrice}`;
						}

					}
				}.bind(this), 1);

				// make sure the selected date updates correctly
				var selectedDate = this.selectedDate;
				this.selectedDate = this.future;
				setTimeout(function() {
					this.selectedDate = selectedDate;
				}.bind(this), 1);

	}

	get selectedTimeslots() {
		return this._selectedTimeslots;
	}
	set selectedTimeslots(selectedTimeslots) {
		this._selectedTimeslots = selectedTimeslots;
		this.updateCalendar();
		this.updateTimeslots();

		// calculate total tickets and pricing
		var count = 0;
		var cost = 0;

		for (var id in this.selectedTimeslots) {
			var selectedTimeslot = this.selectedTimeslots[id];

			// lookup the ticket price
			var timeslot = this.getTimeslot(id);
			if (!timeslot) continue;

			var variant = null;
			for (var i = 0; i < timeslot.variants.length; i++) {
				var value = timeslot.variants[i];

				if (value.shopifyVariantId == selectedTimeslot.variant) {
					variant = value;
				}
			}
			if (!variant) return false;

			count += selectedTimeslot.quantity;
			cost += variant.price * selectedTimeslot.quantity;
		}

		// write the count and cost
		this.elements.count.innerHTML = count + " Reservation" + (count == 1 ? "" : "s");
		this.elements.cost.innerHTML = "$" + cost.toFixed(2);

		// if they've selected dates - allow them to add to bag
		if (count && !this.loading) {
			this.elements.addToBag.classList.remove("disabled");
		} else {
			this.elements.addToBag.classList.add("disabled");
		}
	}

		toggleTimeslotsView() {
			this.expandTimeslots = !this.expandTimeslots;
		}
		collapseTimeslots() {
			this.expandTimeslots = false;
		}
		expandTimeslots() {
			this.expandTimeslots = true;
		}
		get expandTimeslots() {
		return this._expandTimeslots;
	}
	set expandTimeslots(expand) {
		this._expandTimeslots = expand;

		var container = this.elements.options.parentNode;
				if (expand) {
					container.style.height = container.dataset.expandedHeight;
					this.elements.footer.classList.remove("collapse");
					this.elements.footer.classList.add("expand");
				} else {
					container.style.height = container.dataset.collapsedHeight;
					this.elements.footer.classList.add("collapse");
					this.elements.footer.classList.remove("expand");
				}

				setTimeout(function(){
					overflowScrollFade(this.elements.options);
				}.bind(this), 0.4 * 1000);
	}

	// notifying
	registerReadyCallback(name, func) {
		this.callbacks.ready[name] = func;
	}

	// filtering
	filterTimeslots() {
		var timeslots = [...this.allTimeslots];

		// each of the timeslots
		var i = timeslots.length;
		while (i--) {
			var timeslot = timeslots[i];

			// check with all of the registered filters
			var remove = false;
			for (var name in this.filters) {
				if (this.filters[name](timeslot) === false) {
					remove = true;
					break;
				}
			}

			if (remove) timeslots.splice(i, 1);
		}

		this.timeslots = timeslots;

	}
	registerFilter(name, func) {
		this.filters[name] = func;
		this.selectedTimeslots = {};
		this.filterTimeslots();
		this.selectedDate = this.selectedDate;
	}
	clearFilters() {
		this.filters = {};
		this.filterTimeslots();
	}

	// get all the events between 2 dates to fill the calendar with
	getEvents(startDate, endDate) {
		this.ready = false;
		this.loading = true;
			$.ajax({
			type: "POST",
			url: "https://prod-v2-api.experiencesapp.services/rest/productsAvailability?shop=beyond-skate-city.myshopify.com",
			contentType: "application/json",
			dataType: "json",
			data: JSON.stringify({
				startsAt: this.experiencesDateFormat(startDate),
				endsAt: this.experiencesDateFormat(endDate)
			}),
			success: function(events) {
				this.loading = false;
				this.ready = true;
				// console.log(events);

				for (const event of events) {
                  
					// if it's been archived
					if (event.archivedAt) continue;

					// event.shopifyProductId
					// event.location
					// event.name
					// event.tags
					// event.minLimit
					// event.maxLimit
					// event.variants (shopifyVariantId, name & price)

					for (const product of (event?.availabilityProducts || [])) {
						for (const timeslot of (product?.availableTimeslots || [])) {

							// not linked to a shopify product
							if (!event.shopifyProductId) continue;

							// timeslot.startsAt
							// timeslot.endsAt
							// timeslot.unitsLeft
							// timeslot.totalUnits

							this.addTimeslot({
								id: this.dateToTimestamp(new Date(timeslot.startsAt)) + "." + this.dateToTimestamp(new Date(timeslot.endsAt)) + "." + event.shopifyProductId,
								productId: event.shopifyProductId,
								name: event.name,
								variants: event.variants,
								startDate: new Date(timeslot.startsAt),
								endDate: new Date(timeslot.endsAt),
								location: event.location,
								totalUnits: timeslot.totalUnits,
								unitsLeft: timeslot.unitsLeft,
								minLimit: event.minLimit,
								maxLimit: event.maxLimit,
								tags: event.tags
							});
						}
					}
				}

				// sort the time slots in order
				this.allTimeslots = this.allTimeslots.sort((a, b) => a.startDate - b.startDate);
				this.filterTimeslots();

				// show the time slots
				this.selectedDate = this.selectedDate;

			}.bind(this),
			error: function(events) {
				this.loading = false;
				this.ready = true;
				// console.log(events);

			}.bind(this),
		});

	}

	addTimeslot(timeslot) {
		if (timeslot.startDate < this.now || timeslot.startDate > this.future) return false;

		// add to timeslots array
		this.allTimeslots.push(timeslot);
	}
	getTimeslots(startDate, endDate) {
		var timeslots = [];
		for (var i = 0; i < this.timeslots.length; i++) {
			var timeslot = this.timeslots[i];

			if (timeslot.startDate > startDate && timeslot.startDate < endDate) {
				timeslots.push(timeslot);
			} else if (timeslot.startDate > endDate) {
				break;
			}
		}

		return timeslots;
	}
	getTimeslot(id) {
		var timeslot = null;

		for (var i = 0; i < this.timeslots.length; i++) {
			var slot = this.timeslots[i];

			if (slot.id == id) {
				timeslot = slot;
				break;
			}
		}

		return timeslot;
	}

	selectTimeslot(id, variantId) {
		if (this.loading) return false;

		var timeslot = this.getTimeslot(id);
		if (!timeslot) return false;

		var variant = null;
		for (var i = 0; i < timeslot.variants.length; i++) {
			var value = timeslot.variants[i];

			if (value.shopifyVariantId == variantId) {
				variant = value;
			}
		}
		if (!variant) return false;

		// keep track of which time slots they're trying to add to their bag
		if (id in this.selectedTimeslots) {
			// if (this.selectedTimeslots[id].quantity > 1) return;
			delete this.selectedTimeslots[id];
		} else {
			this.selectedTimeslots[id] = {
				variant: variantId,
				quantity: 1
			};
		}
		this.selectedTimeslots = this.selectedTimeslots;
		this.updateTimeslots();
		this.updateCalendar();
	}
	changeTimeslotVariant(id, variantId) {
		var timeslot = this.getTimeslot(id);
		if (!timeslot) return false;

		var variant = null;
		for (var i = 0; i < timeslot.variants.length; i++) {
			var value = timeslot.variants[i];

			if (value.shopifyVariantId == variantId) {
				variant = value;
			}
		}
		if (!variant) return false;

		// change the chosen variant
		if (id in this.selectedTimeslots) {
			this.selectedTimeslots[id].variant = variantId;
			this.selectedTimeslots = this.selectedTimeslots;
		} else {
			this.selectTimeslot(id, variantId);
		}
	}

	setTimeslotQuantity(id, quantity) {
		if (this.loading) return false;
		if (!(id in this.selectedTimeslots)) return false;
		quantity = parseInt(quantity);

		// keep track of which time slots they're trying to add to their bag
		if (quantity <= 0) {
			delete this.selectedTimeslots[id];
		} else {
			this.selectedTimeslots[id].quantity = quantity;
		}

		this.selectedTimeslots = this.selectedTimeslots;
		this.updateTimeslots();
		this.updateCalendar();
	}
	minusTimeslotQuantity(id) {
		if (!(id in this.selectedTimeslots)) return false;
		this.setTimeslotQuantity(id, this.selectedTimeslots[id].quantity - 1);
	}
	plusTimeslotQuantity(id) {
		if (!(id in this.selectedTimeslots)) return false;
		this.setTimeslotQuantity(id, this.selectedTimeslots[id].quantity + 1);
	}

	// html
	renderCalendar(startDate, endDate) {

		// clear any existing days
		var layout = this.elements.calendar.querySelector(".layout");
		layout = layout.cloneNode(true);

		this.elements.calendar.innerHTML = "";
		this.elements.calendar.appendChild(layout);

		// create the html for the calendar
		var d = new Date(startDate.getTime());
		var lastMonth = null;
		var weeksElement = null;
		var weekElement = null;
		while (d < endDate) {
			var day = this.days[d.getDay()];
			var date = d.getDate();
			var month = this.months[d.getMonth()];
			var year = d.getFullYear();

			// new month
			if (month != lastMonth) {
				var monthElement = document.createElement("div");
				this.elements.calendar.appendChild(monthElement);
				monthElement.classList.add("month");
				monthElement.setAttribute('data-month', month);

				var headerElement = document.createElement("h2");
				monthElement.appendChild(headerElement);
				headerElement.classList.add("header");
				headerElement.innerHTML = month + " " + year;

				weeksElement = document.createElement("div");
				monthElement.appendChild(weeksElement);
				weeksElement.classList.add("weeks");

				// end of month spacers
				if (weekElement) {
					for (var i = d.getDay(); i > 0 && i <= 6; i++) {
						var spacer = document.createElement("a");
						spacer.classList.add("spacer");
						weekElement.appendChild(spacer);
					}
				}

				weekElement = document.createElement("div");
				weeksElement.appendChild(weekElement);
				weekElement.classList.add("week");

				// start of month spacers
				for (var i = 0; i < d.getDay(); i++) {
					var spacer = document.createElement("a");
					spacer.classList.add("spacer");
					weekElement.appendChild(spacer);
				}
			}

			// new week (starts on Sunday / 0)
			if (d.getDay() == 0 && month == lastMonth) {
				weekElement = document.createElement("div");
				weeksElement.appendChild(weekElement);
				weekElement.classList.add("week");
			}

			// new day
			var dayElement = document.createElement("a");
			weekElement.appendChild(dayElement);
			dayElement.classList.add("day");
			dayElement.setAttribute('data-timestamp', this.dateToTimestamp(d));
			dayElement.setAttribute('onclick', "events.selectedDate = this.dataset.timestamp;");

						var dateElement = document.createElement("span");
						dayElement.appendChild(dateElement);
						dateElement.classList.add("date");
						dateElement.innerHTML = date;

						var coloursElement = document.createElement("div");
						dayElement.appendChild(coloursElement);
						coloursElement.classList.add("colours");

			if (this.isToday(d)) {
				dayElement.classList.add("today");
			}

			// next iteration
			lastMonth = month;
			d.setDate(d.getDate() + 1);
		}

		// end of the last month's spacers
		for (var i = d.getDay(); i > 0 && i <= 6; i++) {
			var spacer = document.createElement("a");
			spacer.classList.add("spacer");
			weekElement.appendChild(spacer);
		}
	}
	updateCalendar() {

		// clear all "selectedTimeslot" classes from days
		var selectedTimeslotDays = this.elements.calendar.querySelectorAll(".day.selectedTimeslot");
		for (var i = 0; i < selectedTimeslotDays.length; i++) {
			var selectedTimeslotDay = selectedTimeslotDays[i];
			selectedTimeslotDay.classList.remove("selectedTimeslot");
		}

		// add all the "selectedTimeslot" classes
		for (var id in this.selectedTimeslots) {
			var selectedTimeslot = this.selectedTimeslots[id];

			var timeslot = this.getTimeslot(id);
			if (!timeslot) return false;

			var dayElement = this.elements.calendar.querySelector(".day[data-timestamp='" + this.dateToTimestamp(this.dateFloor(timeslot.startDate)) + "']");
			dayElement.classList.add("selectedTimeslot");
		}
	}
	renderTimeslots(startDate, endDate) {

				// get the store's open hours for the day
				var storeHours = this.defaultOpenHours[startDate.getDay()];
				if (this.store) {
					storeHours = this.stores[this.store].hours[startDate.getDay()];
				}

				var openTime = new Date(startDate.getTime());
				openTime.setHours(storeHours.open.split(":")[0]);
				openTime.setMinutes(storeHours.open.split(":")[1]);

				var closeTime = new Date(startDate.getTime());
				closeTime.setHours(storeHours.close.split(":")[0]);
				closeTime.setMinutes(storeHours.close.split(":")[1]);

				var scheduleStartTime = new Date(openTime);
				var scheduleEndTime = new Date(closeTime);

				// get the start of first event, and end of last event times
				var timeslots = this.getTimeslots(startDate, endDate);
				if (timeslots.length) {
			var timeslotsStartTime = new Date(timeslots[0].startDate);
					var timeslotsEndTime = new Date(timeslots[timeslots.length - 1].endDate);

					if (timeslotsStartTime < scheduleStartTime) {
						scheduleStartTime = timeslotsStartTime;
					}
					if (timeslotsEndTime > scheduleEndTime) {
						scheduleEndTime = timeslotsEndTime;
					}
				}

		// clear out the current time slots
		this.elements.options.innerHTML = "";

				if (timeslots.length) {
					this.elements.options.removeAttribute('data-empty');
				} else {
					this.elements.options.dataset.empty = true;
				}

				// create the open hours "schedule"
				var scheduleMultiplier = 1;
				var schedulePadding = 20;

				scheduleStartTime.setMinutes(scheduleStartTime.getMinutes() - schedulePadding);
				scheduleEndTime.setMinutes(scheduleEndTime.getMinutes() + schedulePadding);

				// set the height of the container
				this.elements.options.parentNode.dataset.expandedHeight = (this.minutesBetween(scheduleStartTime, scheduleEndTime) * scheduleMultiplier) + "px";

				var scheduleElement = document.createElement("div");
				this.elements.options.appendChild(scheduleElement);
				scheduleElement.classList.add("schedule");

				// create the blocks
				var scheduleTime = new Date(scheduleStartTime.getTime());
				while (scheduleTime < scheduleEndTime) {
					var blockTimeStart = new Date(scheduleTime.getTime());

					// set the next block an hour later
					var invisible = false;
					if (scheduleTime.getMinutes() != 0) {
						invisible = true;
						scheduleTime.setMinutes(0);
					}
					scheduleTime.setHours(scheduleTime.getHours() + 1);

					// if it's the last block
					var blockTimeEnd = new Date(scheduleTime.getTime());
					if (scheduleTime >= scheduleEndTime) {
						blockTimeEnd = new Date(scheduleEndTime.getTime());
					}

					var blockElement = document.createElement("div");
					scheduleElement.appendChild(blockElement);
					blockElement.classList.add("block");
					blockElement.style.height = (this.minutesBetween(blockTimeStart, blockTimeEnd) * scheduleMultiplier) + "px";
					if (invisible) blockElement.style.opacity = 0;

					var labelElement = document.createElement("span");
					blockElement.appendChild(labelElement);
					labelElement.classList.add("label");
					labelElement.innerHTML = this.humanTime(blockTimeStart);
				}

		// render the new time slots
		for (var i = 0; i < timeslots.length; i++) {
			var timeslot = timeslots[i];

			// timeslot.id
			// timeslot.productId
			// timeslot.name
			// timeslot.variants (shopifyVariantId, name & price)
			// timeslot.startDate
			// timeslot.endDate
			// timeslot.location
			// timeslot.totalUnits
			// timeslot.unitsLeft
			// timeslot.minLimit
			// timeslot.maxLimit
			// timeslot.tags

			var optionElement = document.createElement("div");
			this.elements.options.appendChild(optionElement);
			optionElement.classList.add("option");
			optionElement.setAttribute("data-id", timeslot.id);
			optionElement.setAttribute("onclick", "events.selectTimeslot(this.dataset.id, this.querySelector('.variants select').value);");

			// if it's been selected (to prevent the annoying quantity animation every day change)
			if (timeslot.id in this.selectedTimeslots) {
				optionElement.classList.add("selected");
			}

			// if it's sold out
						var optionSoldOut = false;
			if (timeslot.unitsLeft <= 0) {
				optionElement.classList.add("unavailable", "disabled");
				if (timeslot.totalUnits > 0) {
					optionElement.classList.add("sold-out");
										optionSoldOut = true;
				}
			}

						// height
						optionElement.style.minHeight = (this.minutesBetween(timeslot.startDate, timeslot.endDate) * scheduleMultiplier) + "px";

						// margin top
						if (i == 0) {
							optionElement.style.marginTop = (this.minutesBetween(scheduleStartTime, timeslot.startDate) * scheduleMultiplier) + "px";
						}
						// margin bottom
						if (i + 1 == timeslots.length) {
							optionElement.style.marginBottom = (this.minutesBetween(timeslot.endDate, scheduleEndTime) * scheduleMultiplier) + "px";
						} else {
							optionElement.style.marginBottom = (this.minutesBetween(timeslot.endDate, timeslots[i + 1].startDate) * scheduleMultiplier) + "px";
						}

						// add the colour
						var timeslotColour = this.getTimeslotColour(timeslot);
						optionElement.style.backgroundColor = timeslotColour;
						optionElement.style.color = timeslotColour;
						optionElement.style.fill = timeslotColour;
						optionElement.style.borderColor = timeslotColour;

			var quantityElement = document.createElement("div");
			optionElement.appendChild(quantityElement);
			quantityElement.classList.add("quantity", "chevron", "icon");

			var quantitySelectElement = document.createElement("select");
			quantityElement.appendChild(quantitySelectElement);
			quantitySelectElement.classList.add("resizable");
			quantitySelectElement.setAttribute("onclick", "event.stopPropagation();");
			quantitySelectElement.setAttribute("onchange", "events.setTimeslotQuantity(this.closest('.option[data-id]').dataset.id, this.value);");

			var min = timeslot.minLimit ? timeslot.minLimit : 1;
			var max = timeslot.maxLimit ? (timeslot.maxLimit < timeslot.unitsLeft ? timeslot.maxLimit : timeslot.unitsLeft) : timeslot.unitsLeft;
			var quantityOptions = [0];
			if (max >= min) {
				quantityOptions = this.range(min, max);
				quantityOptions.unshift(0);
			}

			for (var j = 0; j < quantityOptions.length; j++) {
				var quantityOption = quantityOptions[j];

				var subOptionElement = document.createElement("option");
				quantitySelectElement.appendChild(subOptionElement);
				subOptionElement.value = quantityOption;
				subOptionElement.innerHTML = quantityOption;
			}

			var textElement = document.createElement("div");
			optionElement.appendChild(textElement);
			textElement.classList.add("text");

			var nameElement = document.createElement("span");
			textElement.appendChild(nameElement);
			nameElement.classList.add("name");
			nameElement.innerHTML = timeslot.name;

			var timeElement = document.createElement("span");
			textElement.appendChild(timeElement);
			timeElement.classList.add("time");
			timeElement.innerHTML = this.humanTime(timeslot.startDate) + " - " + this.humanTime(timeslot.endDate);

			var variantsElement = document.createElement("div");
			optionElement.appendChild(variantsElement);
			variantsElement.classList.add("variants", "chevron", "icon");

			if (optionSoldOut || timeslot.variants.length <= 1) {
				variantsElement.dataset.default = "true";
			}

			var variantSelectElement = document.createElement("select");
			variantsElement.appendChild(variantSelectElement);
			variantSelectElement.classList.add("resizable");
			variantSelectElement.setAttribute("onclick", "event.stopPropagation();");
			variantSelectElement.setAttribute("onchange", "resizableSelect(this); events.changeTimeslotVariant(this.closest('.option[data-id]').dataset.id, this.value);");

			for (var j = 0; j < timeslot.variants.length; j++) {
				var variant = timeslot.variants[j];

				var subOptionElement = document.createElement("option");
				variantSelectElement.appendChild(subOptionElement);
				subOptionElement.value = variant.shopifyVariantId;

								if (!optionSoldOut) {
									subOptionElement.innerHTML = (timeslot.variants.length <= 1 ? "$" + variant.price : variant.name + " ($" + variant.price + ")");
								} else {
									subOptionElement.innerHTML = "Sold Out";
									break;
								}
			}

						// add the chevron icon
						if (!optionSoldOut && timeslot.variants.length > 1) {
							var svgContainer = document.createElement("div");
							svgContainer.innerHTML = '<svg class="chevron" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 12.3 7.2" xml:space="preserve"><polygon points="6.2,7.2 0.3,1.2 1.5,0 6.2,4.8 10.9,0 12.1,1.2"/></svg>';
							variantsElement.appendChild(svgContainer.firstElementChild);
						}

			resizableSelect(variantSelectElement);
		}

		// show them what they've selected
		this.updateTimeslots();

		// show overflow fade
		overflowScrollFade(this.elements.options);
	}
	updateTimeslots() {
		var optionElements = this.elements.options.querySelectorAll(".option");
		for (var i = 0; i < optionElements.length; i++) {
			var optionElement = optionElements[i];
			var timeslot = this.getTimeslot(optionElement.dataset.id);
			if (!timeslot) continue;

			// timeslot.id
			// timeslot.productId
			// timeslot.name
			// timeslot.variants (shopifyVariantId, name & price)
			// timeslot.startDate
			// timeslot.endDate
			// timeslot.location
			// timeslot.totalUnits
			// timeslot.unitsLeft
			// timeslot.minLimit
			// timeslot.maxLimit
			// timeslot.tags

			// count
			var quantitySelectElement = optionElement.querySelector(".quantity select");

			// if it's been selected
			if (timeslot.id in this.selectedTimeslots) {
				optionElement.classList.add("selected");
				quantitySelectElement.value = this.selectedTimeslots[timeslot.id].quantity;
				resizableSelect(quantitySelectElement);
			} else {
				optionElement.classList.remove("selected");
				quantitySelectElement.value = 0;
				resizableSelect(quantitySelectElement);
			}
		}
	}

		getTimeslotColour(timeslot) {
			var colour = this.defaultTimeslotColour;
			var colours = this.timeslotColours;

			// check each of the colours rules
			for (var j = 0; j < colours.length; j++) {

				// if all the keys match - assign that colour
				var match = !!colours[j].keys.length;
				for (var k = 0; k < colours[j].keys.length; k++) {
					if (!(new RegExp(colours[j].keys[k], "i").test(timeslot.name))) {
						match = false;
						break;
					}
				}

				if (match) {
					colour = colours[j].colour;
					break;
				}
			}

			return colour;
		}

	// final step
	addToBag() {
		if (Object.keys(this.selectedTimeslots).length <= 0) return false;

		this.loading = true;
		this.elements.addToBag.classList.add("disabled");

		var data = [];
		for (var id in this.selectedTimeslots) {
			var selectedTimeslot = this.selectedTimeslots[id];

			// lookup the ticket price
			var timeslot = this.getTimeslot(id);
			if (!timeslot) continue;

			data.push({
				id: selectedTimeslot.variant,
				quantity: selectedTimeslot.quantity,
				properties: {
					Store: this.getStoreName(timeslot.location),
					When: this.experiencesHumanDateFormat(timeslot.startDate) + " to " + this.experiencesHumanDateFormat(timeslot.endDate),
                  	_Timeslot: Math.round(timeslot.startDate.getTime() / 1000)
				}
			});
		}
		var success = function(response) {
			this.loading = false;
			this.reset();

		}.bind(this);
		var error = function(response) {
			this.loading = false;
		}.bind(this);

		bag.addItem(data, success, error);
	}

}



/* NONSENSE */

// automatic selector widths
function initResizableSelects() {
	var selects = document.querySelectorAll("select[onchange*=resizableSelect]");
	for (var i = 0; i < selects.length; i++) {
		var select = selects[i];
		resizableSelect(select);
	}
}
function resizableSelect(select) {

	// create a hidden select element to calculate the new width
	var tmpSelect = document.createElement("select");
	tmpSelect.class = select.class;
	tmpSelect.style.display = "initial";

	var tmpOption = document.createElement("option");
	tmpOption.innerHTML = select.options[select.selectedIndex].textContent;
	tmpSelect.appendChild(tmpOption);

	select.parentNode.appendChild(tmpSelect);

	// set the new width
	if (tmpSelect.clientWidth > 0) {
		select.style.width = tmpSelect.clientWidth + "px";
	}

	// clean up
	tmpSelect.parentNode.removeChild(tmpSelect);
}



/* ONLOAD */

document.addEventListener("DOMContentLoaded", function(event) {

	// rotate colours on grouped products every x seconds
	const rotateColoursInterval = setInterval(function() {
		var colouredProducts = document.querySelectorAll(".grid.product.group");
		var visibleColouredProducts = [];

		// we've got some coloured items on the page
		if (colouredProducts.length > 0) {

			// check if any these products are currently visible
			for (var i = 0; i < colouredProducts.length; i++) {
				var colouredProduct = colouredProducts[i];

				// is visible on screen and not being hovered
				if (isElementVisible(colouredProduct.querySelector(".images")) && !isElementHovered(colouredProduct)) {
					visibleColouredProducts.push(colouredProduct);
				}
			}

			// randomly pick one of the visible products and
			if (visibleColouredProducts.length > 0) {
				var randomProduct = visibleColouredProducts[Math.floor(Math.random() * visibleColouredProducts.length)];
				var colours = randomProduct.querySelectorAll(".colours > .colour");

				// figure out which colour is currently selected
				var selectedColourIndex = 0;
				for (var i = 0; i < colours.length; i++) {
					var colour = colours[i];

					if (colour.classList.contains("selected")) {
						selectedColourIndex = i;
						break;
					}
				}

				// figure out which colour comes next
				var colourIndex = (selectedColourIndex == colours.length - 1) ? 0 : selectedColourIndex + 1;
				var colour = colours[colourIndex];

				// select the new colour
				gridProductColour(randomProduct, colour.getAttribute('data-id'), colour.getAttribute('data-name'));
			}

			// no products on this page
		} else if (document.querySelectorAll(".grid.product").length == 0) {
			clearInterval(rotateColoursInterval);
		}

		// isElementVisible(el)
	}, 7500);

	// check if redirected from the cart
	if (getURLParameter("bag") == "true") {
		modal("bag");
		window.history.replaceState({}, document.title, removeURLParameter("bag"));
	}

});
